// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --secondary-color: #0d314d;
  --primary-color: #0d9b84;
  --alert-color: #f44336;
  --devider-color: #202042;
  --accent-color: #051d30;
}

html {
  font-size: 16px;
  scroll-behavior: smooth;
}
html[lang=en] {
  font-family: "Roboto", sans-serif, sans-serif !important;
  direction: ltr !important;
}
html[lang=ar] {
  font-family: "Tajawal", sans-serif, sans-serif !important;
  direction: rtl !important;
}

/* Styles for large screens */
@media (min-width: 1200px) {
  html {
    font-size: 12px !important;
  }
}
/* Styles for medium screens */
@media (max-width: 1199px) {
  html {
    font-size: 11.5px !important;
  }
}
/* Styles for small screens */
@media (max-width: 576px) {
  html {
    font-size: 13.5px !important;
  }
}
/* Styles for medium screens */
@media (min-width: 577px) and (max-width: 768px) {
  html {
    font-size: 13px !important;
  }
}
/* ======== Angular Material M3 Theme ======== */
html {
  --mat-app-background-color: #f7faf9;
  --mat-app-text-color: #191c1c;
  --mat-app-elevation-shadow-level-0: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-1: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-2: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-3: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-4: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-5: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-6: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-7: 0px 4px 5px -2px rgba(0, 0, 0, 0.2), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-8: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-9: 0px 5px 6px -3px rgba(0, 0, 0, 0.2), 0px 9px 12px 1px rgba(0, 0, 0, 0.14), 0px 3px 16px 2px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-10: 0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-11: 0px 6px 7px -4px rgba(0, 0, 0, 0.2), 0px 11px 15px 1px rgba(0, 0, 0, 0.14), 0px 4px 20px 3px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-12: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-13: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 13px 19px 2px rgba(0, 0, 0, 0.14), 0px 5px 24px 4px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-14: 0px 7px 9px -4px rgba(0, 0, 0, 0.2), 0px 14px 21px 2px rgba(0, 0, 0, 0.14), 0px 5px 26px 4px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-15: 0px 8px 9px -5px rgba(0, 0, 0, 0.2), 0px 15px 22px 2px rgba(0, 0, 0, 0.14), 0px 6px 28px 5px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-16: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-17: 0px 8px 11px -5px rgba(0, 0, 0, 0.2), 0px 17px 26px 2px rgba(0, 0, 0, 0.14), 0px 6px 32px 5px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-18: 0px 9px 11px -5px rgba(0, 0, 0, 0.2), 0px 18px 28px 2px rgba(0, 0, 0, 0.14), 0px 7px 34px 6px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-19: 0px 9px 12px -6px rgba(0, 0, 0, 0.2), 0px 19px 29px 2px rgba(0, 0, 0, 0.14), 0px 7px 36px 6px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-20: 0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 20px 31px 3px rgba(0, 0, 0, 0.14), 0px 8px 38px 7px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-21: 0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 21px 33px 3px rgba(0, 0, 0, 0.14), 0px 8px 40px 7px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-22: 0px 10px 14px -6px rgba(0, 0, 0, 0.2), 0px 22px 35px 3px rgba(0, 0, 0, 0.14), 0px 8px 42px 7px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-23: 0px 11px 14px -7px rgba(0, 0, 0, 0.2), 0px 23px 36px 3px rgba(0, 0, 0, 0.14), 0px 9px 44px 8px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-24: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}
html {
  --mat-ripple-color: rgba(25, 28, 28, 0.1);
}
html {
  --mat-option-selected-state-label-text-color: #324b4b;
  --mat-option-label-text-color: #191c1c;
  --mat-option-hover-state-layer-color: rgba(25, 28, 28, 0.08);
  --mat-option-focus-state-layer-color: rgba(25, 28, 28, 0.12);
  --mat-option-selected-state-layer-color: #cce8e7;
  --mat-option-label-text-font: Tajawal;
  --mat-option-label-text-line-height: 1.25rem;
  --mat-option-label-text-size: 1rem;
  --mat-option-label-text-tracking: 0.006rem;
  --mat-option-label-text-weight: 400;
}
html {
  --mat-optgroup-label-text-color: #3f4948;
  --mat-optgroup-label-text-font: Tajawal;
  --mat-optgroup-label-text-line-height: 1.25rem;
  --mat-optgroup-label-text-size: 0.875rem;
  --mat-optgroup-label-text-tracking: 0.006rem;
  --mat-optgroup-label-text-weight: 500;
}
html {
  --mat-full-pseudo-checkbox-selected-icon-color: #006a6a;
  --mat-full-pseudo-checkbox-selected-checkmark-color: #ffffff;
  --mat-full-pseudo-checkbox-unselected-icon-color: #3f4948;
  --mat-full-pseudo-checkbox-disabled-selected-checkmark-color: #f7faf9;
  --mat-full-pseudo-checkbox-disabled-unselected-icon-color: rgba(25, 28, 28, 0.38);
  --mat-full-pseudo-checkbox-disabled-selected-icon-color: rgba(25, 28, 28, 0.38);
}
html {
  --mat-minimal-pseudo-checkbox-selected-checkmark-color: #006a6a;
  --mat-minimal-pseudo-checkbox-disabled-selected-checkmark-color: rgba(25, 28, 28, 0.38);
}
html {
  --mdc-elevated-card-container-color: #f1f4f3;
  --mdc-elevated-card-container-elevation: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mdc-elevated-card-container-shape: 12px;
}
html {
  --mdc-outlined-card-container-color: #f7faf9;
  --mdc-outlined-card-outline-color: #bec9c8;
  --mdc-outlined-card-container-elevation: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mdc-outlined-card-container-shape: 12px;
  --mdc-outlined-card-outline-width: 1px;
}
html {
  --mat-card-subtitle-text-color: #191c1c;
  --mat-card-title-text-font: Tajawal;
  --mat-card-title-text-line-height: 1.75rem;
  --mat-card-title-text-size: 1.375rem;
  --mat-card-title-text-tracking: 0;
  --mat-card-title-text-weight: 400;
  --mat-card-subtitle-text-font: Tajawal;
  --mat-card-subtitle-text-line-height: 1.5rem;
  --mat-card-subtitle-text-size: 1rem;
  --mat-card-subtitle-text-tracking: 0.009rem;
  --mat-card-subtitle-text-weight: 500;
}
html {
  --mdc-linear-progress-active-indicator-color: #006a6a;
  --mdc-linear-progress-track-color: #dae5e4;
  --mdc-linear-progress-active-indicator-height: 4px;
  --mdc-linear-progress-track-height: 4px;
  --mdc-linear-progress-track-shape: 0;
}
html {
  --mdc-plain-tooltip-container-color: #2d3131;
  --mdc-plain-tooltip-supporting-text-color: #eff1f0;
  --mdc-plain-tooltip-supporting-text-line-height: 1rem;
  --mdc-plain-tooltip-supporting-text-font: Tajawal;
  --mdc-plain-tooltip-supporting-text-size: 0.75rem;
  --mdc-plain-tooltip-supporting-text-weight: 400;
  --mdc-plain-tooltip-supporting-text-tracking: 0.025rem;
  --mdc-plain-tooltip-container-shape: 4px;
}
html {
  --mdc-filled-text-field-caret-color: #006a6a;
  --mdc-filled-text-field-focus-active-indicator-color: #006a6a;
  --mdc-filled-text-field-focus-label-text-color: #006a6a;
  --mdc-filled-text-field-container-color: #dae5e4;
  --mdc-filled-text-field-disabled-container-color: rgba(25, 28, 28, 0.04);
  --mdc-filled-text-field-label-text-color: #3f4948;
  --mdc-filled-text-field-hover-label-text-color: #3f4948;
  --mdc-filled-text-field-disabled-label-text-color: rgba(25, 28, 28, 0.38);
  --mdc-filled-text-field-input-text-color: #191c1c;
  --mdc-filled-text-field-disabled-input-text-color: rgba(25, 28, 28, 0.38);
  --mdc-filled-text-field-input-text-placeholder-color: #3f4948;
  --mdc-filled-text-field-error-hover-label-text-color: #93000a;
  --mdc-filled-text-field-error-focus-label-text-color: #ba1a1a;
  --mdc-filled-text-field-error-label-text-color: #ba1a1a;
  --mdc-filled-text-field-active-indicator-color: #3f4948;
  --mdc-filled-text-field-disabled-active-indicator-color: rgba(25, 28, 28, 0.38);
  --mdc-filled-text-field-hover-active-indicator-color: #191c1c;
  --mdc-filled-text-field-error-active-indicator-color: #ba1a1a;
  --mdc-filled-text-field-error-focus-active-indicator-color: #ba1a1a;
  --mdc-filled-text-field-error-hover-active-indicator-color: #93000a;
  --mdc-filled-text-field-label-text-font: Tajawal;
  --mdc-filled-text-field-label-text-size: 1rem;
  --mdc-filled-text-field-label-text-tracking: 0.031rem;
  --mdc-filled-text-field-label-text-weight: 400;
  --mdc-filled-text-field-active-indicator-height: 1px;
  --mdc-filled-text-field-focus-active-indicator-height: 2px;
  --mdc-filled-text-field-container-shape: 4px;
}
html {
  --mdc-outlined-text-field-caret-color: #006a6a;
  --mdc-outlined-text-field-focus-outline-color: #006a6a;
  --mdc-outlined-text-field-focus-label-text-color: #006a6a;
  --mdc-outlined-text-field-label-text-color: #3f4948;
  --mdc-outlined-text-field-hover-label-text-color: #191c1c;
  --mdc-outlined-text-field-disabled-label-text-color: rgba(25, 28, 28, 0.38);
  --mdc-outlined-text-field-input-text-color: #191c1c;
  --mdc-outlined-text-field-disabled-input-text-color: rgba(25, 28, 28, 0.38);
  --mdc-outlined-text-field-input-text-placeholder-color: #3f4948;
  --mdc-outlined-text-field-error-focus-label-text-color: #ba1a1a;
  --mdc-outlined-text-field-error-label-text-color: #ba1a1a;
  --mdc-outlined-text-field-error-hover-label-text-color: #93000a;
  --mdc-outlined-text-field-outline-color: #6f7979;
  --mdc-outlined-text-field-disabled-outline-color: rgba(25, 28, 28, 0.12);
  --mdc-outlined-text-field-hover-outline-color: #191c1c;
  --mdc-outlined-text-field-error-focus-outline-color: #ba1a1a;
  --mdc-outlined-text-field-error-hover-outline-color: #93000a;
  --mdc-outlined-text-field-error-outline-color: #ba1a1a;
  --mdc-outlined-text-field-label-text-font: Tajawal;
  --mdc-outlined-text-field-label-text-size: 1rem;
  --mdc-outlined-text-field-label-text-tracking: 0.031rem;
  --mdc-outlined-text-field-label-text-weight: 400;
  --mdc-outlined-text-field-outline-width: 1px;
  --mdc-outlined-text-field-focus-outline-width: 2px;
  --mdc-outlined-text-field-container-shape: 4px;
}
html {
  --mat-form-field-focus-select-arrow-color: #006a6a;
  --mat-form-field-disabled-input-text-placeholder-color: rgba(25, 28, 28, 0.38);
  --mat-form-field-state-layer-color: #191c1c;
  --mat-form-field-error-text-color: #ba1a1a;
  --mat-form-field-select-option-text-color: #191c1c;
  --mat-form-field-select-disabled-option-text-color: rgba(25, 28, 28, 0.38);
  --mat-form-field-leading-icon-color: #3f4948;
  --mat-form-field-disabled-leading-icon-color: rgba(25, 28, 28, 0.38);
  --mat-form-field-trailing-icon-color: #3f4948;
  --mat-form-field-disabled-trailing-icon-color: rgba(25, 28, 28, 0.38);
  --mat-form-field-error-focus-trailing-icon-color: #ba1a1a;
  --mat-form-field-error-hover-trailing-icon-color: #93000a;
  --mat-form-field-error-trailing-icon-color: #ba1a1a;
  --mat-form-field-enabled-select-arrow-color: #3f4948;
  --mat-form-field-disabled-select-arrow-color: rgba(25, 28, 28, 0.38);
  --mat-form-field-hover-state-layer-opacity: 0.08;
  --mat-form-field-container-text-font: Tajawal;
  --mat-form-field-container-text-line-height: 1.5rem;
  --mat-form-field-container-text-size: 1rem;
  --mat-form-field-container-text-tracking: 0.031rem;
  --mat-form-field-container-text-weight: 400;
  --mat-form-field-subscript-text-font: Tajawal;
  --mat-form-field-subscript-text-line-height: 1rem;
  --mat-form-field-subscript-text-size: 0.75rem;
  --mat-form-field-subscript-text-tracking: 0.025rem;
  --mat-form-field-subscript-text-weight: 400;
  --mat-form-field-container-height: 56px;
  --mat-form-field-filled-label-display: block;
  --mat-form-field-container-vertical-padding: 16px;
  --mat-form-field-filled-with-label-container-padding-top: 24px;
  --mat-form-field-filled-with-label-container-padding-bottom: 8px;
  --mat-form-field-focus-state-layer-opacity: 0;
}
html {
  --mat-select-panel-background-color: #ebefed;
  --mat-select-enabled-trigger-text-color: #191c1c;
  --mat-select-disabled-trigger-text-color: rgba(25, 28, 28, 0.38);
  --mat-select-placeholder-text-color: #3f4948;
  --mat-select-enabled-arrow-color: #3f4948;
  --mat-select-disabled-arrow-color: rgba(25, 28, 28, 0.38);
  --mat-select-focused-arrow-color: #006a6a;
  --mat-select-invalid-arrow-color: #ba1a1a;
  --mat-select-trigger-text-font: Tajawal;
  --mat-select-trigger-text-line-height: 1.5rem;
  --mat-select-trigger-text-size: 1rem;
  --mat-select-trigger-text-tracking: 0.031rem;
  --mat-select-trigger-text-weight: 400;
  --mat-select-arrow-transform: translateY(-8px);
  --mat-select-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
html {
  --mat-autocomplete-background-color: #ebefed;
  --mat-autocomplete-container-shape: 4px;
  --mat-autocomplete-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
html {
  --mdc-dialog-container-color: #f7faf9;
  --mdc-dialog-subhead-color: #191c1c;
  --mdc-dialog-supporting-text-color: #3f4948;
  --mdc-dialog-subhead-font: Tajawal;
  --mdc-dialog-subhead-line-height: 2rem;
  --mdc-dialog-subhead-size: 1.5rem;
  --mdc-dialog-subhead-weight: 400;
  --mdc-dialog-subhead-tracking: 0;
  --mdc-dialog-supporting-text-font: Tajawal;
  --mdc-dialog-supporting-text-line-height: 1.25rem;
  --mdc-dialog-supporting-text-size: 0.875rem;
  --mdc-dialog-supporting-text-weight: 400;
  --mdc-dialog-supporting-text-tracking: 0.016rem;
  --mdc-dialog-container-shape: 28px;
}
html {
  --mat-dialog-container-elevation-shadow: none;
  --mat-dialog-container-max-width: 560px;
  --mat-dialog-container-small-max-width: calc(100vw - 32px);
  --mat-dialog-container-min-width: 280px;
  --mat-dialog-actions-alignment: flex-end;
  --mat-dialog-actions-padding: 16px 24px;
  --mat-dialog-content-padding: 20px 24px;
  --mat-dialog-with-actions-content-padding: 20px 24px 0;
  --mat-dialog-headline-padding: 6px 24px 13px;
}
html {
  --mdc-chip-outline-color: #6f7979;
  --mdc-chip-disabled-outline-color: rgba(25, 28, 28, 0.12);
  --mdc-chip-focus-outline-color: #3f4948;
  --mdc-chip-hover-state-layer-opacity: 0.08;
  --mdc-chip-selected-hover-state-layer-opacity: 0.08;
  --mdc-chip-disabled-label-text-color: rgba(25, 28, 28, 0.38);
  --mdc-chip-elevated-selected-container-color: #cce8e7;
  --mdc-chip-flat-disabled-selected-container-color: rgba(25, 28, 28, 0.12);
  --mdc-chip-focus-state-layer-color: #3f4948;
  --mdc-chip-hover-state-layer-color: #3f4948;
  --mdc-chip-selected-hover-state-layer-color: #324b4b;
  --mdc-chip-focus-state-layer-opacity: 0.12;
  --mdc-chip-selected-focus-state-layer-color: #324b4b;
  --mdc-chip-selected-focus-state-layer-opacity: 0.12;
  --mdc-chip-label-text-color: #3f4948;
  --mdc-chip-selected-label-text-color: #324b4b;
  --mdc-chip-with-icon-icon-color: #3f4948;
  --mdc-chip-with-icon-disabled-icon-color: #191c1c;
  --mdc-chip-with-icon-selected-icon-color: #324b4b;
  --mdc-chip-with-trailing-icon-disabled-trailing-icon-color: #191c1c;
  --mdc-chip-with-trailing-icon-trailing-icon-color: #3f4948;
  --mdc-chip-label-text-font: Tajawal;
  --mdc-chip-label-text-line-height: 1.25rem;
  --mdc-chip-label-text-size: 0.875rem;
  --mdc-chip-label-text-tracking: 0.006rem;
  --mdc-chip-label-text-weight: 500;
  --mdc-chip-container-height: 32px;
  --mdc-chip-container-shape-radius: 8px;
  --mdc-chip-with-avatar-avatar-shape-radius: 24px;
  --mdc-chip-with-avatar-avatar-size: 24px;
  --mdc-chip-with-icon-icon-size: 18px;
  --mdc-chip-outline-width: 1px;
  --mdc-chip-with-avatar-disabled-avatar-opacity: 0.38;
  --mdc-chip-flat-selected-outline-width: 0;
  --mdc-chip-with-trailing-icon-disabled-trailing-icon-opacity: 0.38;
  --mdc-chip-with-icon-disabled-icon-opacity: 0.38;
  --mdc-chip-elevated-container-color: transparent;
}
html {
  --mat-chip-trailing-action-state-layer-color: #3f4948;
  --mat-chip-selected-trailing-action-state-layer-color: #324b4b;
  --mat-chip-trailing-action-hover-state-layer-opacity: 0.08;
  --mat-chip-trailing-action-focus-state-layer-opacity: 0.12;
  --mat-chip-selected-disabled-trailing-icon-color: #191c1c;
  --mat-chip-selected-trailing-icon-color: #324b4b;
  --mat-chip-disabled-container-opacity: 1;
  --mat-chip-trailing-action-opacity: 1;
  --mat-chip-trailing-action-focus-opacity: 1;
}
html {
  --mdc-switch-selected-focus-state-layer-opacity: 0.12;
  --mdc-switch-selected-hover-state-layer-opacity: 0.08;
  --mdc-switch-selected-pressed-state-layer-opacity: 0.12;
  --mdc-switch-unselected-focus-state-layer-opacity: 0.12;
  --mdc-switch-unselected-hover-state-layer-opacity: 0.08;
  --mdc-switch-unselected-pressed-state-layer-opacity: 0.12;
  --mdc-switch-selected-focus-state-layer-color: #006a6a;
  --mdc-switch-selected-handle-color: #ffffff;
  --mdc-switch-selected-hover-state-layer-color: #006a6a;
  --mdc-switch-selected-pressed-state-layer-color: #006a6a;
  --mdc-switch-selected-focus-handle-color: #00fbfb;
  --mdc-switch-selected-hover-handle-color: #00fbfb;
  --mdc-switch-selected-pressed-handle-color: #00fbfb;
  --mdc-switch-selected-focus-track-color: #006a6a;
  --mdc-switch-selected-hover-track-color: #006a6a;
  --mdc-switch-selected-pressed-track-color: #006a6a;
  --mdc-switch-selected-track-color: #006a6a;
  --mdc-switch-disabled-selected-handle-color: #f7faf9;
  --mdc-switch-disabled-selected-icon-color: #191c1c;
  --mdc-switch-disabled-selected-track-color: #191c1c;
  --mdc-switch-disabled-unselected-handle-color: #191c1c;
  --mdc-switch-disabled-unselected-icon-color: #dae5e4;
  --mdc-switch-disabled-unselected-track-color: #dae5e4;
  --mdc-switch-selected-icon-color: #004f4f;
  --mdc-switch-unselected-focus-handle-color: #3f4948;
  --mdc-switch-unselected-focus-state-layer-color: #191c1c;
  --mdc-switch-unselected-focus-track-color: #dae5e4;
  --mdc-switch-unselected-handle-color: #6f7979;
  --mdc-switch-unselected-hover-handle-color: #3f4948;
  --mdc-switch-unselected-hover-state-layer-color: #191c1c;
  --mdc-switch-unselected-hover-track-color: #dae5e4;
  --mdc-switch-unselected-icon-color: #dae5e4;
  --mdc-switch-unselected-pressed-handle-color: #3f4948;
  --mdc-switch-unselected-pressed-state-layer-color: #191c1c;
  --mdc-switch-unselected-pressed-track-color: #dae5e4;
  --mdc-switch-unselected-track-color: #dae5e4;
  --mdc-switch-disabled-selected-icon-opacity: 0.38;
  --mdc-switch-disabled-track-opacity: 0.12;
  --mdc-switch-disabled-unselected-icon-opacity: 0.38;
  --mdc-switch-handle-shape: 9999px;
  --mdc-switch-selected-icon-size: 16px;
  --mdc-switch-track-height: 32px;
  --mdc-switch-track-shape: 9999px;
  --mdc-switch-track-width: 52px;
  --mdc-switch-unselected-icon-size: 16px;
  --mdc-switch-state-layer-size: 40px;
}
html {
  --mat-switch-track-outline-color: #6f7979;
  --mat-switch-disabled-unselected-track-outline-color: #191c1c;
  --mat-switch-label-text-color: #191c1c;
  --mat-switch-label-text-font: Tajawal;
  --mat-switch-label-text-line-height: 1.25rem;
  --mat-switch-label-text-size: 0.875rem;
  --mat-switch-label-text-tracking: 0.016rem;
  --mat-switch-label-text-weight: 400;
  --mat-switch-disabled-selected-handle-opacity: 1;
  --mat-switch-disabled-unselected-handle-opacity: 0.38;
  --mat-switch-unselected-handle-size: 16px;
  --mat-switch-selected-handle-size: 24px;
  --mat-switch-pressed-handle-size: 28px;
  --mat-switch-with-icon-handle-size: 24px;
  --mat-switch-selected-handle-horizontal-margin: 0 24px;
  --mat-switch-selected-with-icon-handle-horizontal-margin: 0 24px;
  --mat-switch-selected-pressed-handle-horizontal-margin: 0 22px;
  --mat-switch-unselected-handle-horizontal-margin: 0 8px;
  --mat-switch-unselected-with-icon-handle-horizontal-margin: 0 4px;
  --mat-switch-unselected-pressed-handle-horizontal-margin: 0 2px;
  --mat-switch-visible-track-opacity: 1;
  --mat-switch-hidden-track-opacity: 0;
  --mat-switch-visible-track-transition: opacity 75ms;
  --mat-switch-hidden-track-transition: opacity 75ms;
  --mat-switch-track-outline-width: 2px;
  --mat-switch-selected-track-outline-width: 2px;
  --mat-switch-selected-track-outline-color: transparent;
  --mat-switch-disabled-unselected-track-outline-width: 2px;
}
html {
  --mdc-radio-disabled-selected-icon-color: #191c1c;
  --mdc-radio-disabled-unselected-icon-color: #191c1c;
  --mdc-radio-unselected-hover-icon-color: #191c1c;
  --mdc-radio-unselected-focus-icon-color: #191c1c;
  --mdc-radio-unselected-icon-color: #3f4948;
  --mdc-radio-unselected-pressed-icon-color: #191c1c;
  --mdc-radio-selected-focus-icon-color: #006a6a;
  --mdc-radio-selected-hover-icon-color: #006a6a;
  --mdc-radio-selected-icon-color: #006a6a;
  --mdc-radio-selected-pressed-icon-color: #006a6a;
  --mdc-radio-state-layer-size: 40px;
  --mdc-radio-disabled-selected-icon-opacity: 0.38;
  --mdc-radio-disabled-unselected-icon-opacity: 0.38;
}
html {
  --mat-radio-ripple-color: #191c1c;
  --mat-radio-checked-ripple-color: #006a6a;
  --mat-radio-disabled-label-color: rgba(25, 28, 28, 0.38);
  --mat-radio-label-text-color: #191c1c;
  --mat-radio-label-text-font: Tajawal;
  --mat-radio-label-text-line-height: 1.25rem;
  --mat-radio-label-text-size: 0.875rem;
  --mat-radio-label-text-tracking: 0.016rem;
  --mat-radio-label-text-weight: 400;
  --mat-radio-touch-target-display: block;
}
html {
  --mdc-slider-handle-elevation: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mdc-slider-handle-color: #006a6a;
  --mdc-slider-focus-handle-color: #006a6a;
  --mdc-slider-hover-handle-color: #006a6a;
  --mdc-slider-active-track-color: #006a6a;
  --mdc-slider-inactive-track-color: #dae5e4;
  --mdc-slider-with-tick-marks-inactive-container-color: #3f4948;
  --mdc-slider-with-tick-marks-active-container-color: #ffffff;
  --mdc-slider-disabled-active-track-color: #191c1c;
  --mdc-slider-disabled-handle-color: #191c1c;
  --mdc-slider-disabled-inactive-track-color: #191c1c;
  --mdc-slider-label-container-color: #006a6a;
  --mdc-slider-label-label-text-color: #ffffff;
  --mdc-slider-with-overlap-handle-outline-color: #ffffff;
  --mdc-slider-with-tick-marks-disabled-container-color: #191c1c;
  --mdc-slider-label-label-text-font: Tajawal;
  --mdc-slider-label-label-text-size: 0.75rem;
  --mdc-slider-label-label-text-line-height: 1rem;
  --mdc-slider-label-label-text-tracking: 0.031rem;
  --mdc-slider-label-label-text-weight: 500;
  --mdc-slider-active-track-height: 4px;
  --mdc-slider-active-track-shape: 9999px;
  --mdc-slider-handle-height: 20px;
  --mdc-slider-handle-shape: 9999px;
  --mdc-slider-handle-width: 20px;
  --mdc-slider-inactive-track-height: 4px;
  --mdc-slider-inactive-track-shape: 9999px;
  --mdc-slider-with-overlap-handle-outline-width: 1px;
  --mdc-slider-with-tick-marks-active-container-opacity: 0.38;
  --mdc-slider-with-tick-marks-container-shape: 9999px;
  --mdc-slider-with-tick-marks-container-size: 2px;
  --mdc-slider-with-tick-marks-inactive-container-opacity: 0.38;
}
html {
  --mat-slider-ripple-color: #006a6a;
  --mat-slider-hover-state-layer-color: rgba(0, 106, 106, 0.05);
  --mat-slider-focus-state-layer-color: rgba(0, 106, 106, 0.2);
  --mat-slider-value-indicator-width: 28px;
  --mat-slider-value-indicator-height: 28px;
  --mat-slider-value-indicator-caret-display: none;
  --mat-slider-value-indicator-border-radius: 50% 50% 50% 0;
  --mat-slider-value-indicator-padding: 0;
  --mat-slider-value-indicator-text-transform: rotate(45deg);
  --mat-slider-value-indicator-container-transform: translateX(-50%) rotate(-45deg);
  --mat-slider-value-indicator-opacity: 1;
}
html {
  --mat-menu-item-label-text-color: #191c1c;
  --mat-menu-item-icon-color: #3f4948;
  --mat-menu-item-hover-state-layer-color: rgba(25, 28, 28, 0.08);
  --mat-menu-item-focus-state-layer-color: rgba(25, 28, 28, 0.12);
  --mat-menu-container-color: #ebefed;
  --mat-menu-divider-color: #dae5e4;
  --mat-menu-item-label-text-font: Tajawal;
  --mat-menu-item-label-text-size: 0.875rem;
  --mat-menu-item-label-text-tracking: 0.006rem;
  --mat-menu-item-label-text-line-height: 1.25rem;
  --mat-menu-item-label-text-weight: 500;
  --mat-menu-container-shape: 4px;
  --mat-menu-divider-bottom-spacing: 8px;
  --mat-menu-divider-top-spacing: 8px;
  --mat-menu-item-spacing: 12px;
  --mat-menu-item-icon-size: 24px;
  --mat-menu-item-leading-spacing: 12px;
  --mat-menu-item-trailing-spacing: 12px;
  --mat-menu-item-with-icon-leading-spacing: 12px;
  --mat-menu-item-with-icon-trailing-spacing: 12px;
  --mat-menu-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
html {
  --mdc-list-list-item-container-color: transparent;
  --mdc-list-list-item-leading-avatar-color: #00fbfb;
  --mdc-list-list-item-disabled-state-layer-color: #191c1c;
  --mdc-list-list-item-disabled-state-layer-opacity: 0.12;
  --mdc-list-list-item-label-text-color: #191c1c;
  --mdc-list-list-item-supporting-text-color: #3f4948;
  --mdc-list-list-item-leading-icon-color: #3f4948;
  --mdc-list-list-item-trailing-supporting-text-color: #3f4948;
  --mdc-list-list-item-trailing-icon-color: #3f4948;
  --mdc-list-list-item-selected-trailing-icon-color: #006a6a;
  --mdc-list-list-item-disabled-label-text-color: #191c1c;
  --mdc-list-list-item-disabled-leading-icon-color: #191c1c;
  --mdc-list-list-item-disabled-trailing-icon-color: #191c1c;
  --mdc-list-list-item-hover-label-text-color: #191c1c;
  --mdc-list-list-item-focus-label-text-color: #191c1c;
  --mdc-list-list-item-hover-state-layer-color: #191c1c;
  --mdc-list-list-item-hover-state-layer-opacity: 0.08;
  --mdc-list-list-item-focus-state-layer-color: #191c1c;
  --mdc-list-list-item-focus-state-layer-opacity: 0.12;
  --mdc-list-list-item-label-text-font: Tajawal;
  --mdc-list-list-item-label-text-line-height: 1.5rem;
  --mdc-list-list-item-label-text-size: 1rem;
  --mdc-list-list-item-label-text-tracking: 0.031rem;
  --mdc-list-list-item-label-text-weight: 400;
  --mdc-list-list-item-supporting-text-font: Tajawal;
  --mdc-list-list-item-supporting-text-line-height: 1.25rem;
  --mdc-list-list-item-supporting-text-size: 0.875rem;
  --mdc-list-list-item-supporting-text-tracking: 0.016rem;
  --mdc-list-list-item-supporting-text-weight: 400;
  --mdc-list-list-item-trailing-supporting-text-font: Tajawal;
  --mdc-list-list-item-trailing-supporting-text-line-height: 1rem;
  --mdc-list-list-item-trailing-supporting-text-size: 0.688rem;
  --mdc-list-list-item-trailing-supporting-text-tracking: 0.031rem;
  --mdc-list-list-item-trailing-supporting-text-weight: 500;
  --mdc-list-list-item-one-line-container-height: 48px;
  --mdc-list-list-item-two-line-container-height: 64px;
  --mdc-list-list-item-three-line-container-height: 88px;
  --mdc-list-list-item-container-shape: 0;
  --mdc-list-list-item-leading-avatar-shape: 9999px;
  --mdc-list-list-item-leading-icon-size: 24px;
  --mdc-list-list-item-leading-avatar-size: 40px;
  --mdc-list-list-item-trailing-icon-size: 24px;
  --mdc-list-list-item-disabled-label-text-opacity: 0.3;
  --mdc-list-list-item-disabled-leading-icon-opacity: 0.38;
  --mdc-list-list-item-disabled-trailing-icon-opacity: 0.38;
}
html {
  --mat-list-active-indicator-color: #cce8e7;
  --mat-list-list-item-leading-icon-start-space: 16px;
  --mat-list-list-item-leading-icon-end-space: 16px;
  --mat-list-active-indicator-shape: 9999px;
}
html {
  --mat-paginator-container-text-color: #191c1c;
  --mat-paginator-container-background-color: #f7faf9;
  --mat-paginator-enabled-icon-color: #3f4948;
  --mat-paginator-disabled-icon-color: rgba(25, 28, 28, 0.38);
  --mat-paginator-container-text-font: Tajawal;
  --mat-paginator-container-text-line-height: 1rem;
  --mat-paginator-container-text-size: 0.75rem;
  --mat-paginator-container-text-tracking: 0.025rem;
  --mat-paginator-container-text-weight: 400;
  --mat-paginator-select-trigger-text-size: 0.75rem;
  --mat-paginator-container-size: 56px;
  --mat-paginator-form-field-container-height: 40px;
  --mat-paginator-form-field-container-vertical-padding: 8px;
  --mat-paginator-touch-target-display: block;
}
html {
  --mdc-secondary-navigation-tab-container-height: 48px;
}
html {
  --mdc-tab-indicator-active-indicator-color: #006a6a;
  --mdc-tab-indicator-active-indicator-height: 2px;
  --mdc-tab-indicator-active-indicator-shape: 0;
}
html {
  --mat-tab-header-divider-color: #dae5e4;
  --mat-tab-header-pagination-icon-color: #191c1c;
  --mat-tab-header-inactive-label-text-color: #191c1c;
  --mat-tab-header-active-label-text-color: #191c1c;
  --mat-tab-header-active-ripple-color: #191c1c;
  --mat-tab-header-inactive-ripple-color: #191c1c;
  --mat-tab-header-inactive-focus-label-text-color: #191c1c;
  --mat-tab-header-inactive-hover-label-text-color: #191c1c;
  --mat-tab-header-active-focus-label-text-color: #191c1c;
  --mat-tab-header-active-hover-label-text-color: #191c1c;
  --mat-tab-header-active-focus-indicator-color: #006a6a;
  --mat-tab-header-active-hover-indicator-color: #006a6a;
  --mat-tab-header-label-text-font: Tajawal;
  --mat-tab-header-label-text-size: 0.875rem;
  --mat-tab-header-label-text-tracking: 0.006rem;
  --mat-tab-header-label-text-line-height: 1.25rem;
  --mat-tab-header-label-text-weight: 500;
  --mat-tab-header-divider-height: 1px;
}
html {
  --mdc-checkbox-disabled-selected-checkmark-color: #f7faf9;
  --mdc-checkbox-selected-focus-state-layer-opacity: 0.12;
  --mdc-checkbox-selected-hover-state-layer-opacity: 0.08;
  --mdc-checkbox-selected-pressed-state-layer-opacity: 0.12;
  --mdc-checkbox-unselected-focus-state-layer-opacity: 0.12;
  --mdc-checkbox-unselected-hover-state-layer-opacity: 0.08;
  --mdc-checkbox-unselected-pressed-state-layer-opacity: 0.12;
  --mdc-checkbox-selected-pressed-icon-color: #006a6a;
  --mdc-checkbox-disabled-selected-icon-color: rgba(25, 28, 28, 0.38);
  --mdc-checkbox-disabled-unselected-icon-color: rgba(25, 28, 28, 0.38);
  --mdc-checkbox-selected-checkmark-color: #ffffff;
  --mdc-checkbox-selected-focus-icon-color: #006a6a;
  --mdc-checkbox-selected-hover-icon-color: #006a6a;
  --mdc-checkbox-selected-icon-color: #006a6a;
  --mdc-checkbox-unselected-focus-icon-color: #191c1c;
  --mdc-checkbox-unselected-hover-icon-color: #191c1c;
  --mdc-checkbox-unselected-icon-color: #3f4948;
  --mdc-checkbox-selected-focus-state-layer-color: #006a6a;
  --mdc-checkbox-selected-hover-state-layer-color: #006a6a;
  --mdc-checkbox-selected-pressed-state-layer-color: #191c1c;
  --mdc-checkbox-unselected-focus-state-layer-color: #191c1c;
  --mdc-checkbox-unselected-hover-state-layer-color: #191c1c;
  --mdc-checkbox-unselected-pressed-state-layer-color: #006a6a;
  --mdc-checkbox-state-layer-size: 40px;
}
html {
  --mat-checkbox-disabled-label-color: rgba(25, 28, 28, 0.38);
  --mat-checkbox-label-text-color: #191c1c;
  --mat-checkbox-label-text-font: Tajawal;
  --mat-checkbox-label-text-line-height: 1.25rem;
  --mat-checkbox-label-text-size: 0.875rem;
  --mat-checkbox-label-text-tracking: 0.016rem;
  --mat-checkbox-label-text-weight: 400;
  --mat-checkbox-touch-target-display: block;
}
html {
  --mdc-text-button-label-text-color: #006a6a;
  --mdc-text-button-disabled-label-text-color: rgba(25, 28, 28, 0.38);
  --mdc-text-button-label-text-font: Tajawal;
  --mdc-text-button-label-text-size: 0.875rem;
  --mdc-text-button-label-text-tracking: 0.006rem;
  --mdc-text-button-label-text-weight: 500;
  --mdc-text-button-container-height: 40px;
  --mdc-text-button-container-shape: 9999px;
}
html {
  --mdc-protected-button-container-elevation-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mdc-protected-button-disabled-container-elevation-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mdc-protected-button-focus-container-elevation-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mdc-protected-button-hover-container-elevation-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
  --mdc-protected-button-pressed-container-elevation-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mdc-protected-button-container-color: #f7faf9;
  --mdc-protected-button-label-text-color: #006a6a;
  --mdc-protected-button-disabled-container-color: rgba(25, 28, 28, 0.12);
  --mdc-protected-button-disabled-label-text-color: rgba(25, 28, 28, 0.38);
  --mdc-protected-button-label-text-font: Tajawal;
  --mdc-protected-button-label-text-size: 0.875rem;
  --mdc-protected-button-label-text-tracking: 0.006rem;
  --mdc-protected-button-label-text-weight: 500;
  --mdc-protected-button-container-height: 40px;
  --mdc-protected-button-container-shape: 9999px;
}
html {
  --mdc-filled-button-container-color: #006a6a;
  --mdc-filled-button-label-text-color: #ffffff;
  --mdc-filled-button-disabled-container-color: rgba(25, 28, 28, 0.12);
  --mdc-filled-button-disabled-label-text-color: rgba(25, 28, 28, 0.38);
  --mdc-filled-button-label-text-font: Tajawal;
  --mdc-filled-button-label-text-size: 0.875rem;
  --mdc-filled-button-label-text-tracking: 0.006rem;
  --mdc-filled-button-label-text-weight: 500;
  --mdc-filled-button-container-height: 40px;
  --mdc-filled-button-container-shape: 9999px;
}
html {
  --mdc-outlined-button-disabled-outline-color: rgba(25, 28, 28, 0.12);
  --mdc-outlined-button-disabled-label-text-color: rgba(25, 28, 28, 0.38);
  --mdc-outlined-button-label-text-color: #006a6a;
  --mdc-outlined-button-outline-color: #6f7979;
  --mdc-outlined-button-label-text-font: Tajawal;
  --mdc-outlined-button-label-text-size: 0.875rem;
  --mdc-outlined-button-label-text-tracking: 0.006rem;
  --mdc-outlined-button-label-text-weight: 500;
  --mdc-outlined-button-container-height: 40px;
  --mdc-outlined-button-outline-width: 1px;
  --mdc-outlined-button-container-shape: 9999px;
}
html {
  --mat-text-button-state-layer-color: #006a6a;
  --mat-text-button-disabled-state-layer-color: #3f4948;
  --mat-text-button-ripple-color: rgba(0, 106, 106, 0.12);
  --mat-text-button-hover-state-layer-opacity: 0.08;
  --mat-text-button-focus-state-layer-opacity: 0.12;
  --mat-text-button-pressed-state-layer-opacity: 0.12;
  --mat-text-button-touch-target-display: block;
  --mat-text-button-horizontal-padding: 12px;
  --mat-text-button-with-icon-horizontal-padding: 16px;
  --mat-text-button-icon-spacing: 8px;
  --mat-text-button-icon-offset: -4px;
}
html {
  --mat-protected-button-state-layer-color: #006a6a;
  --mat-protected-button-disabled-state-layer-color: #3f4948;
  --mat-protected-button-ripple-color: rgba(0, 106, 106, 0.12);
  --mat-protected-button-hover-state-layer-opacity: 0.08;
  --mat-protected-button-focus-state-layer-opacity: 0.12;
  --mat-protected-button-pressed-state-layer-opacity: 0.12;
  --mat-protected-button-touch-target-display: block;
  --mat-protected-button-horizontal-padding: 24px;
  --mat-protected-button-icon-spacing: 8px;
  --mat-protected-button-icon-offset: -8px;
}
html {
  --mat-filled-button-state-layer-color: #ffffff;
  --mat-filled-button-disabled-state-layer-color: #3f4948;
  --mat-filled-button-ripple-color: rgba(255, 255, 255, 0.12);
  --mat-filled-button-hover-state-layer-opacity: 0.08;
  --mat-filled-button-focus-state-layer-opacity: 0.12;
  --mat-filled-button-pressed-state-layer-opacity: 0.12;
  --mat-filled-button-touch-target-display: block;
  --mat-filled-button-horizontal-padding: 24px;
  --mat-filled-button-icon-spacing: 8px;
  --mat-filled-button-icon-offset: -8px;
}
html {
  --mat-outlined-button-state-layer-color: #006a6a;
  --mat-outlined-button-disabled-state-layer-color: #3f4948;
  --mat-outlined-button-ripple-color: rgba(0, 106, 106, 0.12);
  --mat-outlined-button-hover-state-layer-opacity: 0.08;
  --mat-outlined-button-focus-state-layer-opacity: 0.12;
  --mat-outlined-button-pressed-state-layer-opacity: 0.12;
  --mat-outlined-button-touch-target-display: block;
  --mat-outlined-button-horizontal-padding: 24px;
  --mat-outlined-button-icon-spacing: 8px;
  --mat-outlined-button-icon-offset: -8px;
}
html {
  --mdc-icon-button-icon-color: #3f4948;
  --mdc-icon-button-disabled-icon-color: rgba(25, 28, 28, 0.38);
  --mdc-icon-button-state-layer-size: 40px;
  --mdc-icon-button-icon-size: 24px;
}
html {
  --mat-icon-button-state-layer-color: #3f4948;
  --mat-icon-button-disabled-state-layer-color: #3f4948;
  --mat-icon-button-ripple-color: rgba(63, 73, 72, 0.12);
  --mat-icon-button-hover-state-layer-opacity: 0.08;
  --mat-icon-button-focus-state-layer-opacity: 0.12;
  --mat-icon-button-pressed-state-layer-opacity: 0.12;
  --mat-icon-button-touch-target-display: block;
}
html {
  --mdc-extended-fab-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mdc-extended-fab-focus-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mdc-extended-fab-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mdc-extended-fab-pressed-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mdc-extended-fab-label-text-font: Tajawal;
  --mdc-extended-fab-label-text-size: 0.875rem;
  --mdc-extended-fab-label-text-tracking: 0.006rem;
  --mdc-extended-fab-label-text-weight: 500;
  --mdc-extended-fab-container-height: 56px;
  --mdc-extended-fab-container-shape: 16px;
}
html {
  --mdc-fab-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mdc-fab-focus-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mdc-fab-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mdc-fab-pressed-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mdc-fab-container-color: #00fbfb;
  --mdc-fab-container-shape: 16px;
}
html {
  --mdc-fab-small-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mdc-fab-small-focus-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mdc-fab-small-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mdc-fab-small-pressed-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mdc-fab-small-container-color: #00fbfb;
  --mdc-fab-small-container-shape: 12px;
}
html {
  --mat-fab-foreground-color: #004f4f;
  --mat-fab-state-layer-color: #004f4f;
  --mat-fab-ripple-color: rgba(0, 79, 79, 0.12);
  --mat-fab-hover-state-layer-opacity: 0.08;
  --mat-fab-focus-state-layer-opacity: 0.12;
  --mat-fab-pressed-state-layer-opacity: 0.12;
  --mat-fab-disabled-state-container-color: rgba(25, 28, 28, 0.12);
  --mat-fab-disabled-state-foreground-color: rgba(25, 28, 28, 0.38);
  --mat-fab-touch-target-display: block;
}
html {
  --mat-fab-small-foreground-color: #004f4f;
  --mat-fab-small-state-layer-color: #004f4f;
  --mat-fab-small-ripple-color: rgba(0, 79, 79, 0.12);
  --mat-fab-small-hover-state-layer-opacity: 0.08;
  --mat-fab-small-focus-state-layer-opacity: 0.12;
  --mat-fab-small-pressed-state-layer-opacity: 0.12;
  --mat-fab-small-disabled-state-container-color: rgba(25, 28, 28, 0.12);
  --mat-fab-small-disabled-state-foreground-color: rgba(25, 28, 28, 0.38);
}
html {
  --mdc-snackbar-container-color: #2d3131;
  --mdc-snackbar-supporting-text-color: #eff1f0;
  --mdc-snackbar-supporting-text-font: Tajawal;
  --mdc-snackbar-supporting-text-line-height: 1.25rem;
  --mdc-snackbar-supporting-text-size: 0.875rem;
  --mdc-snackbar-supporting-text-weight: 400;
  --mdc-snackbar-container-shape: 4px;
}
html {
  --mat-snack-bar-button-color: #00dddd;
}
html {
  --mat-table-background-color: #f7faf9;
  --mat-table-header-headline-color: #191c1c;
  --mat-table-row-item-label-text-color: #191c1c;
  --mat-table-row-item-outline-color: #6f7979;
  --mat-table-header-headline-font: Tajawal;
  --mat-table-header-headline-line-height: 1.25rem;
  --mat-table-header-headline-size: 0.875rem;
  --mat-table-header-headline-weight: 500;
  --mat-table-header-headline-tracking: 0.006rem;
  --mat-table-row-item-label-text-font: Tajawal;
  --mat-table-row-item-label-text-line-height: 1.25rem;
  --mat-table-row-item-label-text-size: 0.875rem;
  --mat-table-row-item-label-text-weight: 400;
  --mat-table-row-item-label-text-tracking: 0.016rem;
  --mat-table-footer-supporting-text-font: Tajawal;
  --mat-table-footer-supporting-text-line-height: 1.25rem;
  --mat-table-footer-supporting-text-size: 0.875rem;
  --mat-table-footer-supporting-text-weight: 400;
  --mat-table-footer-supporting-text-tracking: 0.016rem;
  --mat-table-header-container-height: 56px;
  --mat-table-footer-container-height: 52px;
  --mat-table-row-item-container-height: 52px;
  --mat-table-row-item-outline-width: 1px;
}
html {
  --mdc-circular-progress-active-indicator-color: #006a6a;
  --mdc-circular-progress-active-indicator-width: 4px;
  --mdc-circular-progress-size: 48px;
}
html {
  --mat-badge-background-color: #ba1a1a;
  --mat-badge-text-color: #ffffff;
  --mat-badge-disabled-state-background-color: rgba(186, 26, 26, 0.38);
  --mat-badge-disabled-state-text-color: #ffffff;
  --mat-badge-text-font: Tajawal;
  --mat-badge-text-size: 0.688rem;
  --mat-badge-text-weight: 500;
  --mat-badge-large-size-text-size: 0.688rem;
  --mat-badge-container-shape: 9999px;
  --mat-badge-container-size: 16px;
  --mat-badge-small-size-container-size: 6px;
  --mat-badge-large-size-container-size: 16px;
  --mat-badge-legacy-container-size: unset;
  --mat-badge-legacy-small-size-container-size: unset;
  --mat-badge-legacy-large-size-container-size: unset;
  --mat-badge-container-offset: -12px 0;
  --mat-badge-small-size-container-offset: -6px 0;
  --mat-badge-large-size-container-offset: -12px 0;
  --mat-badge-container-overlap-offset: -12px;
  --mat-badge-small-size-container-overlap-offset: -6px;
  --mat-badge-large-size-container-overlap-offset: -12px;
  --mat-badge-container-padding: 0 4px;
  --mat-badge-small-size-container-padding: 0;
  --mat-badge-large-size-container-padding: 0 4px;
  --mat-badge-line-height: 16px;
  --mat-badge-small-size-text-size: 0;
  --mat-badge-small-size-line-height: 6px;
  --mat-badge-large-size-line-height: 16px;
}
html {
  --mat-bottom-sheet-container-text-color: #191c1c;
  --mat-bottom-sheet-container-background-color: #f1f4f3;
  --mat-bottom-sheet-container-text-font: Tajawal;
  --mat-bottom-sheet-container-text-line-height: 1.5rem;
  --mat-bottom-sheet-container-text-size: 1rem;
  --mat-bottom-sheet-container-text-tracking: 0.031rem;
  --mat-bottom-sheet-container-text-weight: 400;
  --mat-bottom-sheet-container-shape: 28px;
}
html {
  --mat-standard-button-toggle-hover-state-layer-opacity: 0.08;
  --mat-standard-button-toggle-focus-state-layer-opacity: 0.12;
  --mat-standard-button-toggle-text-color: #191c1c;
  --mat-standard-button-toggle-state-layer-color: #191c1c;
  --mat-standard-button-toggle-selected-state-background-color: #cce8e7;
  --mat-standard-button-toggle-selected-state-text-color: #324b4b;
  --mat-standard-button-toggle-disabled-state-text-color: rgba(25, 28, 28, 0.38);
  --mat-standard-button-toggle-disabled-selected-state-text-color: rgba(25, 28, 28, 0.38);
  --mat-standard-button-toggle-disabled-selected-state-background-color: rgba(25, 28, 28, 0.12);
  --mat-standard-button-toggle-divider-color: #6f7979;
  --mat-standard-button-toggle-label-text-font: Tajawal;
  --mat-standard-button-toggle-label-text-line-height: 1.25rem;
  --mat-standard-button-toggle-label-text-size: 0.875rem;
  --mat-standard-button-toggle-label-text-tracking: 0.006rem;
  --mat-standard-button-toggle-label-text-weight: 500;
  --mat-standard-button-toggle-height: 40px;
  --mat-standard-button-toggle-shape: 28px;
  --mat-standard-button-toggle-background-color: transparent;
  --mat-standard-button-toggle-disabled-state-background-color: transparent;
}
html {
  --mat-datepicker-calendar-date-selected-state-text-color: #ffffff;
  --mat-datepicker-calendar-date-selected-state-background-color: #006a6a;
  --mat-datepicker-calendar-date-selected-disabled-state-background-color: rgba(25, 28, 28, 0.38);
  --mat-datepicker-calendar-date-today-selected-state-outline-color: #006a6a;
  --mat-datepicker-calendar-date-focus-state-background-color: rgba(25, 28, 28, 0.12);
  --mat-datepicker-calendar-date-hover-state-background-color: rgba(25, 28, 28, 0.08);
  --mat-datepicker-toggle-active-state-icon-color: #3f4948;
  --mat-datepicker-calendar-date-in-range-state-background-color: #00fbfb;
  --mat-datepicker-calendar-date-in-comparison-range-state-background-color: #e0e0ff;
  --mat-datepicker-calendar-date-in-overlap-range-state-background-color: #cce8e7;
  --mat-datepicker-calendar-date-in-overlap-range-selected-state-background-color: #4a6363;
  --mat-datepicker-toggle-icon-color: #3f4948;
  --mat-datepicker-calendar-body-label-text-color: #191c1c;
  --mat-datepicker-calendar-period-button-text-color: #3f4948;
  --mat-datepicker-calendar-period-button-icon-color: #3f4948;
  --mat-datepicker-calendar-navigation-button-icon-color: #3f4948;
  --mat-datepicker-calendar-header-text-color: #3f4948;
  --mat-datepicker-calendar-date-today-outline-color: #006a6a;
  --mat-datepicker-calendar-date-today-disabled-state-outline-color: rgba(25, 28, 28, 0.38);
  --mat-datepicker-calendar-date-text-color: #191c1c;
  --mat-datepicker-calendar-date-disabled-state-text-color: rgba(25, 28, 28, 0.38);
  --mat-datepicker-calendar-date-preview-state-outline-color: #006a6a;
  --mat-datepicker-range-input-separator-color: #191c1c;
  --mat-datepicker-range-input-disabled-state-separator-color: rgba(25, 28, 28, 0.38);
  --mat-datepicker-range-input-disabled-state-text-color: rgba(25, 28, 28, 0.38);
  --mat-datepicker-calendar-container-background-color: #e6e9e7;
  --mat-datepicker-calendar-container-text-color: #191c1c;
  --mat-datepicker-calendar-text-font: Tajawal;
  --mat-datepicker-calendar-text-size: 0.875rem;
  --mat-datepicker-calendar-body-label-text-size: 0.875rem;
  --mat-datepicker-calendar-body-label-text-weight: 500;
  --mat-datepicker-calendar-period-button-text-size: 0.875rem;
  --mat-datepicker-calendar-period-button-text-weight: 500;
  --mat-datepicker-calendar-header-text-size: 0.875rem;
  --mat-datepicker-calendar-header-text-weight: 500;
  --mat-datepicker-calendar-container-shape: 16px;
  --mat-datepicker-calendar-container-touch-shape: 28px;
  --mat-datepicker-calendar-container-elevation-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-container-touch-elevation-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-header-divider-color: transparent;
  --mat-datepicker-calendar-date-outline-color: transparent;
}
html {
  --mat-divider-color: #6f7979;
  --mat-divider-width: 1px;
}
html {
  --mat-expansion-container-background-color: #f7faf9;
  --mat-expansion-container-text-color: #191c1c;
  --mat-expansion-actions-divider-color: #6f7979;
  --mat-expansion-header-hover-state-layer-color: rgba(25, 28, 28, 0.08);
  --mat-expansion-header-focus-state-layer-color: rgba(25, 28, 28, 0.12);
  --mat-expansion-header-disabled-state-text-color: rgba(25, 28, 28, 0.38);
  --mat-expansion-header-text-color: #191c1c;
  --mat-expansion-header-description-color: #3f4948;
  --mat-expansion-header-indicator-color: #3f4948;
  --mat-expansion-header-text-font: Tajawal;
  --mat-expansion-header-text-size: 1rem;
  --mat-expansion-header-text-weight: 500;
  --mat-expansion-header-text-line-height: 1.5rem;
  --mat-expansion-header-text-tracking: 0.009rem;
  --mat-expansion-container-text-font: Tajawal;
  --mat-expansion-container-text-line-height: 1.5rem;
  --mat-expansion-container-text-size: 1rem;
  --mat-expansion-container-text-tracking: 0.031rem;
  --mat-expansion-container-text-weight: 400;
  --mat-expansion-header-collapsed-state-height: 48px;
  --mat-expansion-header-expanded-state-height: 64px;
  --mat-expansion-container-shape: 12px;
  --mat-expansion-legacy-header-indicator-display: none;
  --mat-expansion-header-indicator-display: inline-block;
}
html {
  --mat-grid-list-tile-header-primary-text-size: 400 1rem / 1.5rem Tajawal;
  --mat-grid-list-tile-header-secondary-text-size: 400 0.875rem / 1.25rem Tajawal;
  --mat-grid-list-tile-footer-primary-text-size: 400 1rem / 1.5rem Tajawal;
  --mat-grid-list-tile-footer-secondary-text-size: 400 0.875rem / 1.25rem Tajawal;
}
html {
  --mat-icon-color: inherit;
}
html {
  --mat-sidenav-container-background-color: #f7faf9;
  --mat-sidenav-container-text-color: #3f4948;
  --mat-sidenav-content-background-color: #f7faf9;
  --mat-sidenav-content-text-color: #191c1c;
  --mat-sidenav-scrim-color: rgba(41, 50, 50, 0.4);
  --mat-sidenav-container-shape: 16px;
  --mat-sidenav-container-elevation-shadow: none;
  --mat-sidenav-container-width: 360px;
  --mat-sidenav-container-divider-color: transparent;
}
html {
  --mat-stepper-header-icon-foreground-color: #f7faf9;
  --mat-stepper-header-selected-state-icon-background-color: #006a6a;
  --mat-stepper-header-selected-state-icon-foreground-color: #ffffff;
  --mat-stepper-header-edit-state-icon-background-color: #006a6a;
  --mat-stepper-header-edit-state-icon-foreground-color: #ffffff;
  --mat-stepper-container-color: #f7faf9;
  --mat-stepper-line-color: #6f7979;
  --mat-stepper-header-hover-state-layer-color: rgba(45, 49, 49, 0.08);
  --mat-stepper-header-focus-state-layer-color: rgba(45, 49, 49, 0.12);
  --mat-stepper-header-label-text-color: #3f4948;
  --mat-stepper-header-optional-label-text-color: #3f4948;
  --mat-stepper-header-selected-state-label-text-color: #3f4948;
  --mat-stepper-header-error-state-label-text-color: #ba1a1a;
  --mat-stepper-header-icon-background-color: #3f4948;
  --mat-stepper-header-error-state-icon-foreground-color: #ba1a1a;
  --mat-stepper-container-text-font: Tajawal;
  --mat-stepper-header-label-text-font: Tajawal;
  --mat-stepper-header-label-text-size: 0.875rem;
  --mat-stepper-header-label-text-weight: 500;
  --mat-stepper-header-error-state-label-text-size: 0.875rem;
  --mat-stepper-header-selected-state-label-text-size: 0.875rem;
  --mat-stepper-header-selected-state-label-text-weight: 500;
  --mat-stepper-header-height: 72px;
  --mat-stepper-header-focus-state-layer-shape: 12px;
  --mat-stepper-header-hover-state-layer-shape: 12px;
  --mat-stepper-header-error-state-icon-background-color: transparent;
}
html {
  --mat-sort-arrow-color: #191c1c;
}
html {
  --mat-toolbar-container-background-color: #f7faf9;
  --mat-toolbar-container-text-color: #191c1c;
  --mat-toolbar-title-text-font: Tajawal;
  --mat-toolbar-title-text-line-height: 1.75rem;
  --mat-toolbar-title-text-size: 1.375rem;
  --mat-toolbar-title-text-tracking: 0;
  --mat-toolbar-title-text-weight: 400;
  --mat-toolbar-standard-height: 64px;
  --mat-toolbar-mobile-height: 56px;
}
html {
  --mat-tree-container-background-color: #f7faf9;
  --mat-tree-node-text-color: #191c1c;
  --mat-tree-node-text-font: Tajawal;
  --mat-tree-node-text-size: 1rem;
  --mat-tree-node-text-weight: 400;
  --mat-tree-node-min-height: 48px;
}
html {
  --mat-timepicker-container-background-color: #ebefed;
  --mat-timepicker-container-shape: 4px;
  --mat-timepicker-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

/* ======== Global UI polish ======== */
a, button, .mat-mdc-button, .mat-mdc-icon-button, .nav-item {
  transition: all 0.2s ease-out;
}

:focus-visible {
  outline: 2px solid #0d9b84;
  outline-offset: 2px;
  border-radius: 4px;
}

.mat-mdc-dialog-container .mdc-dialog__surface {
  border-radius: 1rem !important;
}

.mdc-snackbar__surface {
  border-radius: 0.5rem !important;
}

.mat-dialog-container {
  border-radius: 1.6rem !important;
}

.confirm-dialog .mat-dialog-container {
  padding: 1.8rem 2.8rem 3.8rem !important;
}

.logout-dialog h2 {
  color: var(--dark-text-color);
  font-size: 2.4rem;
  font-weight: bold;
}
.logout-dialog .mat-icon {
  rotate: 180deg;
  color: var(--accent-color) !important;
}
.logout-dialog h3 {
  color: var(--dark-text-color);
  font-size: 2.1rem;
}

.mat-spinner {
  margin: 2rem auto;
}

.mat-tab-group {
  box-shadow: none !important;
}
.mat-tab-group .mat-tab-header {
  border-bottom: none;
}

.mat-tab-label {
  background-color: transparent !important;
  opacity: 1 !important;
}
.mat-tab-label.mat-tab-disabled {
  background-color: transparent !important;
}
.mat-tab-label.mat-tab-disabled .mat-tab-label-content {
  opacity: 1;
}
.mat-tab-label.mat-tab-label-active {
  background-color: transparent !important;
  opacity: 1 !important;
}
.mat-tab-label .mat-tab-label-content {
  color: var(--black-color);
  font-size: 16px;
}
.mat-tab-label:last-of-type {
  margin-inline-start: auto;
}

.mat-ink-bar {
  height: 4px !important;
  background-color: var(--accent-color) !important;
  transform: scale(0.5);
}

td.mat-cell:last-of-type {
  position: relative;
}

.mat-row:hover {
  background-color: #e8e8e8;
}

.mat-user-card {
  width: 70%;
  height: 50px;
  margin: 0 auto;
  margin-top: 16px;
  border: none;
}
.mat-user-card span {
  margin-left: 10px;
  line-height: 45px;
}
.mat-user-card img {
  margin-left: 10px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  vertical-align: middle;
}

.my-full-width-menu {
  width: 400px !important;
  max-width: 100% !important;
  height: 400px !important;
  max-height: 100% !important;
  padding: 8px;
}

.mat-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0px 1.8rem !important;
}
.mat-table .mat-header-cell {
  min-width: 15rem;
}

.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  background-color: #f0e7e6;
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 100ms cubic-bezier(0, 0, 0.2, 1);
  background-color: #f0e7e6;
}

.cdk-drop-list-dragging .mat-row:not(.cdk-drag-placeholder) {
  transition: transform 100ms cubic-bezier(0, 0, 0.2, 1);
}

.mat-header-cell {
  padding: 0 1rem !important;
  text-align: center !important;
  border: 1px solid !important;
  border-color: var(--devider-color) !important;
}

.mat-sort-header-container {
  justify-content: center;
}

.mat-cell {
  text-align: center;
  border-bottom-color: transparent !important;
  box-shadow: 3px 3px 10px 3px #eee;
  padding: 0 1rem !important;
  white-space: nowrap;
}
.mat-cell p {
  overflow: hidden;
  text-overflow: ellipsis;
}
.mat-cell:not(:first-of-type) {
  border-inline-start: 1.5px solid var(--devider-color);
}

.overlay-snackbar, .error-snackbar, .success-snackbar {
  height: 100vh !important;
  width: 100vw !important;
  max-width: 100vw !important;
  min-width: 100vw !important;
  margin: 0 !important;
  direction: ltr;
}

.container-snackbar, .error-snackbar.mat-mdc-snack-bar-container .mdc-snackbar__surface, .success-snackbar.mat-mdc-snack-bar-container .mdc-snackbar__surface {
  position: absolute;
  bottom: 3.5rem;
  right: 3.5rem;
  background-color: #f44336 !important;
  color: #fff !important;
  max-width: max-content !important;
  min-width: auto !important;
  text-align: center;
  border-radius: 0.5rem;
  box-shadow: none !important;
  display: flex;
  padding: 0.625rem 1.5rem;
  justify-content: flex-end;
  align-items: center;
  gap: 0.625rem;
}
@media only screen and (max-width: 768px) {
  .container-snackbar, .error-snackbar.mat-mdc-snack-bar-container .mdc-snackbar__surface, .success-snackbar.mat-mdc-snack-bar-container .mdc-snackbar__surface {
    right: 1rem;
    bottom: 5rem;
  }
}

.success-snackbar.mat-mdc-snack-bar-container .mdc-snackbar__surface {
  background-color: #0d9b84 !important;
}
.success-snackbar.mat-mdc-snack-bar-container .mdc-snackbar__surface .mdc-snackbar__label {
  direction: rtl;
  white-space: pre;
  display: flex;
  align-items: center;
  padding: 0 !important;
}

.error-snackbar.mat-mdc-snack-bar-container .mdc-snackbar__surface .mdc-snackbar__label {
  direction: rtl;
  white-space: pre;
  display: flex;
  align-items: center;
  padding: 0 !important;
}

::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: block;
  min-height: 1.25rem;
}
::ng-deep .mat-mdc-form-field-subscript-wrapper:not(:has(.mat-mdc-form-field-error)):not(:has(.mat-mdc-form-field-hint)) {
  display: none;
}
::ng-deep .mat-mdc-form-field-infix {
  min-height: 3rem !important;
  height: 3rem !important;
}
::ng-deep .mat-mdc-form-field-flex {
  display: flex;
  align-items: center;
}
::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mat-mdc-form-field-infix {
  padding: 0.375rem 0 !important;
  display: flex;
  align-items: center;
}
::ng-deep .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing {
  border-radius: 0.5rem !important;
  border-width: 1px !important;
  border-color: #77797b !important;
}
::ng-deep .mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__trailing {
  border-radius: 0.5rem !important;
  border-width: 1px !important;
  border-color: #0d9b84 !important;
}
::ng-deep .mdc-text-field--no-label:not(.mdc-text-field--textarea) .mat-mdc-form-field-input-control.mdc-text-field__input,
::ng-deep .mdc-text-field--focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-input-control {
  caret-color: #0d9b84 !important;
}
::ng-deep .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-text-field--focused .mdc-notched-outline .mdc-notched-outline__leading {
  border-color: #0d9b84 !important;
}
::ng-deep .mdc-text-field--no-label:not(.mdc-text-field--textarea) .mat-mdc-form-field-input-control.mdc-text-field__input,
::ng-deep .mat-mdc-text-field-wrapper .mat-mdc-form-field-input-control {
  height: 100%;
}
::ng-deep .mdc-text-field--outlined.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-text-field__input {
  caret-color: #f44336 !important;
}
::ng-deep .mdc-text-field--outlined .mdc-notched-outline,
::ng-deep .mdc-text-field--outlined.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing,
::ng-deep .mdc-text-field--outlined.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__leading {
  border-color: #f44336 !important;
  border-radius: 0.5rem !important;
  border-width: 1px !important;
}
::ng-deep .mdc-text-field--no-label .mdc-notched-outline__leading {
  display: none;
}
::ng-deep .mdc-text-field--no-label .mdc-notched-outline__trailing {
  border-inline-start: 1px solid !important;
  border-radius: 0.5rem !important;
}
::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined:not(.mdc-text-field--no-label) .mdc-notched-outline__leading {
  display: block;
}
::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined:not(.mdc-text-field--no-label) .mdc-notched-outline__trailing {
  border-inline-start: 0 !important;
  border-start-start-radius: 0 !important;
  border-end-start-radius: 0 !important;
}
::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined:not(.mdc-text-field--no-label) .mat-mdc-form-field-infix {
  height: auto !important;
  min-height: auto !important;
  display: block !important;
  padding: 1rem 0 !important;
}
::ng-deep .mat-mdc-form-field-error {
  margin-top: 0.5rem !important;
  color: #f44336 !important;
}
::ng-deep .mat-mdc-form-field-bottom-align::before {
  height: auto !important;
}
::ng-deep .mat-mdc-button .mat-mdc-button-persistent-ripple::before {
  background-color: transparent !important;
}
::ng-deep .mat-mdc-button .mat-mdc-button-ripple,
::ng-deep .mat-mdc-unelevated-button .mat-mdc-button-ripple,
::ng-deep .mat-mdc-raised-button .mat-mdc-button-ripple,
::ng-deep .mat-mdc-outlined-button .mat-mdc-button-ripple,
::ng-deep .mat-mdc-button .mat-mdc-button-touch-target {
  display: none !important;
  visibility: hidden !important;
}
::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  border-radius: 1rem !important;
  overflow: hidden;
}
@media only screen and (max-width: 768px) {
  ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
    height: auto !important;
  }
}
@media only screen and (max-width: 768px) {
  ::ng-deep .dialog-container {
    padding: 1rem !important;
  }
  ::ng-deep .mdc-dialog .mdc-dialog__content {
    padding: 0 !important;
    height: 60vh;
  }
}
::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
::ng-deep .mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  background-color: #0d9b84 !important;
  border-color: #0d9b84 !important;
}
::ng-deep .mat-mdc-button[disabled][disabled] {
  pointer-events: none;
  opacity: 0.5;
}
::ng-deep .mat-mdc-raised-button,
::ng-deep .mat-mdc-unelevated-button,
::ng-deep .mat-mdc-outlined-button,
::ng-deep .mat-mdc-button {
  min-height: 2.625rem;
  border-radius: 0.625rem !important;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
  padding-inline: 1.25rem;
}
::ng-deep .mat-mdc-raised-button:not([disabled]),
::ng-deep .mat-mdc-unelevated-button:not([disabled]) {
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08), 0 2px 6px rgba(15, 23, 42, 0.06);
}
::ng-deep .mat-mdc-raised-button:not([disabled]):hover,
::ng-deep .mat-mdc-unelevated-button:not([disabled]):hover {
  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.1), 0 6px 16px rgba(15, 23, 42, 0.1);
}
::ng-deep .mat-mdc-outlined-button:not([disabled]) {
  border-color: rgba(15, 23, 42, 0.18);
}
::ng-deep .mat-mdc-outlined-button:not([disabled]):hover {
  border-color: #0d9b84;
  color: #0d9b84;
}
::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mdc-notched-outline__leading,
::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mdc-notched-outline__notch,
::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mdc-notched-outline__trailing {
  border-color: #99acc4;
}
::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined.mdc-text-field--focused .mdc-notched-outline__leading,
::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined.mdc-text-field--focused .mdc-notched-outline__notch,
::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined.mdc-text-field--focused .mdc-notched-outline__trailing {
  border-color: #0d9b84 !important;
  border-width: 1px !important;
}
::ng-deep .mdc-text-field--outlined .mdc-notched-outline__leading {
  border-start-start-radius: 0.5rem;
  border-end-start-radius: 0.5rem;
}
::ng-deep .mdc-text-field--outlined .mdc-notched-outline__trailing {
  border-start-end-radius: 0.5rem;
  border-end-end-radius: 0.5rem;
}
::ng-deep .mat-mdc-form-field.mat-focused .mat-mdc-floating-label {
  color: #0d9b84;
}
::ng-deep .mat-mdc-card {
  border-radius: 1rem;
  border: 1px solid rgba(15, 23, 42, 0.07);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 16px rgba(15, 23, 42, 0.06) !important;
}
::ng-deep .mat-mdc-tab .mdc-tab__text-label {
  font-weight: 600;
  letter-spacing: 0;
}

app-data-table {
  display: block;
  padding: 0 !important;
}
app-data-table table {
  position: relative;
  z-index: 0;
  border-collapse: separate !important;
  border-spacing: 0 1rem !important;
  background: transparent !important;
  box-shadow: none !important;
  height: fit-content;
  padding-inline-end: 4rem !important;
  padding-inline-start: 3rem !important;
}
@media only screen and (max-width: 768px) {
  app-data-table table {
    padding-inline-end: 1.25rem !important;
    padding-inline-start: 1.25rem !important;
  }
}
app-data-table table .mat-mdc-header-cell {
  text-align: center !important;
  color: #fff;
}
app-data-table table .mdc-data-table__cell {
  text-align: center !important;
  color: #051d30;
}
app-data-table table tr.mat-mdc-header-row {
  background-color: #0d9b84;
  position: sticky;
  position: -webkit-sticky; /* Safari */
  z-index: 100;
  top: 0;
}
app-data-table table th.mat-mdc-header-cell {
  border-top: none !important;
  border-bottom: none !important;
  background-color: #0d9b84;
  color: #fff !important;
  text-align: center;
  padding: 1rem 0;
  font-weight: 600 !important;
}
@media only screen and (max-width: 768px) {
  app-data-table table th.mat-mdc-header-cell {
    padding: 0;
  }
}
app-data-table table th.mat-mdc-header-cell .mat-sort-header-arrow {
  display: none !important;
}
app-data-table table th.mat-mdc-header-cell:first-child {
  border-start-start-radius: 0.5rem;
  border-end-start-radius: 0.5rem;
}
app-data-table table th.mat-mdc-header-cell:last-child {
  border-start-end-radius: 0.5rem;
  border-end-end-radius: 0.5rem;
}
app-data-table table td.mat-mdc-cell:first-child,
app-data-table table th.mat-mdc-header-cell:first-child {
  border-inline-start: none;
}
app-data-table table td.mat-mdc-cell:last-child,
app-data-table table th.mat-mdc-header-cell:last-child {
  border-inline-end: 1px solid #ccc;
}
app-data-table table tr.mat-mdc-row {
  background-color: #f9f9f9;
  position: relative;
  transition: background-color 0.15s ease-out;
}
app-data-table table tr.mat-mdc-row:nth-child(even) {
  background-color: #ffffff;
}
app-data-table table tr.mat-mdc-row:hover {
  background-color: rgba(13, 155, 132, 0.06) !important;
}
app-data-table table tr.mat-mdc-row.customRowActionFlag {
  cursor: pointer;
}
app-data-table table td.mat-mdc-cell {
  text-align: center;
  border-top: 1px solid #ccc !important;
  border-bottom: 1px solid #ccc !important;
  min-width: 10rem;
  padding: 0.05rem 1.875rem;
}
app-data-table table td.mat-mdc-cell img {
  object-fit: contain !important;
}
app-data-table table td.mat-mdc-cell .platformWidth {
  width: 15rem !important;
  min-width: auto;
  margin: auto;
}
app-data-table table td.mat-mdc-cell .data-text {
  padding: 1.25rem 0;
  direction: ltr;
  white-space: nowrap;
}
@media only screen and (max-width: 768px) {
  app-data-table table td.mat-mdc-cell .data-text {
    padding: 0;
  }
}
app-data-table table td.mat-mdc-cell .data-text.tooltip {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: auto;
}
app-data-table table td.mat-mdc-cell .data-text.bank-status[data-value=مفعل]::after {
  content: "مفعل";
  display: block;
  border: 0.5px solid #0d314d;
  background: rgba(7, 178, 126, 0.1);
  color: #0d314d;
}
app-data-table table td.mat-mdc-cell .data-text.bank-status[data-value="غير مفعل"]::after {
  content: "غير مفعل";
  display: block;
  border: 0.5px solid #f44336;
  background: rgba(186, 57, 57, 0.2);
  color: #f44336;
}
app-data-table table td.mat-mdc-cell .data-text.bank-status span {
  display: none;
}
app-data-table table td.mat-mdc-cell .isDisabled-rounded, app-data-table table td.mat-mdc-cell .isDisabled[data-value="0"]::after, app-data-table table td.mat-mdc-cell .isDisabled[data-value="1"]::after, app-data-table table td.mat-mdc-cell .data-text.bank-status[data-value=مفعل]::after, app-data-table table td.mat-mdc-cell .data-text.bank-status[data-value="غير مفعل"]::after {
  border-radius: 0.5rem !important;
  padding: 0.1875rem 0.4375rem;
  white-space: nowrap;
  width: 5rem;
  margin: auto;
}
app-data-table table td.mat-mdc-cell .isDisabled span {
  display: none;
}
app-data-table table td.mat-mdc-cell .isDisabled[data-value="1"]::after {
  content: "غير مفعل";
  display: block;
  border: 0.5px solid #f44336;
  background: rgba(186, 57, 57, 0.2);
  color: #f44336;
}
app-data-table table td.mat-mdc-cell .isDisabled[data-value="0"] .span {
  display: none;
}
app-data-table table td.mat-mdc-cell .isDisabled[data-value="0"]::after {
  content: "مفعل";
  display: block;
  border: 0.5px solid #0d314d;
  background: rgba(7, 178, 126, 0.1);
  color: #0d314d;
}
app-data-table table td.mat-mdc-cell .mat-mdc-select {
  display: flex;
  justify-content: center;
}
app-data-table table td.mat-mdc-cell .mat-mdc-select.mat-mdc-select-disabled .mat-mdc-select-value-text,
app-data-table table td.mat-mdc-cell .mat-mdc-select.mat-mdc-select-disabled .mat-mdc-select-arrow {
  color: #77797b !important;
  border-color: #77797b !important;
  pointer-events: none;
}
app-data-table table td.mat-mdc-cell .mat-mdc-select[aria-expanded=true] .mat-mdc-select-arrow {
  transform: rotate(-135deg) !important;
  -webkit-transform: rotate(-135deg);
  border-color: #0d9b84 !important;
}
app-data-table table td.mat-mdc-cell .mat-mdc-select .mat-mdc-select-value-text {
  color: #0d9b84 !important;
}
app-data-table table td.mat-mdc-cell .mat-mdc-select .mat-mdc-select-trigger {
  width: auto !important;
  gap: 0.5rem;
  position: unset;
}
app-data-table table td.mat-mdc-cell .mat-mdc-select .mat-mdc-select-arrow {
  position: unset;
  transform: rotate(45deg) !important;
  -webkit-transform: rotate(45deg);
  border: solid #0d9b84;
  border-width: 0 2px 2px 0;
  padding: 2.5px;
  width: unset !important;
  height: unset !important;
}
app-data-table table td.mat-mdc-cell .mat-mdc-select .mat-mdc-select-arrow svg {
  display: none !important;
}
app-data-table table td.mat-mdc-cell .inquiry_number,
app-data-table table td.mat-mdc-cell .question_number {
  color: #0d314d;
  background-color: rgba(7, 178, 126, 0.1);
  padding: 0 0.5rem;
  width: 30%;
  padding: 0 2rem;
  margin: auto;
  border-radius: 0.25rem;
}
app-data-table table td.mat-mdc-cell .inquiry_name {
  min-width: 30rem !important;
}
app-data-table table td.mat-mdc-cell .question_name {
  min-width: 25rem !important;
  width: 12rem !important;
}
app-data-table table .btn-show {
  margin: 0 !important;
}
app-data-table table .btn-show.customHover:hover {
  color: #0d9b84 !important;
}
app-data-table table .btn-show.mat-mdc-button .mdc-button__label, app-data-table table .btn-show.mat-mdc-unelevated-button .mdc-button__label, app-data-table table .btn-show.mat-mdc-raised-button .mdc-button__label, app-data-table table .btn-show.mat-mdc-outlined-button .mdc-button__label {
  max-width: 12rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
app-data-table table .btn-show.show-data {
  gap: 0.3125rem;
}
app-data-table table .btn-show.show-data::after {
  font-family: "Material Symbols Outlined";
  content: "\\e941";
  position: relative;
  display: block;
  font-size: 24px;
  transform: rotateZ(180deg);
  font-weight: 300;
}
app-data-table table .btn-show.show-profile {
  font-weight: 600;
  color: #0d9b84 !important;
}
app-data-table table .btn-show.show-profile:hover {
  color: #0d314d !important;
}
app-data-table table .btn-show.show-profile.mat-mdc-button .mdc-button__label, app-data-table table .btn-show.show-profile.mat-mdc-unelevated-button .mdc-button__label, app-data-table table .btn-show.show-profile.mat-mdc-raised-button .mdc-button__label, app-data-table table .btn-show.show-profile.mat-mdc-outlined-button .mdc-button__label {
  max-width: unset;
}
app-data-table table .btn-show.delete-admin {
  cursor: pointer;
}
app-data-table table .btn-show.delete-admin.condition {
  display: none !important;
}
app-data-table table .btn-show.delete-admin::after {
  font-family: "Material Symbols Outlined";
  content: "delete";
  position: relative;
  display: block;
  font-size: 32px;
  width: 32px;
  height: 32px;
  font-weight: 300;
  color: #f44336;
}
app-data-table table .btn-show.block-user {
  cursor: pointer;
}
app-data-table table .btn-show.block-user.condition::after {
  font-family: "Material Symbols Outlined";
  content: "lock_open_right";
  position: relative;
  display: block;
  font-size: 32px;
  width: 32px;
  height: 32px;
  font-weight: 300;
  color: #0d314d;
}
app-data-table table .btn-show.block-user::after {
  font-family: "Material Symbols Outlined";
  content: "lock";
  position: relative;
  display: block;
  font-size: 32px;
  width: 32px;
  height: 32px;
  font-weight: 300;
  color: #f44336;
}
app-data-table .mat-divider {
  display: none;
}
app-data-table .content-page-header {
  width: 100% !important;
  margin-right: unset !important;
  margin-bottom: 4.375rem !important;
  margin-left: unset !important;
  padding-inline-start: 3rem !important;
  padding-inline-end: 5rem !important;
}
@media only screen and (max-width: 768px) {
  app-data-table .content-page-header {
    padding: 1.25rem 0;
    margin-bottom: 1.25rem !important;
    padding-inline-end: 1.25rem !important;
    padding-inline-start: 1.25rem !important;
  }
}
app-data-table .content-page-header .contents {
  padding: unset !important;
  gap: 8rem;
  align-items: flex-start !important;
}
@media only screen and (max-width: 768px) {
  app-data-table .content-page-header .contents {
    flex-direction: column !important;
    position: relative;
    gap: 1rem !important;
    align-items: flex-start !important;
  }
  app-data-table .content-page-header .contents .header-title h2 {
    white-space: normal !important;
  }
}
app-data-table .content-page-header .contents .header-title h2 {
  color: #0d314d !important;
  font-size: 2rem !important;
  font-weight: 700 !important;
  line-height: 1.4 !important;
  white-space: nowrap;
  letter-spacing: -0.01em;
  position: relative;
  padding-bottom: 0.4rem;
}
app-data-table .content-page-header .contents .header-title h2::after {
  content: "";
  position: absolute;
  bottom: 0;
  inset-inline-start: 0;
  width: 2.5rem;
  height: 3px;
  background: #0d9b84;
  border-radius: 2px;
}
app-data-table .content-page-header .contents .k-ng-search {
  width: 28%;
}
app-data-table .content-page-header .contents .k-ng-search .search-btn {
  position: absolute;
  left: -8rem;
  bottom: -0.2rem;
  background-color: #0d9b84 !important;
}
@media only screen and (max-width: 768px) {
  app-data-table .content-page-header .contents .k-ng-search .search-btn {
    bottom: 4px !important;
    left: -7rem !important;
  }
}
app-data-table .content-page-header .contents .k-ng-search mat-form-field {
  width: 100%;
}
app-data-table .content-page-header .contents .k-ng-search mat-form-field .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mat-mdc-form-field-infix {
  gap: 0.4rem;
}
app-data-table .content-page-header .contents .k-ng-search mat-form-field.ng-touch.ng-invalid.ng-dirty.mat-form-field-invalid.ng-touched .mdc-notched-outline.mdc-notched-outline--no-label.mdc-notched-outline--notched {
  border-color: #f44336 !important;
  border-radius: 0.5rem !important;
  border-width: 1px !important;
}
app-data-table .content-page-header .contents .k-ng-search mat-form-field input::placeholder {
  color: #77797b;
  font-size: 1.1rem !important;
}
app-data-table .content-page-header .contents .k-ng-search mat-icon {
  font-family: "Material Symbols Outlined";
  color: #77797b;
  font-size: 20px;
  height: 20px;
  width: 20px;
}
app-data-table .content-page-header .contents .k-ng-search mat-icon.search-icon {
  cursor: pointer;
}
app-data-table .content-page-header .contents .k-ng-search mat-icon.close-icon {
  color: #0d314d !important;
  cursor: pointer;
}
@media only screen and (max-width: 768px) {
  app-data-table .content-page-header .contents .k-ng-search {
    width: 75%;
  }
}
app-data-table .content-page-header .contents .k-ng-filter mat-form-field .mat-mdc-text-field-wrapper {
  height: 3rem;
}
app-data-table .content-page-header .contents .header-actions {
  gap: 0.75rem !important;
  justify-content: space-between;
  align-items: flex-start;
}
@media only screen and (max-width: 768px) {
  app-data-table .content-page-header .contents .header-actions .k-ng-filter {
    margin-inline-end: auto;
  }
}
app-data-table .content-page-header .contents .header-actions .add {
  margin-left: 0.5rem;
  width: 50%;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.42);
}
app-data-table .content-page-header .contents .header-actions .btn {
  height: 3rem !important;
  width: max-content;
  padding: 0 1rem !important;
}
app-data-table .content-page-header .contents .header-actions .btn.delete-maqare {
  border: 1px solid #f44336 !important;
  color: #f44336 !important;
  background-color: #fff !important;
}
app-data-table .content-page-header .contents .header-actions .btn.date-filter {
  border: 1px solid #0d9b84 !important;
  color: #0d9b84 !important;
  background-color: #fff !important;
}
app-data-table .content-page-header .contents .header-actions .btnActions-resp .mat-mdc-button mat-icon {
  margin: 0 !important;
  color: #0d9b84;
  font-size: 1.5rem;
  height: 1.5rem;
  width: 1.5rem;
}
app-data-table .content-page-header .contents .header-actions .btnActions-resp .mdc-button {
  min-width: unset !important;
  padding: 0 !important;
  position: absolute;
  top: 0;
  left: 0 !important;
  right: unset !important;
}
app-data-table .content-page-body {
  width: 100% !important;
  max-width: 1400px;
  margin-inline: auto;
}
@media only screen and (max-width: 1024px) {
  app-data-table .content-page-body {
    max-width: 100%;
  }
}
@media only screen and (max-width: 768px) {
  app-data-table .content-page-body {
    margin-block-end: 5rem !important;
  }
}
app-data-table .content-page-body .empty-state {
  flex-direction: column;
  padding-top: 6.25rem;
  flex-direction: column;
  gap: 3rem;
  color: #07213c;
}
app-data-table .content-page-body .empty-state figure img {
  display: block;
  width: 100%;
}
app-data-table .content-page-body .empty-state .message {
  color: #77797b;
}
app-data-table .content-page-body .table-loading-spinner {
  padding-top: 7.5rem !important;
}
app-data-table .content-page-body .table-border {
  min-height: 60vh;
  max-height: 70vh !important;
  margin-inline-end: 5rem;
}
app-data-table .content-page-body .table-border.scroll_width {
  margin-inline-end: 0 !important;
  max-width: 100%;
  padding: 0 !important;
  overflow: auto;
  padding-bottom: 2rem !important;
}
app-data-table .content-page-body .table-border.scroll_width:hover {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
app-data-table .content-page-body .table-border.scroll_width::-webkit-scrollbar {
  width: 0.8rem !important;
  height: 0.8rem !important;
}
@media only screen and (max-width: 1280px) {
  app-data-table .content-page-body .table-border.scroll_width {
    overflow: auto;
  }
}
@media only screen and (min-width: 769px) and (max-height: 750px) {
  app-data-table .content-page-body .table-border {
    max-height: 63vh !important;
    padding-inline-end: 1rem;
  }
}
@media only screen and (min-width: 769px) and (max-height: 650px) {
  app-data-table .content-page-body .table-border {
    max-height: 55vh !important;
  }
}
@media only screen and (max-width: 768px) {
  app-data-table .content-page-body .table-border {
    min-height: unset !important;
    max-height: unset !important;
    height: auto !important;
  }
}
app-data-table app-pagination {
  padding: 0.5rem 0 2rem;
  width: 85%;
  position: fixed !important;
}
@media only screen and (max-width: 768px) {
  app-data-table app-pagination {
    position: relative !important;
    width: 100%;
    padding: 0 !important;
  }
}
app-data-table app-pagination .pagination {
  position: relative;
  bottom: 0rem;
  background: #fff;
  padding: 0.6875rem 0 0 0;
  padding-inline-end: 5.25rem;
}
@media only screen and (max-width: 768px) {
  app-data-table app-pagination .pagination {
    flex-direction: column;
    padding: 1.25rem 0;
    width: 100%;
    gap: 0.5rem !important;
    bottom: 0rem !important;
  }
}
app-data-table app-pagination .pagination-action {
  margin-inline-start: 3rem !important;
}
@media only screen and (max-width: 768px) {
  app-data-table app-pagination .pagination-action {
    width: 100%;
    justify-content: center !important;
    padding: 0 1rem;
    margin-inline-start: 0rem !important;
  }
}
app-data-table app-pagination .pagination__btn {
  color: #051d30;
  background: #fff !important;
  padding: 0.5rem;
}
app-data-table app-pagination .pagination__btn:hover {
  background: rgba(80, 153, 209, 0.04) !important;
  border-radius: 0.5rem;
  color: #0d9b84 !important;
}
app-data-table app-pagination .pagination__toggle-btns {
  background-color: transparent !important;
  border: none !important;
  color: #fff;
}
app-data-table app-pagination .pagination__toggle-btns__dots {
  color: #051d30;
  pointer-events: none;
}
app-data-table app-pagination .pagination__toggle-btns__btn {
  border-radius: 0.5rem;
  height: 2rem;
  width: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.5rem;
  color: #051d30;
}
app-data-table app-pagination .pagination__toggle-btns__btn:hover {
  background-color: white !important;
  --mat-standard-button-toggle-hover-state-layer-opacity: 0 !important;
  --mat-standard-button-toggle-focus-state-layer-opacity: 0 !important;
}
app-data-table app-pagination .pagination__toggle-btns__btn__active {
  background-color: #0d314d !important;
  color: #fff !important;
  padding: 0 !important;
}
app-data-table app-pagination .pagination__toggle-btns__btn__active:hover {
  background-color: #0d314d !important;
}
app-data-table app-pagination .pagination__toggle-btns .mat-button-toggle-appearance-standard .mat-button-toggle-label-content {
  padding: 0 !important;
}
app-data-table app-pagination .pagination-count {
  color: #77797b;
  word-spacing: 0.1rem;
  font-size: 1rem;
  line-height: 2rem;
  font-weight: 400;
}
@media only screen and (max-width: 768px) {
  app-data-table app-pagination .pagination-count {
    display: none !important;
  }
}
app-data-table app-pagination .disabled {
  pointer-events: none;
  color: #77797b !important;
}

::ng-deep .tooltiptext {
  background-color: #323232 !important;
  color: #fff !important;
  text-align: center;
  border-radius: 0.5rem;
  padding: 0.5rem;
  width: 100%;
}
::ng-deep .tooltiptext.tooltipSearch {
  top: -1rem;
}
::ng-deep .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #323232 transparent transparent transparent;
}
::ng-deep .mat-mdc-tooltip .mdc-tooltip__surface {
  background-color: #323232 !important;
  color: #fff !important;
  padding: 0 !important;
  text-align: center !important;
  max-width: 31.25rem;
  max-height: 18.75rem;
  overflow-y: auto;
  scrollbar-color: #fff transparent !important;
  padding: 0 1rem !important;
}
::ng-deep .mat-mdc-tooltip .mdc-tooltip__surface::-webkit-scrollbar {
  width: 0.2rem;
}
::ng-deep .mat-mdc-tooltip .mdc-tooltip__surface::-webkit-scrollbar-track {
  background: #77797b !important;
}
::ng-deep .mat-mdc-tooltip .mdc-tooltip__surface::-webkit-scrollbar-thumb {
  background: #fff !important;
}
::ng-deep .cdk-overlay-pane.selectCustomClass {
  width: auto !important;
}
::ng-deep .cdk-overlay-pane.selectCustomClass.selectLevelClass, ::ng-deep .cdk-overlay-pane.selectCustomClass.selectFilterClass {
  width: 100% !important;
}
::ng-deep .cdk-overlay-pane .selectCustomClass {
  border-radius: 0.5rem !important;
  background: #f9f9f9 !important;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.42) !important;
  padding: 0 !important;
  direction: rtl !important;
}
::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option,
::ng-deep .cdk-overlay-pane .selectCustomClass mat-mdc-option {
  border-bottom: 0.25px solid #c0c0c0;
  direction: rtl !important;
}
::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option .mdc-list-item__primary-text,
::ng-deep .cdk-overlay-pane .selectCustomClass mat-mdc-option .mdc-list-item__primary-text {
  white-space: nowrap;
}
::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option .mat-pseudo-checkbox-minimal,
::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option mat-pseudo-checkbox,
::ng-deep .cdk-overlay-pane .selectCustomClass mat-mdc-option .mat-pseudo-checkbox-minimal,
::ng-deep .cdk-overlay-pane .selectCustomClass mat-mdc-option mat-pseudo-checkbox {
  margin-left: unset !important;
  margin-inline-end: 1rem;
  display: none !important;
}
::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option:hover,
::ng-deep .cdk-overlay-pane .selectCustomClass mat-mdc-option:hover {
  background-color: transparent !important;
}
::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option:last-child, ::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option:first-child,
::ng-deep .cdk-overlay-pane .selectCustomClass mat-mdc-option:last-child,
::ng-deep .cdk-overlay-pane .selectCustomClass mat-mdc-option:first-child {
  border: none !important;
}
::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option:first-child,
::ng-deep .cdk-overlay-pane .selectCustomClass mat-mdc-option:first-child {
  display: none !important;
}
::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option.canCloseFlag, ::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option.canActionFlag,
::ng-deep .cdk-overlay-pane .selectCustomClass mat-mdc-option.canCloseFlag,
::ng-deep .cdk-overlay-pane .selectCustomClass mat-mdc-option.canActionFlag {
  pointer-events: none;
  opacity: 0.5;
}
::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option.mat-mdc-active,
::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled),
::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option.mat-mdc-selected:not(.mat-mdc-option-disabled),
::ng-deep .cdk-overlay-pane .selectCustomClass .mdc-list-item--selected.mdc-list-item--disabled {
  background-color: transparent !important;
}
::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option .mat-mdc-option-ripple {
  display: none;
}
::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text {
  color: unset;
}
::ng-deep .cdk-overlay-pane .selectCustomClass.selectLevelClass .mat-mdc-option,
::ng-deep .cdk-overlay-pane .selectCustomClass.selectLevelClass mat-mdc-option {
  border-bottom: 0.25px solid #c0c0c0 !important;
}
::ng-deep .cdk-overlay-pane .selectCustomClass.selectLevelClass .mat-mdc-option-multiple,
::ng-deep .cdk-overlay-pane .selectCustomClass.selectLevelClass mat-mdc-option-multiple {
  flex-direction: row-reverse;
}
::ng-deep .cdk-overlay-pane .selectCustomClass.selectLevelClass .mat-mdc-option .mdc-list-item__primary-text,
::ng-deep .cdk-overlay-pane .selectCustomClass.selectLevelClass mat-mdc-option .mdc-list-item__primary-text {
  color: #07213c !important;
  line-height: unset !important;
  background-color: transparent !important;
}
::ng-deep .cdk-overlay-pane .selectCustomClass.selectLevelClass .mat-mdc-option:first-child,
::ng-deep .cdk-overlay-pane .selectCustomClass.selectLevelClass mat-mdc-option:first-child {
  display: flex !important;
  border-bottom: 0.25px solid #c0c0c0 !important;
}
::ng-deep .cdk-overlay-pane .selectCustomClass.selectLevelClass .mat-mdc-option:last-child,
::ng-deep .cdk-overlay-pane .selectCustomClass.selectLevelClass mat-mdc-option:last-child {
  border: none !important;
}
::ng-deep .cdk-overlay-pane .selectCustomClass.selectLevelClass .mat-mdc-option.mat-mdc-active,
::ng-deep .cdk-overlay-pane .selectCustomClass.selectLevelClass .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled),
::ng-deep .cdk-overlay-pane .selectCustomClass.selectLevelClass .mat-mdc-option.mat-mdc-selected:not(.mat-mdc-option-disabled) {
  margin: 0 !important;
  padding: 0 1.5rem !important;
  background-color: #ddeaf3 !important;
}
::ng-deep .cdk-overlay-pane .selectCustomClass.selectClass .mat-mdc-option .mat-pseudo-checkbox-minimal,
::ng-deep .cdk-overlay-pane .selectCustomClass.selectClass .mat-mdc-option mat-pseudo-checkbox,
::ng-deep .cdk-overlay-pane .selectCustomClass.selectClass mat-mdc-option .mat-pseudo-checkbox-minimal,
::ng-deep .cdk-overlay-pane .selectCustomClass.selectClass mat-mdc-option mat-pseudo-checkbox {
  display: block !important;
  background: #fff !important;
  border: 1.5px solid #0d9b84 !important;
}
::ng-deep .cdk-overlay-pane .selectCustomClass.selectClass .mat-mdc-option .mat-pseudo-checkbox-minimal::after,
::ng-deep .cdk-overlay-pane .selectCustomClass.selectClass .mat-mdc-option mat-pseudo-checkbox::after,
::ng-deep .cdk-overlay-pane .selectCustomClass.selectClass mat-mdc-option .mat-pseudo-checkbox-minimal::after,
::ng-deep .cdk-overlay-pane .selectCustomClass.selectClass mat-mdc-option mat-pseudo-checkbox::after {
  color: #0d9b84 !important;
}
::ng-deep .cdk-overlay-pane .phoneClass {
  width: 40% !important;
}
::ng-deep .cdk-overlay-pane .matMenuClass .mat-mdc-menu-content {
  padding: 0 !important;
}
::ng-deep .cdk-overlay-pane .matMenuClass .mat-mdc-menu-item {
  padding: 0 1rem !important;
  border: none !important;
  border-bottom: 0.25px solid #c0c0c0 !important;
  display: flex;
  justify-content: center !important;
  width: 100% !important;
  background-color: transparent !important;
  border-radius: 0 !important;
  direction: rtl;
}
::ng-deep .cdk-overlay-pane .matMenuClass .mat-mdc-menu-item mat-icon {
  order: 2;
  color: #0d314d !important;
}
::ng-deep .cdk-overlay-pane .matMenuClass .mat-mdc-menu-item:last-child {
  border: none;
}
::ng-deep .cdk-overlay-pane .matMenuClass .mat-mdc-menu-item:not([disabled]):hover {
  background-color: transparent !important;
}
::ng-deep .cdk-overlay-pane .matMenuClass .mat-mdc-menu-ripple {
  display: none;
}
::ng-deep .cdk-overlay-pane .matMenuClass .mat-mdc-menu-item-text {
  color: #051d30 !important;
}
::ng-deep .mat-mdc-form-field-icon-suffix .mat-icon {
  padding: 0 !important;
}

.filter-page {
  position: relative;
}
.filter-page_main {
  grid-template-columns: 4fr 1fr;
  margin: 0 auto;
  width: 100%;
  padding: 0.5rem 3rem;
}
@media only screen and (max-width: 768px) {
  .filter-page_main {
    padding: 0.5rem 1rem;
  }
}
.filter-page_main_header {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 768px) {
  .filter-page_main_header {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 0.5rem;
  }
}
.filter-page_main_header h4 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #051d30;
  margin-left: 1rem;
}
.filter-page_main_header_badges {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 1.5rem;
}
@media only screen and (max-width: 768px) {
  .filter-page_main_header_badges {
    gap: 0;
  }
}
.filter-page_main_header_badges .badge {
  height: 3rem;
  width: fit-content;
  border-radius: 1.5rem;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1019607843);
  min-width: 14rem;
  display: grid;
  place-items: center;
  font-size: 1.25rem;
  position: relative;
  color: #051d30;
  padding: 0 2rem;
  margin: 0 1rem;
  background: white;
}
@media only screen and (max-width: 768px) {
  .filter-page_main_header_badges .badge {
    padding: 0 0.5rem;
    font-size: 1rem;
    min-width: 10rem;
  }
}
.filter-page_main_header_badges .badge .close-btn {
  position: absolute !important;
  top: -0.5rem;
  left: -0.5rem;
  font-size: 1rem;
  height: 1.25rem;
  width: 1.25rem;
  background-color: #051d30;
  border-radius: 50%;
  color: white;
  cursor: pointer;
}
.filter-page_main_header_badges .badge .close-btn:hover {
  background-color: #0d314d;
}
.filter-page_main_content {
  width: 73%;
}
.filter-page.filterBody app-data-table .content-page-header {
  margin-bottom: 0.5rem !important;
}
.filter-page.filterBody app-data-table .content-page-header .k-ng-filter {
  top: 0rem;
}

.meetings app-data-table .content-page-header .contents .k-ng-filter {
  position: absolute;
  top: 4rem;
  left: 5rem;
  right: unset;
}
.meetings app-data-table .content-page-header .contents .k-ng-filter .mat-mdc-form-field {
  width: 22.2rem;
}
@media only screen and (max-width: 1400px) {
  .meetings app-data-table .content-page-header .contents .k-ng-filter {
    left: 3.5rem;
  }
}
@media only screen and (max-width: 768px) {
  .meetings app-data-table .content-page-header .contents .k-ng-filter {
    position: relative !important;
    top: unset;
    left: unset;
    right: unset;
  }
}

html[dir=ltr] app-data-table table .btn-show.show-data::after {
  transform: unset !important;
}
html[dir=ltr] app-data-table .content-page-header .contents .k-ng-search .search-btn {
  right: -8rem;
  bottom: 1px !important;
  left: unset !important;
}
html[dir=ltr] app-data-table .content-page-header .contents .header-actions .btnActions-resp .mdc-button {
  left: unset !important;
  right: 0 !important;
}
html[dir=ltr] app-data-table .content-page-header .contents .k-ng-filter {
  left: unset;
  right: 5rem;
}
html[dir=ltr] app-data-table .content-page-header .contents .k-ng-filter .mat-mdc-form-field {
  width: 20.5rem;
}
@media only screen and (max-width: 1400px) {
  html[dir=ltr] app-data-table .content-page-header .contents .k-ng-filter {
    right: 5rem;
    left: unset;
  }
}
html[dir=ltr] app-data-table app-pagination .pagination__btn .arrow {
  transform: rotate(180deg) !important;
}
html[dir=ltr] app-data-table app-pagination .pagination__btn .arrow.arrow_left {
  transform: rotate(0deg) !important;
}
html[dir=ltr] .cdk-overlay-pane {
  direction: rtl;
}
html[dir=ltr] .cdk-overlay-pane .selectCustomClass {
  direction: ltr !important;
}
html[dir=ltr] .cdk-overlay-pane .selectCustomClass .mat-mdc-option,
html[dir=ltr] .cdk-overlay-pane .selectCustomClass mat-mdc-option {
  direction: ltr !important;
  padding: 0 1.5rem !important;
}
html[dir=ltr] .cdk-overlay-pane .phoneClass {
  direction: ltr;
}
html[dir=ltr] .meetings app-data-table .content-page-header .contents .k-ng-filter {
  left: unset;
  right: 5rem;
}
html[dir=ltr] .meetings app-data-table .content-page-header .contents .k-ng-filter .mat-mdc-form-field {
  width: 20.5rem;
}
@media only screen and (max-width: 1400px) {
  html[dir=ltr] .meetings app-data-table .content-page-header .contents .k-ng-filter {
    right: 5rem;
    left: unset;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: none;
  scrollbar-width: thin !important;
  scrollbar-color: rgba(100, 169, 222, 0.3) #e5e7e8 !important;
}
@media only screen and (max-width: 768px) {
  * {
    scrollbar-color: rgba(100, 169, 222, 0.3) #e5e7e8 !important;
  }
}

::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
}

::-webkit-scrollbar-track {
  background: #e5e7e8;
  border-radius: 2rem;
}

::-webkit-scrollbar-thumb {
  background: rgba(100, 169, 222, 0.3);
  border-radius: 2rem;
  transition: width 0.3s ease;
  -webkit-transition: width 0.3s ease;
  -moz-transition: width 0.3s ease;
  -ms-transition: width 0.3s ease;
  -o-transition: width 0.3s ease;
  -webkit-border-radius: 2rem;
  -moz-border-radius: 2rem;
  -ms-border-radius: 2rem;
  -o-border-radius: 2rem;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(100, 169, 222, 0.3);
}

@media only screen and (max-width: 768px) {
  ::-webkit-scrollbar {
    width: 0.3rem;
    height: 0.3rem;
  }
  ::-webkit-scrollbar-track {
    background: secondary-color-opacity-5;
  }
  ::-webkit-scrollbar-thumb {
    background: secondary-color-opacity-5;
  }
}
html,
body {
  height: 100%;
  overflow: hidden;
}

html[dir=rtl] {
  direction: rtl !important;
}
html[dir=rtl] .mat-dialog-container,
html[dir=rtl] .mat-calendar-header,
html[dir=rtl] .mdc-dialog__container {
  direction: rtl !important;
}
html[dir=ltr] {
  direction: ltr !important;
}
html[dir=ltr] .mat-dialog-container,
html[dir=ltr] .mat-calendar-header,
html[dir=ltr] .mdc-dialog__container {
  direction: ltr !important;
}

img {
  width: 100%;
  display: block;
}

a {
  text-decoration: none;
  cursor: pointer;
}

a,
h1,
h2,
h3,
span,
table,
td,
tr,
button,
input,
li,
ul,
label,
div,
pre {
  font-family: "Tajawal", sans-serif;
}

ul {
  list-style: none;
}

.display-large {
  font-size: 4rem !important;
  line-height: 5.875rem !important;
  font-weight: 700 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.display-large-2 {
  font-size: 2.5rem !important;
  line-height: 4.25rem !important;
  font-weight: 700 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.display-semiBold {
  font-size: 3rem !important;
  line-height: 4.5rem !important;
  font-weight: 600 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.display-semiBold-2 {
  font-size: 2.5rem !important;
  line-height: 4.25rem !important;
  font-weight: 600 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.display-medium {
  font-size: 3rem !important;
  line-height: 4.5rem !important;
  font-weight: 700 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.display-medium-2 {
  font-size: 2.5rem !important;
  line-height: 4.25rem !important;
  font-weight: 500 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.display-small {
  font-size: 3rem !important;
  line-height: 4.5rem !important;
  font-weight: 500 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.display-small {
  font-size: 2.5rem !important;
  line-height: 4rem !important;
  font-weight: 400 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.headline-large {
  font-size: 2.25rem !important;
  line-height: 3.75rem !important;
  font-weight: 700 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.headline-large-2 {
  font-size: 2rem !important;
  line-height: 3.5rem !important;
  font-weight: 700 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.headline-semiBold {
  font-size: 2.25rem !important;
  line-height: 3.75rem !important;
  font-weight: 600 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.headline-semiBold-2 {
  font-size: 2rem !important;
  line-height: 3.5rem !important;
  font-weight: 600 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.headline-medium {
  font-size: 2.25rem !important;
  line-height: 3.75rem !important;
  font-weight: 500 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.headline-medium-2 {
  font-size: 2rem !important;
  line-height: 3.5rem !important;
  font-weight: 500 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.headline-small {
  font-size: 2.25rem !important;
  line-height: 3.75rem !important;
  font-weight: 400 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.headline-small-2 {
  font-size: 1.875rem !important;
  line-height: 3.5rem !important;
  font-weight: 400 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.title-large {
  font-size: 1.75rem !important;
  line-height: 3.5rem !important;
  font-weight: 700 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.title-large-2 {
  font-size: 1.5rem !important;
  line-height: 3rem !important;
  font-weight: 700 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.title-large-3, app-data-table table .btn-show.show-data {
  font-size: 1.375rem !important;
  line-height: 2.5rem !important;
  font-weight: 700 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.title-semiBold {
  font-size: 1.75rem !important;
  line-height: 3.5rem !important;
  font-weight: 600 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.title-semiBold-2 {
  font-size: 1.5rem !important;
  line-height: 3rem !important;
  font-weight: 600 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.title-semiBold-3 {
  font-size: 1.375rem !important;
  line-height: 2.5rem !important;
  font-weight: 600 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.title-medium {
  font-size: 1.75rem !important;
  line-height: 3.5rem !important;
  font-weight: 500 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.title-medium-2 {
  font-size: 1.5rem !important;
  line-height: 3rem !important;
  font-weight: 500 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.title-medium-3, app-data-table table td.mat-mdc-cell .inquiry_number,
app-data-table table td.mat-mdc-cell .question_number {
  font-size: 1.375rem !important;
  line-height: 2.5rem !important;
  font-weight: 500 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.title-small {
  font-size: 1.75rem !important;
  line-height: 3.5rem !important;
  font-weight: 400 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.title-small-2 {
  font-size: 1.5rem !important;
  line-height: 3rem !important;
  font-weight: 400 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.title-small-3 {
  font-size: 1.375rem !important;
  line-height: 2.5rem !important;
  font-weight: 400 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.label-large, .btn-secondary {
  font-size: 1.25rem !important;
  line-height: 2.375rem !important;
  font-weight: 700 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.label-large-2 {
  font-size: 1.125rem !important;
  line-height: 2.25rem !important;
  font-weight: 700 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.label-semiBold, .menu-card.lang-btn span {
  font-size: 1.25rem !important;
  line-height: 2.375rem !important;
  font-weight: 600 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.label-semiBold-2 {
  font-size: 1.125rem !important;
  line-height: 2.25rem !important;
  font-weight: 600 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.label-medium, .btn-cancel, .btn-primary-outline, .btn-primary, app-data-table table .mat-mdc-header-cell, app-data-table table .mdc-data-table__cell {
  font-size: 1.25rem !important;
  line-height: 2.375rem !important;
  font-weight: 500 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.label-medium-2, .field input, .success-snackbar.mat-mdc-snack-bar-container .mdc-snackbar__surface .mdc-snackbar__label, .error-snackbar.mat-mdc-snack-bar-container .mdc-snackbar__surface .mdc-snackbar__label, app-data-table .content-page-body .empty-state .message {
  font-size: 1.125rem !important;
  line-height: 2.25rem !important;
  font-weight: 500 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.label-small {
  font-size: 1.25rem !important;
  line-height: 2.375rem !important;
  font-weight: 400 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.label-small-2 {
  font-size: 1.125rem !important;
  line-height: 2.25rem !important;
  font-weight: 400 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.body-large {
  font-size: 1rem !important;
  line-height: 2rem !important;
  font-weight: 700 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.body-large-2 {
  font-size: 0.875rem !important;
  line-height: 1.625rem !important;
  font-weight: 700 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.body-large-3 {
  font-size: 0.75rem !important;
  line-height: 1.5rem !important;
  font-weight: 700 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.body-semiBold {
  font-size: 1rem !important;
  line-height: 2rem !important;
  font-weight: 600 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.body-semiBold-2 {
  font-size: 0.875rem !important;
  line-height: 1.625rem !important;
  font-weight: 600 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.body-semiBold-3 {
  font-size: 0.75rem !important;
  line-height: 1.5rem !important;
  font-weight: 600 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.body-medium-lg {
  font-size: 1.25rem !important;
  line-height: 2rem !important;
  font-weight: 500 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.body-medium, app-data-table .content-page-header .contents .k-ng-search mat-form-field input::placeholder, app-data-table app-pagination .pagination__btn, ::ng-deep .tooltiptext, ::ng-deep .mat-mdc-tooltip .mdc-tooltip__surface {
  font-size: 1rem !important;
  line-height: 2rem !important;
  font-weight: 500 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.body-medium-2, .payment-status, .res-status, .inquiry_status, app-data-table table td.mat-mdc-cell .inquiry_status, app-data-table table td.mat-mdc-cell .isDisabled-rounded, app-data-table table td.mat-mdc-cell .data-text.bank-status[data-value=مفعل]::after, app-data-table table td.mat-mdc-cell .data-text.bank-status[data-value="غير مفعل"]::after, app-data-table table td.mat-mdc-cell .isDisabled[data-value="1"]::after, app-data-table table td.mat-mdc-cell .isDisabled[data-value="0"]::after {
  font-size: 0.875rem !important;
  line-height: 1.625rem !important;
  font-weight: 500 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.body-medium-3 {
  font-size: 0.75rem !important;
  line-height: 1.5rem !important;
  font-weight: 500 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.body-small-lg, .field__label {
  font-size: 1.25rem !important;
  line-height: 2.25rem !important;
  font-weight: 400 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.body-small, .field__label__required, app-data-table app-pagination .pagination__toggle-btns__dots, app-data-table app-pagination .pagination__toggle-btns__btn, ::ng-deep .cdk-overlay-pane .selectCustomClass .mat-mdc-option,
::ng-deep .cdk-overlay-pane .selectCustomClass mat-mdc-option, ::ng-deep .cdk-overlay-pane .selectCustomClass.selectLevelClass .mat-mdc-option .mdc-list-item__primary-text,
::ng-deep .cdk-overlay-pane .selectCustomClass.selectLevelClass mat-mdc-option .mdc-list-item__primary-text, ::ng-deep .cdk-overlay-pane .matMenuClass .mat-mdc-menu-item-text {
  font-size: 1rem !important;
  line-height: 2rem !important;
  font-weight: 400 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.body-small-2 {
  font-size: 0.875rem !important;
  line-height: 1.625rem !important;
  font-weight: 400 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.body-small-3 {
  font-size: 0.75rem !important;
  line-height: 1.5rem !important;
  font-weight: 400 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.body-small-4 {
  font-size: 0.625rem !important;
  line-height: 1.5rem !important;
  font-weight: 400 !important;
  font-family: "Tajawal", sans-serif;
  letter-spacing: 0 !important;
}

.d-flex, .d-flex-between, .btn-primary, .d-flex-center, .menu-card.lang-btn mat-icon, .payment-status, .res-status, .inquiry_status, app-data-table table td.mat-mdc-cell .inquiry_status, .btn-primary mat-icon, app-data-table table td.mat-mdc-cell .inquiry_number,
app-data-table table td.mat-mdc-cell .question_number, app-data-table .content-page-body .empty-state, app-data-table .content-page-body .table-loading-spinner, .filter-page_main_header_badges .badge .close-btn {
  display: flex !important;
  align-items: center;
}

.d-flex-center, .menu-card.lang-btn mat-icon, .payment-status, .res-status, .inquiry_status, app-data-table table td.mat-mdc-cell .inquiry_status, .btn-primary mat-icon, app-data-table table td.mat-mdc-cell .inquiry_number,
app-data-table table td.mat-mdc-cell .question_number, app-data-table .content-page-body .empty-state, app-data-table .content-page-body .table-loading-spinner, .filter-page_main_header_badges .badge .close-btn {
  justify-content: center;
}

.d-flex-between, .btn-primary {
  justify-content: space-between;
}

.field {
  display: flex;
  flex-direction: column;
  font-weight: normal;
  margin-top: 2rem;
  text-align: start;
}
.field input {
  color: #07213c;
}
.field__label {
  color: #07213c;
}
.field__label__required {
  color: #f44336;
  font-size: 2rem;
}
.field .error {
  color: #f44336;
}

.btn {
  height: 3.25rem !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.625rem;
  width: 100%;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-out;
}
.btn:hover {
  transform: translateY(-1px);
}
.btn:active {
  transform: translateY(0);
}

.btn-secondary {
  background: #0d314d;
  box-shadow: 0 2px 8px rgba(13, 49, 77, 0.2);
  color: #fff !important;
}
.btn-secondary:hover {
  box-shadow: 0 4px 12px rgba(13, 49, 77, 0.3);
}

.btn-primary {
  background-color: #0d9b84 !important;
  border-radius: 0.625rem !important;
  padding: 0.5rem !important;
  color: #fff !important;
  width: auto;
  gap: 0.5rem;
  direction: ltr;
  box-shadow: 0 2px 8px rgba(13, 155, 132, 0.2);
}
.btn-primary mat-icon {
  font-size: 1.25rem !important;
  height: 1.25rem !important;
  width: 1.25rem !important;
  margin: 0 !important;
}

.btn-primary-outline {
  color: #0d9b84 !important;
  border: 1px solid #0d9b84 !important;
  background-color: transparent !important;
  gap: 0.5rem;
  white-space: nowrap;
  justify-content: center !important;
}
.btn-primary-outline::after {
  font-family: "Material Symbols Outlined";
  content: "download";
  position: relative;
  display: block;
  font-size: 1.375rem;
  font-weight: 400;
  color: #0d9b84;
}

.btn-cancel {
  color: #07213c !important;
  background-color: transparent !important;
}

.gap-1 {
  gap: 1.5rem;
}

.disabled {
  pointer-events: none;
  color: #77797b !important;
  opacity: 0.5;
}

.disabled-header {
  pointer-events: none;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.inquiry_status, app-data-table table td.mat-mdc-cell .inquiry_status {
  border-radius: 0.5rem !important;
  padding: 0.1875rem 0.4375rem;
  white-space: nowrap;
  width: 6rem;
  margin: auto;
  border: 0.5px solid;
}
.inquiry_status[data-value=active], app-data-table table td.mat-mdc-cell [data-value=active].inquiry_status {
  border-color: #0d314d;
  color: #0d314d;
  background: rgba(7, 178, 126, 0.1);
}
.inquiry_status[data-value=initiated], app-data-table table td.mat-mdc-cell [data-value=initiated].inquiry_status {
  border-color: #4053ff;
  color: #4053ff;
  background: #eaf0ff;
}
.inquiry_status[data-value=closed], app-data-table table td.mat-mdc-cell [data-value=closed].inquiry_status {
  border-color: #4776a7;
  color: #4776a7;
  background: #dfefef;
}
.inquiry_status[data-value=escalated_to_admin], app-data-table table td.mat-mdc-cell [data-value=escalated_to_admin].inquiry_status {
  border-color: #df9312;
  color: #df9312;
  background: rgba(245, 158, 11, 0.2);
  padding: 0.1875rem 0.625rem !important;
}
.inquiry_status[data-value=reported], app-data-table table td.mat-mdc-cell [data-value=reported].inquiry_status {
  border-color: #f44336;
  color: #f44336;
  background: rgba(186, 57, 57, 0.2);
}
.inquiry_status[data-value=rejected], app-data-table table td.mat-mdc-cell [data-value=rejected].inquiry_status {
  border-color: #e54141;
  color: #e54141;
  background: rgba(186, 57, 57, 0.2);
}
.inquiry_status[data-value=delayed], app-data-table table td.mat-mdc-cell [data-value=delayed].inquiry_status {
  border-color: #323232;
  color: #323232;
  background: #ccc;
}

.p-dropdown.p-component {
  min-width: 13.125rem !important;
}

.calendarSelect input {
  text-align: center;
}

.p-dropdown:not(.p-disabled):hover,
.p-dropdown:not(.p-disabled).p-focus,
.p-inputtext:enabled:hover,
.p-inputtext:enabled:focus {
  border-color: #07b27e !important;
}

.p-dropdown:not(.p-disabled).p-focus,
.p-inputtext:enabled:focus {
  box-shadow: none !important;
}

.chart div {
  display: flex;
  justify-content: center;
}
.chart div canvas {
  min-width: 300px;
  max-width: 320px;
  min-height: 300px;
  max-height: 320px;
  width: 320px !important;
  height: 320px !important;
}
@media only screen and (max-width: 1250px) {
  .chart div canvas {
    width: 55% !important;
  }
}
@media only screen and (max-width: 480px) {
  .chart div canvas {
    width: 100% !important;
  }
}

.payment-status, .res-status {
  margin-right: 2rem;
  border-radius: 0.5rem !important;
  padding: 0.1875rem 0.9375rem !important;
  min-width: 6rem;
  white-space: nowrap;
  width: min-content;
  margin: auto;
  border: 0.5px solid;
  pointer-events: none;
}
.payment-status[data-value=paid], [data-value=paid].res-status, .payment-status[data-value=started], [data-value=started].res-status, .payment-status[data-value="courses-status.in_review"], [data-value="courses-status.in_review"].res-status, .payment-status[data-value=underreview], [data-value=underreview].res-status {
  border-color: #0d9b84;
  color: #0d9b84;
  background: rgba(7, 178, 126, 0.1);
}
.payment-status[data-value=unpaid], [data-value=unpaid].res-status, .payment-status[data-value="courses-status.rejected"], [data-value="courses-status.rejected"].res-status, .payment-status[data-value=ended], [data-value=ended].res-status, .payment-status[data-value=rejected], [data-value=rejected].res-status, .payment-status[data-value=closed_by_admin], [data-value=closed_by_admin].res-status, .payment-status[data-value=failed], [data-value=failed].res-status {
  border-color: #e54141;
  color: #e54141;
  background: rgba(186, 57, 57, 0.2);
}
.payment-status[data-value=open], [data-value=open].res-status, .payment-status[data-value=initiated], [data-value=initiated].res-status, .payment-status[data-value="courses-status.enabled"], [data-value="courses-status.enabled"].res-status, .payment-status[data-value=approved], [data-value=approved].res-status, .payment-status[data-value=completed], [data-value=completed].res-status {
  border-color: green;
  color: #fff;
  background: green;
}
.payment-status[data-value=canceled], [data-value=canceled].res-status, .payment-status[data-value=canceled_by_teacher], [data-value=canceled_by_teacher].res-status, .payment-status[data-value=canceled_by_student], [data-value=canceled_by_student].res-status, .payment-status[data-value="courses-status.disabled"], [data-value="courses-status.disabled"].res-status, .payment-status[data-value="courses-status.closed_by_admin"], [data-value="courses-status.closed_by_admin"].res-status, .payment-status[data-value="courses-status.closed_by_user"], [data-value="courses-status.closed_by_user"].res-status, .payment-status[data-value=cancelled], [data-value=cancelled].res-status {
  border-color: #ff9800;
  color: #051d30;
  background: rgba(255, 152, 0, 0.4509803922);
}
.payment-status[data-value=processing], [data-value=processing].res-status, .payment-status[data-value="courses-status.paused"], [data-value="courses-status.paused"].res-status {
  border-color: yellow;
  color: #051d30;
  background: rgba(255, 255, 0, 0.4);
}

.account-status {
  font-size: 1px;
  color: transparent;
}
.account-status[data-value=enabled]::after {
  content: "✓";
  display: inline-block;
  font-size: 2rem;
  font-weight: 700;
  color: green;
  margin-top: 0.5rem;
}
.account-status[data-value=disabled]::after {
  display: inline-block;
  content: "✕";
  font-size: 2rem;
  font-weight: 700;
  color: #e54141;
  margin-top: 0.5rem;
}

.menu-card {
  background-color: transparent !important;
  width: min-content !important;
}
.menu-card.lang-btn mat-icon {
  cursor: pointer;
  background-color: #0d9b84;
  width: 3rem;
  height: 3rem;
  padding: 0.5rem;
  border-radius: 50%;
  color: #fff;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.42);
  position: relative;
}
.menu-card.lang-btn span {
  padding: 0 1rem;
  color: #fff;
}
@media only screen and (max-width: 769px) {
  .menu-card.lang-btn mat-icon {
    width: 2rem;
    height: 2rem;
    padding: 1.2rem !important;
  }
  .menu-card.lang-btn span {
    font-size: 0.875rem !important;
  }
}
.menu-info {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  /* place-content: center;  */
  justify-content: space-between;
  align-items: center;
}
.menu-info span {
  padding: 0 32px;
  font-size: 18px;
  font-weight: bold;
}
.menu-avatar {
  width: 2.5rem;
  min-width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  margin: 0 0.5rem 0 0;
  border-radius: 50%;
  font-size: 1.0625rem;
  font-weight: 600;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/language-icon/language-icon.component.scss","webpack://./src/_variables.scss","webpack://./src/_function.scss","webpack://./src/_theme.scss","webpack://./node_modules/@angular/material/core/tokens/_token-utils.scss","webpack://./src/_mat-theme.scss","webpack://./src/_datatable.scss","webpack://./src/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AC4BhB;EAGE,0BAAA;EACA,wBAAA;EAEA,sBAAA;EAEA,wBAAA;EACA,uBAAA;AD9BF;;AELA;EACE,eAAA;EACA,uBAAA;AFQF;AEPE;EACE,wDAAA;EACA,yBAAA;AFSJ;AEPE;EACE,yDAAA;EACA,yBAAA;AFSJ;;AELA,6BAAA;AACA;EAEE;IACE,0BAAA;EFOF;AACF;AEJA,8BAAA;AACA;EAEE;IACE,4BAAA;EFKF;AACF;AEFA,6BAAA;AACA;EAEE;IACE,4BAAA;EFGF;AACF;AEAA,8BAAA;AACA;EAEE;IACE,0BAAA;EFCF;AACF;AG3CA,gDAAA;AC0HI;EAGM,mCAAA;EAAA,6BAAA;EAAA,gJAAA;EAAA,iJAAA;EAAA,iJAAA;EAAA,iJAAA;EAAA,kJAAA;EAAA,kJAAA;EAAA,mJAAA;EAAA,mJAAA;EAAA,mJAAA;EAAA,mJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,sJAAA;EAAA,sJAAA;EAAA,sJAAA;EAAA,sJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,uJAAA;AJpDV;AIiDI;EAGM,yCAAA;AJjDV;AI8CI;EAGM,qDAAA;EAAA,sCAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,gDAAA;EAAA,qCAAA;EAAA,4CAAA;EAAA,kCAAA;EAAA,0CAAA;EAAA,mCAAA;AJrCV;AIkCI;EAGM,wCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,4CAAA;EAAA,qCAAA;AJ7BV;AI0BI;EAGM,uDAAA;EAAA,4DAAA;EAAA,yDAAA;EAAA,qEAAA;EAAA,iFAAA;EAAA,+EAAA;AJrBV;AIkBI;EAGM,+DAAA;EAAA,uFAAA;AJjBV;AIcI;EAGM,4CAAA;EAAA,sJAAA;EAAA,yCAAA;AJZV;AISI;EAGM,4CAAA;EAAA,0CAAA;EAAA,qJAAA;EAAA,yCAAA;EAAA,sCAAA;AJLV;AIEI;EAGM,uCAAA;EAAA,mCAAA;EAAA,0CAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,sCAAA;EAAA,4CAAA;EAAA,mCAAA;EAAA,2CAAA;EAAA,oCAAA;AJQV;AIXI;EAGM,qDAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,uCAAA;EAAA,oCAAA;AJeV;AIlBI;EAGM,4CAAA;EAAA,kDAAA;EAAA,qDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,+CAAA;EAAA,sDAAA;EAAA,wCAAA;AJyBV;AI5BI;EAGM,4CAAA;EAAA,6DAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,wEAAA;EAAA,iDAAA;EAAA,uDAAA;EAAA,yEAAA;EAAA,iDAAA;EAAA,yEAAA;EAAA,6DAAA;EAAA,6DAAA;EAAA,6DAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,+EAAA;EAAA,6DAAA;EAAA,6DAAA;EAAA,mEAAA;EAAA,mEAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,qDAAA;EAAA,8CAAA;EAAA,oDAAA;EAAA,0DAAA;EAAA,4CAAA;AJsDV;AIzDI;EAGM,8CAAA;EAAA,sDAAA;EAAA,yDAAA;EAAA,mDAAA;EAAA,yDAAA;EAAA,2EAAA;EAAA,mDAAA;EAAA,2EAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,+DAAA;EAAA,gDAAA;EAAA,wEAAA;EAAA,sDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,kDAAA;EAAA,+CAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,kDAAA;EAAA,8CAAA;AJiFV;AIpFI;EAGM,kDAAA;EAAA,8EAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,0EAAA;EAAA,4CAAA;EAAA,oEAAA;EAAA,6CAAA;EAAA,qEAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,mDAAA;EAAA,oDAAA;EAAA,oEAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,mDAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,6CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,uCAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,8DAAA;EAAA,gEAAA;EAAA,6CAAA;AJmHV;AItHI;EAGM,4CAAA;EAAA,gDAAA;EAAA,gEAAA;EAAA,4CAAA;EAAA,yCAAA;EAAA,yDAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,6CAAA;EAAA,oCAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,8CAAA;EAAA,sJAAA;AJoIV;AIvII;EAGM,4CAAA;EAAA,uCAAA;EAAA,4JAAA;AJyIV;AI5II;EAGM,qCAAA;EAAA,mCAAA;EAAA,2CAAA;EAAA,kCAAA;EAAA,sCAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,0CAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,+CAAA;EAAA,kCAAA;AJyJV;AI5JI;EAGM,6CAAA;EAAA,uCAAA;EAAA,0DAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,sDAAA;EAAA,4CAAA;AJoKV;AIvKI;EAGM,iCAAA;EAAA,yDAAA;EAAA,uCAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,4DAAA;EAAA,qDAAA;EAAA,yEAAA;EAAA,2CAAA;EAAA,2CAAA;EAAA,oDAAA;EAAA,0CAAA;EAAA,oDAAA;EAAA,mDAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,wCAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,mEAAA;EAAA,0DAAA;EAAA,mCAAA;EAAA,0CAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,sCAAA;EAAA,gDAAA;EAAA,wCAAA;EAAA,oCAAA;EAAA,6BAAA;EAAA,oDAAA;EAAA,yCAAA;EAAA,kEAAA;EAAA,gDAAA;EAAA,gDAAA;AJ2MV;AI9MI;EAGM,qDAAA;EAAA,8DAAA;EAAA,0DAAA;EAAA,0DAAA;EAAA,yDAAA;EAAA,gDAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,2CAAA;AJsNV;AIzNI;EAGM,qDAAA;EAAA,qDAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,sDAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,0CAAA;EAAA,oDAAA;EAAA,kDAAA;EAAA,mDAAA;EAAA,sDAAA;EAAA,oDAAA;EAAA,qDAAA;EAAA,yCAAA;EAAA,mDAAA;EAAA,wDAAA;EAAA,kDAAA;EAAA,6CAAA;EAAA,mDAAA;EAAA,wDAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,qDAAA;EAAA,0DAAA;EAAA,oDAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,yCAAA;EAAA,mDAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,uCAAA;EAAA,mCAAA;AJsQV;AIzQI;EAGM,yCAAA;EAAA,6DAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,4CAAA;EAAA,sCAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,gDAAA;EAAA,qDAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,gEAAA;EAAA,8DAAA;EAAA,uDAAA;EAAA,iEAAA;EAAA,+DAAA;EAAA,qCAAA;EAAA,oCAAA;EAAA,mDAAA;EAAA,kDAAA;EAAA,qCAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,yDAAA;AJoSV;AIvSI;EAGM,iDAAA;EAAA,mDAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,kCAAA;EAAA,gDAAA;EAAA,kDAAA;AJmTV;AItTI;EAGM,iCAAA;EAAA,yCAAA;EAAA,wDAAA;EAAA,qCAAA;EAAA,oCAAA;EAAA,2CAAA;EAAA,qCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,uCAAA;AJ+TV;AIlUI;EAGM,4IAAA;EAAA,kCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,8DAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,uDAAA;EAAA,8DAAA;EAAA,2CAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,mDAAA;EAAA,2DAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,6DAAA;AJiWV;AIpWI;EAGM,kCAAA;EAAA,6DAAA;EAAA,4DAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,gDAAA;EAAA,yDAAA;EAAA,uCAAA;EAAA,0DAAA;EAAA,iFAAA;EAAA,uCAAA;AJ8WV;AIjXI;EAGM,yCAAA;EAAA,mCAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,sCAAA;EAAA,+BAAA;EAAA,sCAAA;EAAA,mCAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,+CAAA;EAAA,gDAAA;EAAA,oJAAA;AJqYV;AIxYI;EAGM,iDAAA;EAAA,kDAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,8CAAA;EAAA,mDAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,0DAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,0DAAA;EAAA,oDAAA;EAAA,oDAAA;EAAA,qDAAA;EAAA,oDAAA;EAAA,qDAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,mDAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,kDAAA;EAAA,yDAAA;EAAA,mDAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,2DAAA;EAAA,+DAAA;EAAA,4DAAA;EAAA,gEAAA;EAAA,yDAAA;EAAA,oDAAA;EAAA,oDAAA;EAAA,sDAAA;EAAA,uCAAA;EAAA,iDAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,qDAAA;EAAA,wDAAA;EAAA,yDAAA;AJobV;AIvbI;EAGM,0CAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,yCAAA;AJ0bV;AI7bI;EAGM,6CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,2DAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,iDAAA;EAAA,oCAAA;EAAA,iDAAA;EAAA,0DAAA;EAAA,2CAAA;AJ0cV;AI7cI;EAGM,qDAAA;AJ6cV;AIhdI;EAGM,mDAAA;EAAA,gDAAA;EAAA,6CAAA;AJkdV;AIrdI;EAGM,uCAAA;EAAA,+CAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,8CAAA;EAAA,gDAAA;EAAA,uCAAA;EAAA,oCAAA;AJseV;AIzeI;EAGM,yDAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,2DAAA;EAAA,mDAAA;EAAA,mEAAA;EAAA,qEAAA;EAAA,gDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,6CAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,0DAAA;EAAA,0DAAA;EAAA,4DAAA;EAAA,qCAAA;AJggBV;AIngBI;EAGM,2DAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,0CAAA;AJ0gBV;AI7gBI;EAGM,2CAAA;EAAA,mEAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,yCAAA;AJohBV;AIvhBI;EAGM,gKAAA;EAAA,wKAAA;EAAA,sKAAA;EAAA,sKAAA;EAAA,wKAAA;EAAA,+CAAA;EAAA,gDAAA;EAAA,uEAAA;EAAA,wEAAA;EAAA,+CAAA;EAAA,gDAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,8CAAA;AJqiBV;AIxiBI;EAGM,4CAAA;EAAA,6CAAA;EAAA,oEAAA;EAAA,qEAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,2CAAA;AJijBV;AIpjBI;EAGM,oEAAA;EAAA,uEAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,+CAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,wCAAA;EAAA,6CAAA;AJ8jBV;AIjkBI;EAGM,4CAAA;EAAA,qDAAA;EAAA,uDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,6CAAA;EAAA,0CAAA;EAAA,oDAAA;EAAA,mCAAA;EAAA,mCAAA;AJ2kBV;AI9kBI;EAGM,iDAAA;EAAA,0DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,kDAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,wCAAA;AJulBV;AI1lBI;EAGM,8CAAA;EAAA,uDAAA;EAAA,2DAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,qDAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,qCAAA;AJmmBV;AItmBI;EAGM,gDAAA;EAAA,yDAAA;EAAA,2DAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,uDAAA;EAAA,iDAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,uCAAA;AJ+mBV;AIlnBI;EAGM,qCAAA;EAAA,6DAAA;EAAA,wCAAA;EAAA,iCAAA;AJqnBV;AIxnBI;EAGM,4CAAA;EAAA,qDAAA;EAAA,sDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,6CAAA;AJ8nBV;AIjoBI;EAGM,8JAAA;EAAA,oKAAA;EAAA,oKAAA;EAAA,sKAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,wCAAA;AJ0oBV;AI7oBI;EAGM,qJAAA;EAAA,2JAAA;EAAA,2JAAA;EAAA,6JAAA;EAAA,kCAAA;EAAA,+BAAA;AJkpBV;AIrpBI;EAGM,2JAAA;EAAA,iKAAA;EAAA,iKAAA;EAAA,mKAAA;EAAA,wCAAA;EAAA,qCAAA;AJ0pBV;AI7pBI;EAGM,mCAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,gEAAA;EAAA,iEAAA;EAAA,qCAAA;AJqqBV;AIxqBI;EAGM,yCAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,iDAAA;EAAA,sEAAA;EAAA,uEAAA;AJ+qBV;AIlrBI;EAGM,uCAAA;EAAA,6CAAA;EAAA,4CAAA;EAAA,mDAAA;EAAA,6CAAA;EAAA,0CAAA;EAAA,mCAAA;AJwrBV;AI3rBI;EAGM,qCAAA;AJ2rBV;AI9rBI;EAGM,qCAAA;EAAA,0CAAA;EAAA,8CAAA;EAAA,2CAAA;EAAA,yCAAA;EAAA,gDAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,oDAAA;EAAA,8CAAA;EAAA,2CAAA;EAAA,kDAAA;EAAA,gDAAA;EAAA,uDAAA;EAAA,iDAAA;EAAA,8CAAA;EAAA,qDAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,uCAAA;AJotBV;AIvtBI;EAGM,uDAAA;EAAA,mDAAA;EAAA,kCAAA;AJytBV;AI5tBI;EAGM,qCAAA;EAAA,+BAAA;EAAA,oEAAA;EAAA,8CAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,qCAAA;EAAA,+CAAA;EAAA,gDAAA;EAAA,2CAAA;EAAA,qDAAA;EAAA,sDAAA;EAAA,oCAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,6BAAA;EAAA,mCAAA;EAAA,uCAAA;EAAA,wCAAA;AJuvBV;AI1vBI;EAGM,gDAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,qDAAA;EAAA,4CAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,wCAAA;AJiwBV;AIpwBI;EAGM,4DAAA;EAAA,4DAAA;EAAA,gDAAA;EAAA,uDAAA;EAAA,qEAAA;EAAA,+DAAA;EAAA,8EAAA;EAAA,uFAAA;EAAA,6FAAA;EAAA,mDAAA;EAAA,qDAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,0DAAA;EAAA,mDAAA;EAAA,yCAAA;EAAA,wCAAA;EAAA,0DAAA;EAAA,yEAAA;AJsxBV;AIzxBI;EAGM,iEAAA;EAAA,uEAAA;EAAA,+FAAA;EAAA,0EAAA;EAAA,mFAAA;EAAA,mFAAA;EAAA,wDAAA;EAAA,uEAAA;EAAA,kFAAA;EAAA,+EAAA;EAAA,wFAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA,2DAAA;EAAA,2DAAA;EAAA,+DAAA;EAAA,oDAAA;EAAA,2DAAA;EAAA,yFAAA;EAAA,kDAAA;EAAA,gFAAA;EAAA,mEAAA;EAAA,qDAAA;EAAA,mFAAA;EAAA,8EAAA;EAAA,6DAAA;EAAA,uDAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,wDAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,wDAAA;EAAA,oDAAA;EAAA,iDAAA;EAAA,+CAAA;EAAA,qDAAA;EAAA,kKAAA;EAAA,wKAAA;EAAA,2DAAA;EAAA,yDAAA;AJi0BV;AIp0BI;EAGM,4BAAA;EAAA,wBAAA;AJq0BV;AIx0BI;EAGM,mDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;EAAA,0CAAA;EAAA,iDAAA;EAAA,+CAAA;EAAA,yCAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,kDAAA;EAAA,yCAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,kDAAA;EAAA,qCAAA;EAAA,qDAAA;EAAA,sDAAA;AJ+1BV;AIl2BI;EAGM,wEAAA;EAAA,+EAAA;EAAA,wEAAA;EAAA,+EAAA;AJq2BV;AIx2BI;EAGM,yBAAA;AJw2BV;AI32BI;EAGM,iDAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,yCAAA;EAAA,gDAAA;EAAA,mCAAA;EAAA,8CAAA;EAAA,oCAAA;EAAA,kDAAA;AJm3BV;AIt3BI;EAGM,mDAAA;EAAA,kEAAA;EAAA,kEAAA;EAAA,8DAAA;EAAA,8DAAA;EAAA,sCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,oEAAA;EAAA,8CAAA;EAAA,uDAAA;EAAA,6DAAA;EAAA,0DAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,0CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,2CAAA;EAAA,0DAAA;EAAA,6DAAA;EAAA,0DAAA;EAAA,iCAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,mEAAA;AJ+4BV;AIl5BI;EAGM,+BAAA;AJk5BV;AIr5BI;EAGM,iDAAA;EAAA,2CAAA;EAAA,sCAAA;EAAA,6CAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,mCAAA;EAAA,iCAAA;AJ65BV;AIh6BI;EAGM,8CAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,gCAAA;AJq6BV;AIx6BI;EAGM,oDAAA;EAAA,qCAAA;EAAA,0JAAA;AJ06BV;;AGrhCA,uCAAA;AAGA;EACE,6BAAA;AHshCF;;AGlhCA;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AHqhCF;;AGjhCA;EACE,8BAAA;AHohCF;;AGhhCA;EACE,gCAAA;AHmhCF;;AG9gCA;EACE,gCAAA;AHihCF;;AG7gCE;EACE,wCAAA;AHghCJ;;AG3gCE;EACE,6BAAA;EACA,iBAAA;EACA,iBAAA;AH8gCJ;AG3gCE;EACE,cAAA;EACA,qCAAA;AH6gCJ;AG1gCE;EACE,6BAAA;EACA,iBAAA;AH4gCJ;;AGxgCA;EACE,iBAAA;AH2gCF;;AGvgCA;EACE,2BAAA;AH0gCF;AGxgCE;EACE,mBAAA;AH0gCJ;;AGtgCA;EACE,wCAAA;EACA,qBAAA;AHygCF;AGvgCE;EACE,wCAAA;AHygCJ;AGvgCI;EACE,UAAA;AHygCN;AGrgCE;EACE,wCAAA;EACA,qBAAA;AHugCJ;AGpgCE;EACE,yBAAA;EACA,eAAA;AHsgCJ;AGngCE;EACE,yBAAA;AHqgCJ;;AGjgCA;EACE,sBAAA;EACA,gDAAA;EACA,qBAAA;AHogCF;;AGjgCA;EACE,kBAAA;AHogCF;;AGjgCA;EACE,yBAAA;AHogCF;;AGjgCA;EACE,UAAA;EACA,YAAA;EAEA,cAAA;EACA,gBAAA;EACA,YAAA;AHmgCF;AGjgCE;EACE,iBAAA;EACA,iBAAA;AHmgCJ;AGhgCE;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,sBAAA;AHkgCJ;;AG//BA;EACE,uBAAA;EACA,0BAAA;EACA,wBAAA;EACA,2BAAA;EACA,YAAA;AHkgCF;;AG//BA;EACE,WAAA;EACA,yBAAA;EACA,qCAAA;AHkgCF;AGhgCE;EACE,gBAAA;AHkgCJ;;AG9/BA;EACE,sBAAA;EACA,kBAAA;EACA,yBAAA;AHigCF;;AG9/BA;EACE,UAAA;AHigCF;;AG9/BA;EACE,sDAAA;EACA,yBAAA;AHigCF;;AG9/BA;EACE,sDAAA;AHigCF;;AG9/BA;EACE,0BAAA;EACA,6BAAA;EACA,4BAAA;EACA,6CAAA;AHigCF;;AG9/BA;EACE,uBAAA;AHigCF;;AG9/BA;EACE,kBAAA;EACA,2CAAA;EACA,iCAAA;EACA,0BAAA;EACA,mBAAA;AHigCF;AG//BE;EACE,gBAAA;EACA,uBAAA;AHigCJ;AG9/BE;EACE,qDAAA;AHggCJ;;AG7/BA;EACE,wBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EAEA,oBAAA;EACA,cAAA;AH+/BF;;AG5/BA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,oCAAA;EACA,sBAAA;EACA,iCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EACA,2BAAA;EACA,aAAA;EACA,wBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AH+/BF;AG9/BE;EAhBF;IAiBI,WAAA;IACA,YAAA;EHigCF;AACF;;AG3/BI;EAEE,oCAAA;AH6/BN;AG5/BM;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EAEA,qBAAA;AH6/BR;;AGl/BM;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EAEA,qBAAA;AHo/BR;;AKjwCE;EACE,cAAA;EAGA,mBAAA;ALkwCJ;AKhwCE;EACE,aAAA;ALkwCJ;AKhwCE;EACE,2BAAA;EACA,uBAAA;ALkwCJ;AK/vCE;EACE,aAAA;EACA,mBAAA;ALiwCJ;AK9vCE;EACE,8BAAA;EACA,aAAA;EACA,mBAAA;ALgwCJ;AK7vCE;EACE,gCAAA;EACA,4BAAA;EACA,gCAAA;AL+vCJ;AK5vCE;EACE,gCAAA;EACA,4BAAA;EACA,gCAAA;AL8vCJ;AK3vCE;;EAEE,+BAAA;AL6vCJ;AK1vCE;EAIE,gCAAA;ALyvCJ;AKtvCE;;EAEE,YAAA;ALwvCJ;AKtvCE;EACE,+BAAA;ALwvCJ;AKtvCE;;;EAGE,gCAAA;EACA,gCAAA;EACA,4BAAA;ALwvCJ;AK9uCE;EACE,aAAA;ALgvCJ;AK9uCE;EACE,yCAAA;EACA,gCAAA;ALgvCJ;AK7uCI;EACE,cAAA;AL+uCN;AK7uCI;EACE,iCAAA;EACA,uCAAA;EACA,qCAAA;AL+uCN;AK5uCI;EACE,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;AL8uCN;AK3uCE;EACE,6BAAA;EACA,yBAAA;AL6uCJ;AK1uCE;EACE,uBAAA;AL4uCJ;AKzuCE;EACE,wCAAA;AL2uCJ;AKxuCE;;;;;EAKE,wBAAA;EACA,6BAAA;AL0uCJ;AKxuCE;EACE,8BAAA;EACA,gBAAA;AL0uCJ;AKzuCI;EAHF;IAII,uBAAA;EL4uCJ;AACF;AK1uCE;EACE;IACE,wBAAA;EL4uCJ;EK1uCE;IACE,qBAAA;IACA,YAAA;EL4uCJ;AACF;AKzuCE;;;EAGE,oCAAA;EACA,gCAAA;AL2uCJ;AKxuCE;EACE,oBAAA;EACA,YAAA;AL0uCJ;AK/tCE;;;;EAIE,oBAAA;EACA,kCAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,uBAAA;ALiuCJ;AK9tCE;;EAEE,8EACE;AL+tCN;AK7tCI;;EACE,6EACE;AL+tCR;AK1tCE;EACE,oCAAA;AL4tCJ;AK3tCI;EACE,qBJzLU;EI0LV,cJ1LU;ADu5ChB;AKttCI;;;EAGE,qBJ9KS;ADs4Cf;AKrtCM;;;EAGE,gCAAA;EACA,4BAAA;ALutCR;AKntCE;EACE,iCAAA;EACA,+BAAA;ALqtCJ;AKntCE;EACE,+BAAA;EACA,6BAAA;ALqtCJ;AKntCE;EACE,cJxNY;AD66ChB;AKjtCE;EACE,mBAAA;EACA,wCAAA;EACA,0FACE;ALktCN;AK9sCE;EACE,gBAAA;EACA,iBAAA;ALgtCJ;;AMv7CA;EACE,cAAA;EAEA,qBAAA;ANy7CF;AMt7CE;EACE,kBAAA;EACA,UAAA;EACA,oCAAA;EACA,iCAAA;EACA,kCAAA;EACA,2BAAA;EACA,mBAAA;EACA,mCAAA;EACA,qCAAA;ANw7CJ;AMt7CI;EAXF;IAYI,sCAAA;IACA,wCAAA;ENy7CJ;AACF;AMv7CI;EACE,6BAAA;EACA,WLlBQ;AD28Cd;AMr7CI;EACE,6BAAA;EACA,cL5BS;ADm9Cf;AMn7CI;EACE,yBLlCU;EKmCV,gBAAA;EACA,wBAAA,EAAA,WAAA;EACA,YAAA;EACA,MAAA;ANq7CN;AMl7CI;EACE,2BAAA;EACA,8BAAA;EACA,yBL5CU;EK6CV,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;ANo7CN;AMn7CM;EARF;IASI,UAAA;ENs7CN;AACF;AMr7CM;EACE,wBAAA;ANu7CR;AMn7CI;EACE,iCAAA;EACA,+BAAA;ANq7CN;AMl7CI;EACE,+BAAA;EACA,6BAAA;ANo7CN;AMj7CI;;EAEE,yBAAA;ANm7CN;AMh7CI;;EAEE,iCAAA;ANk7CN;AM/6CI;EACE,yBLnEa;EKoEb,kBAAA;EACA,2CAAA;ANi7CN;AM/6CM;EACE,yBAAA;ANi7CR;AM96CM;EACE,qDAAA;ANg7CR;AM96CM;EACE,eAAA;ANg7CR;AM56CI;EACE,kBAAA;EACA,qCAAA;EACA,wCAAA;EACA,gBAAA;EAIA,yBAAA;AN26CN;AMz6CM;EACE,8BAAA;AN26CR;AMx6CM;EACE,uBAAA;EACA,eAAA;EACA,YAAA;AN06CR;AMv6CM;EACE,kBAAA;EAIA,cAAA;EACA,mBAAA;ANs6CR;AM16CQ;EAFF;IAGI,UAAA;EN66CR;AACF;AMx6CQ;EAEE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;ANy6CV;AMr6CQ;EACE,eAAA;EACA,cAAA;EACA,2BAAA;EACA,kCAAA;EACA,cLvIQ;AD8iDlB;AMn6CQ;EACE,mBAAA;EACA,cAAA;EACA,2BAAA;EACA,kCAAA;EACA,cL9II;ADmjDd;AMh6CU;EACE,aAAA;ANk6CZ;AM75CM;EACE,gCAAA;EACA,4BAAA;EAEA,mBAAA;EACA,WAAA;EACA,YAAA;AN85CR;AM35CQ;EACE,aAAA;AN65CV;AMz5CU;EACE,mBAAA;EACA,cAAA;EACA,2BAAA;EACA,kCAAA;EACA,cL5KE;ADukDd;AMr5CU;EACE,aAAA;ANu5CZ;AMr5CU;EACE,eAAA;EACA,cAAA;EACA,2BAAA;EACA,kCAAA;EACA,cL5LM;ADmlDlB;AMj5CM;EAGE,aAAA;EACA,uBAAA;ANi5CR;AM/4CU;;EAEE,yBAAA;EACA,gCAAA;EACA,oBAAA;ANi5CZ;AM54CU;EACE,qCAAA;EACA,kCAAA;EACA,gCAAA;AN84CZ;AM14CQ;EACE,yBAAA;AN44CV;AMz4CQ;EACE,sBAAA;EACA,WAAA;EACA,eAAA;AN24CV;AMx4CQ;EACE,eAAA;EACA,mCAAA;EACA,gCAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;AN04CV;AMx4CU;EACE,wBAAA;AN04CZ;AMr4CM;;EAIE,cLtPU;EKuPV,wCAAA;EACA,iBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;ANq4CR;AMl4CM;EACE,2BAAA;ANo4CR;AM73CM;EACE,2BAAA;EACA,uBAAA;AN+3CR;AMp3CI;EAEE,oBAAA;ANq3CN;AMl3CQ;EACE,yBAAA;ANo3CV;AMh3CM;EAIE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AN+2CR;AM52CM;EAEE,cAAA;AN62CR;AM52CQ;EACE,wCAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;AN82CV;AM12CM;EACE,gBAAA;EACA,yBAAA;AN42CR;AM32CQ;EACE,yBAAA;AN62CV;AM32CQ;EAIE,gBAAA;AN02CV;AMt2CM;EACE,eAAA;ANw2CR;AMv2CQ;EACE,wBAAA;ANy2CV;AMv2CQ;EACE,wCAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cLhVI;ADyrDd;AMr2CM;EACE,eAAA;ANu2CR;AMr2CU;EACE,wCAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cLlWM;ADysDlB;AMp2CQ;EACE,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cL5WI;ADktDd;AM/1CE;EACE,aAAA;ANi2CJ;AM71CE;EACE,sBAAA;EACA,8BAAA;EACA,kCAAA;EACA,6BAAA;EACA,qCAAA;EACA,mCAAA;AN+1CJ;AM71CI;EARF;IASI,kBAAA;IACA,iCAAA;IACA,sCAAA;IACA,wCAAA;ENg2CJ;AACF;AM31CI;EACE,yBAAA;EACA,SAAA;EACA,kCAAA;AN61CN;AM31CM;EALF;IAMI,iCAAA;IACA,kBAAA;IACA,oBAAA;IACA,kCAAA;EN81CN;EM71CM;IACE,8BAAA;EN+1CR;AACF;AM71CM;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;AN+1CR;AM71CQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,qBAAA;EACA,aAAA;EACA,WAAA;EACA,mBL7aM;EK8aN,kBAAA;AN+1CV;AM51CM;EACE,UAAA;AN81CR;AM71CQ;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,oCAAA;AN+1CV;AM91CU;EALF;IAMI,sBAAA;IACA,sBAAA;ENi2CV;AACF;AM/1CQ;EACE,WAAA;ANi2CV;AMh2CU;EACE,WAAA;ANk2CZ;AM/1CU;EAEE,gCAAA;EACA,gCAAA;EACA,4BAAA;ANg2CZ;AM71CU;EACE,cL5bE;EK8bF,4BAAA;AN81CZ;AMz1CQ;EACE,wCAAA;EACA,cLrcI;EKscJ,eAAA;EACA,YAAA;EACA,WAAA;AN21CV;AM11CU;EACE,eAAA;AN41CZ;AM11CU;EACE,yBAAA;EACA,eAAA;AN41CZ;AMx1CQ;EAhDF;IAiDI,UAAA;EN21CR;AACF;AMv1CU;EACE,YAAA;ANy1CZ;AMr1CM;EAEE,uBAAA;EACA,8BAAA;EACA,uBAAA;ANs1CR;AMr1CQ;EACE;IACE,uBAAA;ENu1CV;AACF;AMr1CQ;EACE,mBAAA;EACA,UAAA;EACA,+CLlfG;ADy0Db;AMr1CQ;EACE,uBAAA;EACA,kBAAA;EACA,0BAAA;ANu1CV;AMt1CU;EACE,oCAAA;EACA,yBAAA;EACA,iCAAA;ANw1CZ;AMr1CU;EACE,oCAAA;EACA,yBAAA;EACA,iCAAA;ANu1CZ;AMl1CU;EACE,oBAAA;EACA,cL/gBI;EKghBJ,iBAAA;EACA,cAAA;EACA,aAAA;ANo1CZ;AMl1CU;EACE,2BAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,uBAAA;ANo1CZ;AMn0CE;EACE,sBAAA;EACA,iBAAA;EACA,mBAAA;ANq0CJ;AMp0CI;EAJF;IAKI,eAAA;ENu0CJ;AACF;AMt0CI;EAPF;IAQI,iCAAA;ENy0CJ;AACF;AMx0CI;EAEE,sBAAA;EACA,oBAAA;EACA,sBAAA;EACA,SAAA;EACA,cL7iBO;ADs3Db;AMt0CQ;EACE,cAAA;EACA,WAAA;ANw0CV;AMp0CM;EAEE,cLvjBM;AD43Dd;AMj0CI;EACE,8BAAA;ANm0CN;AM/zCI;EACE,gBAAA;EACA,2BAAA;EACA,uBAAA;ANi0CN;AM/zCM;EACE,+BAAA;EACA,eAAA;EAGA,qBAAA;EAEA,cAAA;EACA,+BAAA;AN8zCR;AM7zCQ;EACE,cAAA;EAGA,iCAAA;AN6zCV;AM3zCQ;EACE,wBAAA;EACA,yBAAA;AN6zCV;AM3zCQ;EAnBF;IAoBI,cAAA;EN8zCR;AACF;AM3zCM;EA7BF;IA8BI,2BAAA;IACA,wBAAA;EN8zCN;AACF;AM5zCM;EAlCF;IAmCI,2BAAA;EN+zCN;AACF;AM7zCM;EAtCF;IAuCI,4BAAA;IACA,4BAAA;IACA,uBAAA;ENg0CN;AACF;AM7yCE;EAIE,sBAAA;EACA,UAAA;EACA,0BAAA;AN4yCJ;AM3yCI;EAPF;IAQI,6BAAA;IACA,WAAA;IACA,qBAAA;EN8yCJ;AACF;AM7yCI;EAEE,kBAAA;EACA,YAAA;EACA,gBLvpBQ;EKwpBR,wBAAA;EACA,2BAAA;AN8yCN;AMzyCM;EAXF;IAYI,sBAAA;IACA,kBAAA;IACA,WAAA;IACA,sBAAA;IACA,uBAAA;EN4yCN;AACF;AM3yCM;EACE,oCAAA;AN6yCR;AM5yCQ;EAFF;IAGI,WAAA;IACA,kCAAA;IACA,eAAA;IACA,oCAAA;EN+yCR;AACF;AM7yCM;EAEE,cLprBO;EKqrBP,2BAAA;EACA,eAAA;AN8yCR;AM5yCQ;EACE,+CAAA;EACA,qBAAA;EACA,yBAAA;AN8yCV;AM1yCM;EACE,wCAAA;EACA,uBAAA;EACA,WL9rBM;AD0+Dd;AM1yCQ;EACE,cLrsBK;EKssBL,oBAAA;AN4yCV;AMxyCQ;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EAEA,cLntBK;AD4/Df;AMvyCU;EACE,kCAAA;EACA,oEAAA;EACA,oEAAA;ANyyCZ;AMtyCU;EACE,oCAAA;EACA,sBAAA;EACA,qBAAA;ANwyCZ;AMtyCY;EACE,oCAAA;ANwyCd;AMnyCQ;EACE,qBAAA;ANqyCV;AMjyCM;EACE,cL9tBM;EK+tBN,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;ANmyCR;AMlyCQ;EANF;IAOI,wBAAA;ENqyCR;AACF;AMjyCI;EACE,oBAAA;EACA,yBAAA;ANmyCN;;AM7xCE;EACE,oCAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;ANgyCJ;AM7xCI;EACE,UAAA;AN+xCN;AM3xCE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yDAAA;AN6xCJ;AM1xCE;EAEE,oCAAA;EACA,sBAAA;EACA,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,4CAAA;EACA,0BAAA;AN2xCJ;AM1xCI;EACE,aAAA;AN4xCN;AM1xCI;EACE,8BAAA;AN4xCN;AMzxCI;EACE,2BAAA;AN2xCN;AMtxCI;EACE,sBAAA;ANwxCN;AMvxCM;EAEE,sBAAA;ANwxCR;AMpxCI;EACE,gCAAA;EACA,8BAAA;EACA,0DAAA;EACA,qBAAA;EACA,yBAAA;ANsxCN;AMpxCM;;EAEE,mCAAA;EACA,yBAAA;ANsxCR;AMpxCQ;;EACE,mBAAA;ANuxCV;AMpxCQ;;;;EAEE,6BAAA;EACA,uBAAA;EACA,wBAAA;ANwxCV;AMrxCQ;;EACE,wCAAA;ANwxCV;AMrxCQ;;;EAEE,uBAAA;ANwxCV;AMrxCQ;;EACE,wBAAA;ANwxCV;AMrxCQ;;;EAEE,oBAAA;EACA,YAAA;ANwxCV;AM/wCM;;;;EAIE,wCAAA;ANixCR;AM9wCM;EACE,aAAA;ANgxCR;AM7wCM;EACE,YAAA;AN+wCR;AM3wCQ;;EAEE,8CAAA;AN6wCV;AM5wCU;;EACE,2BAAA;AN+wCZ;AM7wCU;;EACE,yBAAA;EAEA,6BAAA;EACA,wCAAA;AN+wCZ;AM1wCU;;EACE,wBAAA;EACA,8CAAA;AN6wCZ;AM1wCU;;EACE,uBAAA;AN6wCZ;AM1wCQ;;;EAGE,oBAAA;EACA,4BAAA;EACA,oCAAA;AN4wCV;AMrwCU;;;;EAKE,yBAAA;EACA,2BAAA;EACA,sCAAA;ANswCZ;AM3wCY;;;;EACE,yBAAA;ANgxCd;AMtwCI;EACE,qBAAA;ANwwCN;AMpwCM;EACE,qBAAA;ANswCR;AMpwCM;EACE,0BAAA;EACA,uBAAA;EACA,8CAAA;EACA,aAAA;EACA,kCAAA;EACA,sBAAA;EACA,wCAAA;EACA,2BAAA;EACA,cAAA;ANswCR;AMrwCQ;EACE,QAAA;EACA,yBAAA;ANuwCV;AMrwCQ;EACE,YAAA;ANuwCV;AMpwCM;EACE,wCAAA;ANswCR;AMpwCM;EACE,aAAA;ANswCR;AMpwCM;EAEE,yBAAA;ANqwCR;AMhwCE;EACE,qBAAA;ANkwCJ;;AM9vCA;EACE,kBAAA;ANiwCF;AMhwCE;EACE,8BAAA;EACA,cAAA;EACA,WAAA;EACA,oBAAA;ANkwCJ;AMjwCI;EALF;IAMI,oBAAA;ENowCJ;AACF;AMlwCI;EACE,aAAA;EACA,mBAAA;ANowCN;AMlwCM;EAJF;IAKI,sBAAA;IACA,2BAAA;IACA,uBAAA;IACA,WAAA;ENqwCN;AACF;AMnwCM;EACE,iBAAA;EACA,iBAAA;EACA,cL9+BO;EK++BP,iBAAA;ANqwCR;AMlwCM;EACE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,WAAA;ANowCR;AMnwCQ;EALF;IAMI,MAAA;ENswCR;AACF;AMrwCQ;EACE,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,mDAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cLpgCK;EKqgCL,eAAA;EACA,cAAA;EACA,iBAAA;ANuwCV;AMtwCU;EAdF;IAeI,iBAAA;IACA,eAAA;IACA,gBAAA;ENywCV;AACF;AMvwCU;EACE,6BAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,yBLrhCG;EKuhCH,kBAAA;EACA,YAAA;EACA,eAAA;ANwwCZ;AMrwCY;EACE,yBL5hCI;ADmyElB;AMjwCI;EACE,UAAA;ANmwCN;AM9vCI;EACE,gCAAA;ANgwCN;AM/vCM;EACE,SAAA;ANiwCR;;AMxvCM;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AN2vCR;AM1vCQ;EACE,cAAA;AN4vCV;AM1vCQ;EARF;IASI,YAAA;EN6vCR;AACF;AM5vCQ;EAXF;IAYI,6BAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;EN+vCR;AACF;;AMpvCU;EACE,2BAAA;ANuvCZ;AMjvCQ;EACE,YAAA;EACA,sBAAA;EACA,sBAAA;ANmvCV;AMhvCU;EACE,sBAAA;EACA,mBAAA;ANkvCZ;AM/uCQ;EACE,WAAA;EACA,WAAA;ANivCV;AMhvCU;EACE,cAAA;ANkvCZ;AMhvCU;EANF;IAOI,WAAA;IACA,WAAA;ENmvCV;AACF;AM9uCQ;EACE,oCAAA;ANgvCV;AM/uCU;EACE,kCAAA;ANivCZ;AM5uCI;EACE,cAAA;AN8uCN;AM7uCM;EACE,yBAAA;AN+uCR;AM9uCQ;;EAEE,yBAAA;EACA,4BAAA;ANgvCV;AM7uCM;EACE,cAAA;AN+uCR;AMzuCU;EACE,WAAA;EACA,WAAA;AN2uCZ;AM1uCY;EACE,cAAA;AN4uCd;AM1uCY;EANF;IAOI,WAAA;IACA,WAAA;EN6uCZ;AACF;;AOt3EA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;EAEA,gCAAA;EACA,4DAAA;APw3EF;AOt3EE;EATF;IAUI,4DAAA;EPy3EF;AACF;;AOt3EA;EACE,aAAA;EACA,cAAA;APy3EF;;AOt3EA;EACE,mBNVa;EMWb,mBAAA;APy3EF;;AOt3EA;EACE,oCNhB0B;EMiB1B,mBAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,sBAAA;APy3EF;;AOt3EA;EACE,oCN9B0B;ADu5E5B;;AOt3EA;EACE;IACE,aAAA;IACA,cAAA;EPy3EF;EOt3EA;IACE,qCAAA;EPw3EF;EOr3EA;IACE,qCAAA;EPu3EF;AACF;AOp3EA;;EAEE,YAAA;EACA,gBAAA;APs3EF;;AOl3EE;EACE,yBAAA;APq3EJ;AOn3EI;;;EAGE,yBAAA;APq3EN;AOj3EE;EACE,yBAAA;APm3EJ;AOj3EI;;;EAGE,yBAAA;APm3EN;;AO92EA;EACE,WAAA;EACA,cAAA;APi3EF;;AO92EA;EACE,qBAAA;EACA,eAAA;APi3EF;;AO92EA;;;;;;;;;;;;;;;EAeE,kCNhGe;ADi9EjB;;AO92EA;EACE,gBAAA;APi3EF;;AO52EA;EL5EE,0BAAA;EACA,gCAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF47EF;;AOh3EA;ELhFE,4BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFo8EF;;AOp3EA;ELpFE,0BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF48EF;;AOx3EA;ELxFE,4BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFo9EF;;AO53EA;EL5FE,0BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF49EF;;AOh4EA;ELhGE,4BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFo+EF;;AOp4EA;ELpGE,0BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF4+EF;;AOx4EA;ELxGE,4BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFo/EF;;AO54EA;EL5GE,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF4/EF;;AOh5EA;ELhHE,0BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFogFF;;AOp5EA;ELpHE,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF4gFF;;AOx5EA;ELxHE,0BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFohFF;;AO55EA;EL5HE,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF4hFF;;AOh6EA;ELhIE,0BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFoiFF;;AOp6EA;ELpIE,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF4iFF;;AOx6EA;ELxIE,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFojFF;;AO56EA;EL5IE,6BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF4jFF;;AOh7EA;ELhJE,4BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFokFF;;AOp7EA;ELpJE,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF4kFF;;AOx7EA;ELxJE,6BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFolFF;;AO57EA;EL5JE,4BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF4lFF;;AOh8EA;ELhKE,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFomFF;;AOp8EA;ELpKE,6BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF4mFF;;AOx8EA;ELxKE,4BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFonFF;;AO58EA;;EL5KE,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF6nFF;;AOj9EA;ELhLE,6BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFqoFF;;AOr9EA;ELpLE,4BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF6oFF;;AOz9EA;ELxLE,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFqpFF;;AO79EA;EL5LE,6BAAA;EACA,gCAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF6pFF;;AOj+EA;ELhME,8BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFqqFF;;AOr+EA;ELpME,6BAAA;EACA,gCAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF6qFF;;AOz+EA;ELxME,8BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFqrFF;;AO7+EA;EL5ME,6BAAA;EACA,gCAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF6rFF;;AOj/EA;ELhNE,8BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFqsFF;;AOr/EA;ELpNE,6BAAA;EACA,gCAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF6sFF;;AOz/EA;ELxNE,8BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFqtFF;;AO7/EA;EL5NE,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF6tFF;;AOjgFA;ELhOE,8BAAA;EACA,gCAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFquFF;;AOrgFA;ELpOE,6BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF6uFF;;AOzgFA;ELxOE,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFqvFF;;AO7gFA;EL5OE,8BAAA;EACA,gCAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF6vFF;;AOjhFA;ELhPE,6BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFqwFF;;AOrhFA;ELpPE,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF6wFF;;AOzhFA;ELxPE,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFqxFF;;AO7hFA;EL5PE,8BAAA;EACA,gCAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF6xFF;;AOjiFA;ELhQE,6BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFqyFF;;AOriFA;ELpQE,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF6yFF;;AOziFA;;;ELxQE,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFuzFF;;AO/iFA;EL5QE,8BAAA;EACA,gCAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF+zFF;;AOnjFA;ELhRE,6BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AFu0FF;;AOvjFA;ELpRE,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCDhCe;ECiCf,4BAAA;AF+0FF;;AO3jFA;;EACE,wBAAA;EACA,mBAAA;AP+jFF;;AO5jFA;;EAEE,uBAAA;AP+jFF;;AO5jFA;EAEE,8BAAA;AP8jFF;;AO3jFA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AP8jFF;AO5jFE;EAEE,cNvVS;ADo5Fb;AO1jFE;EAEE,cN5VS;ADu5Fb;AOzjFI;EAEE,cN1WQ;EM2WR,eAAA;AP0jFN;AOtjFE;EACE,cNhXU;ADw6Fd;;AOpjFA;EACE,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;APujFF;AOrjFE;EACE,2BAAA;APujFJ;AOrjFE;EACE,wBAAA;APujFJ;;AOnjFA;EACE,mBN1YgB;EM2YhB,2CAAA;EACA,sBAAA;APsjFF;AOnjFE;EACE,4CAAA;APqjFJ;;AOjjFA;EACE,oCAAA;EACA,kCAAA;EACA,0BAAA;EAEA,sBAAA;EAEA,WAAA;EACA,WAAA;EACA,cAAA;EACA,6CAAA;APkjFF;AOhjFE;EACE,6BAAA;EACA,0BAAA;EACA,yBAAA;EACA,oBAAA;APkjFJ;;AO7iFA;EAEE,yBAAA;EACA,oCAAA;EACA,wCAAA;EACA,WAAA;EACA,mBAAA;EACA,kCAAA;AP+iFF;AO7iFE;EACE,wCAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,cN3bY;AD0+FhB;;AO3iFA;EAEE,yBAAA;EACA,wCAAA;AP6iFF;;AO1iFA;EACE,WAAA;AP6iFF;;AO1iFA;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;AP6iFF;;AO1iFA;EACE,oBAAA;AP6iFF;;AO1iFA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AP6iFF;;AO1iFA,YAAA;AACA;EACE,0BAAA;AP6iFF;;AO1iFA;EAGE,gCAAA;EACA,4BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AP2iFF;AOviFE;EACE,qBN1ec;EM2ed,cN3ec;EM4ed,kCAAA;APyiFJ;AOtiFE;EACE,qBAAA;EACA,cAAA;EACA,mBAAA;APwiFJ;AOriFE;EACE,qBNneS;EMoeT,cNpeS;EMqeT,mBAAA;APuiFJ;AOpiFE;EACE,qBAAA;EACA,cAAA;EACA,mCAAA;EACA,sCAAA;APsiFJ;AOniFE;EACE,qBNjgBU;EMkgBV,cNlgBU;EMmgBV,kCAAA;APqiFJ;AOliFE;EACE,qBAAA;EACA,cAAA;EACA,kCAAA;APoiFJ;AOjiFE;EACE,qBNpgBU;EMqgBV,cNrgBU;EMsgBV,gBAAA;APmiFJ;;AO/hFA;EACE,+BAAA;APkiFF;;AO/hFA;EACE,kBAAA;APkiFF;;AO/hFA;;;;EAIE,gCAAA;APkiFF;;AO/hFA;;EAEE,2BAAA;APkiFF;;AO9hFE;EACE,aAAA;EACA,uBAAA;APiiFJ;AO/hFI;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,wBAAA;APiiFN;AO9hFI;EACE;IACE,qBAAA;EPgiFN;AACF;AO7hFI;EACE;IACE,sBAAA;EP+hFN;AACF;;AO1hFA;EACE,kBAAA;EAGA,gCAAA;EACA,uCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;AP2hFF;AOzhFE;EAIE,qBNxlBY;EMylBZ,cNzlBY;EM0lBZ,kCAAA;APwhFJ;AOrhFE;EAME,qBAAA;EACA,cAAA;EACA,kCAAA;APkhFJ;AO/gFE;EAKE,mBAAA;EACA,WNzmBU;EM0mBV,iBAAA;AP6gFJ;AO1gFE;EAOE,qBAAA;EACA,cNznBW;EM0nBX,2CAAA;APsgFJ;AOngFE;EAEE,oBAAA;EACA,cNhoBW;EMioBX,kCAAA;APogFJ;;AOhgFA;EACE,cAAA;EACA,kBAAA;APmgFF;AOjgFI;EACE,YAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;APmgFN;AO//EI;EACE,qBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;APigFN;;AAzpGE;EAGE,wCAAA;EACA,6BAAA;AA0pGJ;AAxpGM;EACE,eAAA;EACA,yBCVQ;EDWR,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,WCVM;EDYN,+CCVK;EDWL,kBAAA;AAypGR;AAvpGM;EAEE,eAAA;EACA,WClBM;AD0qGd;AAtpGM;EACE;IACE,WAAA;IACA,YAAA;IACA,0BAAA;EAwpGR;EAtpGM;IACE,8BAAA;EAwpGR;AACF;AAnpGE;EACE,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,4BAAA;EACA,8BAAA;EACA,mBAAA;AAqpGJ;AAnpGI;EACE,eAAA;EACA,eAAA;EACA,iBAAA;AAqpGN;AAjpGE;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AAmpGJ","sourcesContent":["@import \"../../../../styles\";\n\n.menu {\n  &-card {\n    // min-width: 56px;\n    // height: 56px;\n    background-color: transparent !important;\n    width: min-content !important;\n    &.lang-btn {\n      mat-icon {\n        cursor: pointer;\n        background-color: $primary-color;\n        width: 3rem;\n        height: 3rem;\n        padding: 0.5rem;\n        border-radius: 50%;\n        color: $white-color;\n        @extend .d-flex-center;\n        box-shadow: $box-shadow;\n        position: relative;\n      }\n      span {\n        @extend .label-semiBold;\n        padding: 0 pxToRem(16);\n        color: $white-color;\n      }\n      @media only screen and (max-width: 769px) {\n        mat-icon {\n          width: 2rem;\n          height: 2rem;\n          padding: 1.2rem !important;\n        }\n        span {\n          font-size: pxToRem(14) !important;\n        }\n      }\n    }\n  }\n\n  &-info {\n    flex-direction: row;\n    box-sizing: border-box;\n    display: flex;\n    /* place-content: center;  */\n    justify-content: space-between;\n    align-items: center;\n\n    span {\n      padding: 0 32px;\n      font-size: 18px;\n      font-weight: bold;\n    }\n  }\n\n  &-avatar {\n    width: pxToRem(40);\n    min-width: pxToRem(40);\n    height: pxToRem(40);\n    line-height: pxToRem(40);\n    margin: 0 pxToRem(8) 0 0;\n    border-radius: 50%;\n    font-size: pxToRem(17);\n    font-weight: 600;\n    text-align: center;\n  }\n}\n","// $primary-color: #07b27e;\n$primary-color: #0d9b84;\n$accent-color: #051d30;\n$secondary-color: #0d314d;\n// $alert-color: #ba3939;\n$alert-color: #f44336;\n$white-color: #fff;\n$devider-color: #202042;\n$box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.42);\n$admin-background: var(--Linear, linear-gradient(180deg, #0d314d 0%, #051d30 100%));\n// $admin-background: #f6faf9;\n$border: #ccc;\n$background-light: #f9f9f9;\n$overlay: rgba(15, 15, 16, 0.2);\n$snackbar-bg: #323232;\n$text-color: #07213c;\n$icons-color: #77797b;\n$shapes-color: #ddeaf3;\n$lines-color: #c0c0c0;\n$scrollbar-color: rgba(80, 153, 209, 0.04);\n$secondary-color-opacity-5: rgba(100, 169, 222, 0.3);\n$scroll-color: #e5e7e8;\n$chat-color: #4776a7;\n$border-color: #99acc4;\n$font-family-en: \"Roboto\", sans-serif;\n$font-family-ar: \"Tajawal\", sans-serif;\n// $font-family-en: \"Source Sans Pro\", sans-serif;\n// $font-family-ar: \"Almarai\", sans-serif;\n:root {\n  // --secondary-color: #0d314d;\n  // --primary-color: #07b27e;\n  --secondary-color: #0d314d;\n  --primary-color: #0d9b84;\n  // --alert-color: #ba3939;\n  --alert-color: #f44336;\n\n  --devider-color: #202042;\n  --accent-color: #051d30;\n}\n\n// #e6a512\n// rgba(230, 165, 18, 0.5);\n// rgba(230, 165, 18, 0.04);\n","$fontSize: 16;\n\nhtml {\n  font-size: $fontSize + px;\n  scroll-behavior: smooth;\n  &[lang=\"en\"] {\n    font-family: $font-family-en, sans-serif !important;\n    direction: ltr !important;\n  }\n  &[lang=\"ar\"] {\n    font-family: $font-family-ar, sans-serif !important;\n    direction: rtl !important;\n  }\n}\n\n/* Styles for large screens */\n@media (min-width: 1200px) {\n  $fontSize: 12;\n  html {\n    font-size: $fontSize + px !important;\n  }\n}\n\n/* Styles for medium screens */\n@media (max-width: 1199px) {\n  $fontSize: 11.5;\n  html {\n    font-size: $fontSize + px !important;\n  }\n}\n\n/* Styles for small screens */\n@media (max-width: 576px) {\n  $fontSize: 13.5;\n  html {\n    font-size: $fontSize + px !important;\n  }\n}\n\n/* Styles for medium screens */\n@media (min-width: 577px) and (max-width: 768px) {\n  $fontSize: 13;\n  html {\n    font-size: $fontSize + px !important;\n  }\n}\n\n// convert px to rem\n@function pxToRem($pxSize) {\n  $remValue: calc($pxSize / $fontSize);\n  @return $remValue + rem;\n}\n\n@mixin textCustom($size, $line-height, $weight) {\n  font-size: pxToRem($size) !important;\n  line-height: pxToRem($line-height) !important;\n  font-weight: $weight !important;\n  font-family: $font-family-ar;\n  letter-spacing: 0 !important;\n}\n","@use \"@angular/material\" as mat;\n\n/* ======== Angular Material M3 Theme ======== */\n\n$custom-theme: mat.define-theme((\n  color: (\n    theme-type: light,\n    primary: mat.$cyan-palette,\n    tertiary: mat.$blue-palette,\n  ),\n  typography: (\n    plain-family: \"Tajawal\",\n    brand-family: \"Tajawal\",\n  ),\n));\n\nhtml {\n  @include mat.all-component-themes($custom-theme);\n}\n\n/* ======== Global UI polish ======== */\n\n// Smoother transitions on interactive elements\na, button, .mat-mdc-button, .mat-mdc-icon-button, .nav-item {\n  transition: all 0.2s ease-out;\n}\n\n// Better focus rings for accessibility\n:focus-visible {\n  outline: 2px solid $primary-color;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n// Refined dialog styling for M3\n.mat-mdc-dialog-container .mdc-dialog__surface {\n  border-radius: 1rem !important;\n}\n\n// Snackbar polish\n.mdc-snackbar__surface {\n  border-radius: 0.5rem !important;\n}\n\n// change in angular material\n\n.mat-dialog-container {\n  border-radius: 1.6rem !important;\n}\n\n.confirm-dialog {\n  .mat-dialog-container {\n    padding: 1.8rem 2.8rem 3.8rem !important;\n  }\n}\n\n.logout-dialog {\n  h2 {\n    color: var(--dark-text-color);\n    font-size: 2.4rem;\n    font-weight: bold;\n  }\n\n  .mat-icon {\n    rotate: 180deg;\n    color: var(--accent-color) !important;\n  }\n\n  h3 {\n    color: var(--dark-text-color);\n    font-size: 2.1rem;\n  }\n}\n\n.mat-spinner {\n  margin: 2rem auto;\n}\n\n//custom tabs style\n.mat-tab-group {\n  box-shadow: none !important;\n\n  .mat-tab-header {\n    border-bottom: none;\n  }\n}\n\n.mat-tab-label {\n  background-color: transparent !important;\n  opacity: 1 !important;\n\n  &.mat-tab-disabled {\n    background-color: transparent !important;\n\n    .mat-tab-label-content {\n      opacity: 1;\n    }\n  }\n\n  &.mat-tab-label-active {\n    background-color: transparent !important;\n    opacity: 1 !important;\n  }\n\n  .mat-tab-label-content {\n    color: var(--black-color);\n    font-size: 16px;\n  }\n\n  &:last-of-type {\n    margin-inline-start: auto;\n  }\n}\n\n.mat-ink-bar {\n  height: 4px !important;\n  background-color: var(--accent-color) !important;\n  transform: scale(0.5);\n}\n\ntd.mat-cell:last-of-type {\n  position: relative;\n}\n\n.mat-row:hover {\n  background-color: #e8e8e8;\n}\n\n.mat-user-card {\n  width: 70%;\n  height: 50px;\n  //background: transparent;\n  margin: 0 auto;\n  margin-top: 16px;\n  border: none;\n\n  & span {\n    margin-left: 10px;\n    line-height: 45px;\n  }\n\n  & img {\n    margin-left: 10px;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    vertical-align: middle;\n  }\n}\n.my-full-width-menu {\n  width: 400px !important;\n  max-width: 100% !important;\n  height: 400px !important;\n  max-height: 100% !important;\n  padding: 8px;\n}\n\n.mat-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0px 1.8rem !important;\n\n  .mat-header-cell {\n    min-width: 15rem;\n  }\n}\n\n.cdk-drag-preview {\n  box-sizing: border-box;\n  border-radius: 4px;\n  background-color: #f0e7e6;\n}\n\n.cdk-drag-placeholder {\n  opacity: 0;\n}\n\n.cdk-drag-animating {\n  transition: transform 100ms cubic-bezier(0, 0, 0.2, 1);\n  background-color: #f0e7e6;\n}\n\n.cdk-drop-list-dragging .mat-row:not(.cdk-drag-placeholder) {\n  transition: transform 100ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.mat-header-cell {\n  padding: 0 1rem !important;\n  text-align: center !important;\n  border: 1px solid !important;\n  border-color: var(--devider-color) !important;\n}\n\n.mat-sort-header-container {\n  justify-content: center;\n}\n\n.mat-cell {\n  text-align: center;\n  border-bottom-color: transparent !important;\n  box-shadow: 3px 3px 10px 3px #eee;\n  padding: 0 1rem !important;\n  white-space: nowrap;\n\n  p {\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &:not(:first-of-type) {\n    border-inline-start: 1.5px solid var(--devider-color);\n  }\n}\n.overlay-snackbar {\n  height: 100vh !important;\n  width: 100vw !important;\n  max-width: 100vw !important;\n  min-width: 100vw !important;\n  // background-color: $overlay;\n  margin: 0 !important;\n  direction: ltr;\n}\n\n.container-snackbar {\n  position: absolute;\n  bottom: pxToRem(56);\n  right: pxToRem(56);\n  background-color: $alert-color !important;\n  color: $white-color !important;\n  max-width: max-content !important;\n  min-width: auto !important;\n  text-align: center;\n  border-radius: pxToRem(8);\n  box-shadow: none !important;\n  display: flex;\n  padding: pxToRem(10) pxToRem(24);\n  justify-content: flex-end;\n  align-items: center;\n  gap: pxToRem(10);\n  @media only screen and (max-width: 768px) {\n    right: 1rem;\n    bottom: 5rem;\n  }\n}\n\n.success-snackbar {\n  @extend .overlay-snackbar;\n  &.mat-mdc-snack-bar-container {\n    .mdc-snackbar__surface {\n      @extend .container-snackbar;\n      background-color: $primary-color !important;\n      .mdc-snackbar__label {\n        direction: rtl;\n        white-space: pre;\n        display: flex;\n        align-items: center;\n        @extend .label-medium-2;\n        padding: 0 !important;\n      }\n    }\n  }\n}\n\n.error-snackbar {\n  @extend .overlay-snackbar;\n  &.mat-mdc-snack-bar-container {\n    .mdc-snackbar__surface {\n      @extend .container-snackbar;\n      .mdc-snackbar__label {\n        direction: rtl;\n        white-space: pre;\n        display: flex;\n        align-items: center;\n        @extend .label-medium-2;\n        padding: 0 !important;\n      }\n    }\n  }\n}\n","@use '../style/elevation';\n@use '../style/sass-utils';\n@use './m3-system';\n@use 'sass:list';\n@use 'sass:map';\n@use 'sass:string';\n\n$_tokens: null;\n$_component-prefix: null;\n$_system-fallbacks: m3-system.create-system-fallbacks();\n\n// Sets the token prefix and map to use when creating token slots.\n@mixin use-tokens($prefix, $tokens) {\n  $_component-prefix: $prefix !global;\n  $_tokens: $tokens !global;\n\n  @content;\n\n  $_component-prefix: null !global;\n  $_tokens: null !global;\n}\n\n// Combines a prefix and a string to generate a CSS variable name for a token.\n@function _create-var-name($prefix, $token) {\n  @if $prefix == null or $token == null {\n    @error 'Must specify both prefix and name when generating token';\n  }\n\n  $string-prefix: '';\n\n  // Prefixes are lists so we need to combine them.\n  @each $part in $prefix {\n    $string-prefix: if($string-prefix == '', $part, '#{$string-prefix}-#{$part}');\n  }\n\n  @return string.unquote('--#{$string-prefix}-#{$token}');\n}\n\n// Creates a CSS variable, including the fallback if provided.\n@function _create-var($name, $fallback: null) {\n  @if ($fallback) {\n    @return var($name, $fallback);\n  } @else {\n    @return var($name);\n  }\n}\n\n// Gets the value of the token given the current global context state.\n@function _get-token-value($token, $fallback) {\n  $var-name: _create-var-name($_component-prefix, $token);\n  $fallback: _get-token-fallback($token, $fallback);\n  @return _create-var($var-name, $fallback);\n}\n\n// Assertion mixin that throws an error if the global state has not been set up by wrapping\n// calls with `use-tokens`.\n@function _assert-use-tokens($token) {\n  @if $_component-prefix == null or $_tokens == null {\n    @error 'Function was not called within a wrapping call of `use-tokens`';\n  }\n  @if not map.has-key($_tokens, $token) {\n    @error 'Token #{$token} does not exist. Configured tokens are: #{map.keys($_tokens)}';\n  }\n\n  @return true;\n}\n\n// Emits a slot for the given token, provided that it has a non-null value in the token map passed\n// to `use-tokens`.\n// Accepts an optional fallback parameter to include in the CSS variable.\n// If $fallback is `true`, then use the tokens map to get the fallback.\n// TODO: Remove the use case where we accept \"true\" and handle any failing client screenshots\n@mixin create-token-slot($property, $token, $fallback: null) {\n  $_assert: _assert-use-tokens($token);\n  @if map.get($_tokens, $token) != null {\n    #{$property}: #{_get-token-value($token, $fallback)};\n  }\n}\n\n// Returns the name of a token including the current prefix. Intended to be used in calculations\n// involving tokens. `create-token-slot` should be used when outputting tokens.\n@function get-token-variable-name($token) {\n  $_assert: _assert-use-tokens($token);\n  @return _create-var-name($_component-prefix, $token);\n}\n\n// Returns a `var()` reference to a specific token. Intended for declarations\n// where the token has to be referenced as a part of a larger expression.\n// Accepts an optional fallback parameter to include in the CSS variable.\n// If $fallback is `true`, then use the tokens map to get the fallback.\n// TODO: Remove the use case where we accept \"true\" and handle any failing client screenshots\n@function get-token-variable($token, $fallback: null) {\n  $_assert: _assert-use-tokens($token);\n  @return _get-token-value($token, $fallback);\n}\n\n// Gets the token's fallback value. Prefers adding a system-level fallback if one exists, otherwise\n// use the provided fallback.\n@function _get-token-fallback($token, $fallback: null) {\n  // If the $fallback is `true`, this is the component's signal to use the current token map value\n  @if ($fallback == true) {\n    $fallback: map.get($_tokens, $token);\n  }\n\n  // Check whether there's a system-level fallback. If not, return the optional\n  // provided fallback (otherwise null).\n  $sys-fallback: map.get($_system-fallbacks, $_component-prefix, $token);\n  @if (not $sys-fallback) {\n    @return $fallback;\n  }\n\n  @if (sass-utils.is-css-var-name($sys-fallback)) {\n    @return _create-var($sys-fallback, $fallback);\n  }\n\n  @return $sys-fallback;\n}\n\n// Outputs a map of tokens under a specific prefix.\n@mixin create-token-values($prefix, $tokens) {\n  @if $tokens != null {\n    // TODO: The `&` adds to the file size of theme, but it's necessary for compatibility\n    // with https://sass-lang.com/documentation/breaking-changes/mixed-decls/. We should\n    // figure out a better way to do this or move all the concrete styles out of the theme.\n    & {\n      @each $key, $value in $tokens {\n        @if $value != null {\n          #{_create-var-name($prefix, $key)}: #{$value};\n        }\n      }\n    }\n  }\n}\n\n// MDC doesn't currently handle elevation tokens properly. As a temporary workaround we can combine\n// the elevation and shadow-color tokens into a full box-shadow and use it as the value for the\n// elevation token.\n@function resolve-elevation($tokens, $elevation-token, $shadow-color-token) {\n  $elevation: map.get($tokens, $elevation-token);\n  $shadow-color: map.get($tokens, $shadow-color-token);\n  @return map.merge(\n    $tokens,\n    (\n      $elevation-token: elevation.get-box-shadow($elevation, $shadow-color),\n      $shadow-color-token: null,\n    )\n  );\n}\n\n/// Checks whether a list starts wih a given prefix\n/// @param {List} $list The list value to check the prefix of.\n/// @param {List} $prefix The prefix to check.\n/// @return {Boolean} Whether the list starts with the prefix.\n@function _is-prefix($list, $prefix) {\n  @for $i from 1 through list.length($prefix) {\n    @if list.nth($list, $i) != list.nth($prefix, $i) {\n      @return false;\n    }\n  }\n  @return true;\n}\n\n/// Gets the supported color variants in the given token set for the given prefix.\n/// @param {Map} $tokens The full token map.\n/// @param {List} $prefix The component prefix to get color variants for.\n/// @return {List} The supported color variants.\n@function _supported-color-variants($tokens, $prefix) {\n  $result: ();\n  @each $namespace in map.keys($tokens) {\n    @if list.length($prefix) == list.length($namespace) - 1 and _is-prefix($namespace, $prefix) {\n      $result: list.append($result, list.nth($namespace, list.length($namespace)), comma);\n    }\n  }\n  @return $result;\n}\n\n/// Gets the token values for the given components prefix with the given options.\n/// @param {Map} $tokens The full token map.\n/// @param {List} $prefix The component prefix to get the token values for.\n/// @param {ArgList} Any additional options\n///   Currently the additional supported options are:\n//     - $color-variant - The color variant to use for the component\n//     - $emit-overrides-only - Whether to emit *only* the overrides for the\n//                              specific color variant, or all color styles. Defaults to false.\n/// @throws If given options are invalid\n/// @return {Map} The token values for the requested component.\n@function get-tokens-for($tokens, $prefix, $options...) {\n  $options: sass-utils.validate-keyword-args($options, (color-variant, emit-overrides-only));\n  @if $tokens == () {\n    @return ();\n  }\n  $values: map.get($tokens, $prefix);\n  $color-variant: map.get($options, color-variant);\n  $emit-overrides-only: map.get($options, emit-overrides-only);\n  @if $color-variant == null {\n    @return $values;\n  }\n  $overrides: map.get($tokens, list.append($prefix, $color-variant));\n  @if $overrides == null {\n    $variants: _supported-color-variants($tokens, $prefix);\n    $secondary-message: if(\n      $variants == (),\n      'Mixin does not support color variants',\n      'Supported color variants are: #{$variants}'\n    );\n\n    @error 'Invalid color variant: #{$color-variant}. #{$secondary-message}.';\n  }\n  @return if($emit-overrides-only, $overrides, map.merge($values, $overrides));\n}\n\n/// Emits new token values for the given token overrides.\n/// Verifies that the overrides passed in are valid tokens.\n/// New token values are emitted under the current selector or root.\n@mixin batch-create-token-values($overrides: (), $namespace-configs...) {\n  @include sass-utils.current-selector-or-root() {\n    $prefixed-name-data: ();\n    $unprefixed-name-data: ();\n    $all-names: ();\n\n    @each $config in $namespace-configs {\n      $namespace: map.get($config, namespace);\n      $prefix: if(map.has-key($config, prefix), map.get($config, prefix), '');\n      $tokens: _filter-nulls(map.get($config, tokens));\n      @each $name, $value in $tokens {\n        $prefixed-name: $prefix + $name;\n        $all-names: list.append($all-names, $prefixed-name, $separator: comma);\n        @if map.has-key($prefixed-name-data, $prefixed-name) {\n          @error #{\n          'Error overriding token: Ambiguous token name `'\n        }#{\n          $prefixed-name\n        }#{\n          '` exists in multiple namespaces: `('\n        }#{\n          list.nth(map.get($prefixed-name-data, $prefixed-name), 1)\n        }#{\n          ')` and `('\n        }#{\n          $namespace\n        }#{\n          ')`'\n        };\n        }\n        $prefixed-name-data: map.set($prefixed-name-data, $prefixed-name, ($namespace, $name));\n        $unprefixed-data: map.has-key($unprefixed-name-data, $name) and\n          map.get($unprefixed-name-data, $name) or\n          ();\n        $unprefixed-data: list.append($unprefixed-data, ($namespace, $prefixed-name));\n        $unprefixed-name-data: map.set($unprefixed-name-data, $name, $unprefixed-data);\n      }\n    }\n\n    @each $name, $value in $overrides {\n      @if map.has-key($prefixed-name-data, $name) {\n        $data: map.get($prefixed-name-data, $name);\n        $namespace: list.nth($data, 1);\n        $name: list.nth($data, 2);\n        @include create-token-values(\n          $namespace,\n          (\n            $name: $value,\n          )\n        );\n      } @else if (map.has-key($unprefixed-name-data, $name)) {\n        $datalist: map.get($unprefixed-name-data, $name);\n        $prefixed-names: ();\n        @each $data in $datalist {\n          $namespace: list.nth($data, 1);\n          $prefixed-names: list.append($prefixed-names, list.nth($data, 2), $separator: comma);\n          @include create-token-values(\n            $namespace,\n            (\n              $name: $value,\n            )\n          );\n        }\n        @warn #{\n        'Token `'\n      }#{\n        $name\n      }#{\n        '` is deprecated. Please use one of the following alternatives: '\n      }#{\n        $prefixed-names\n      };\n      } @else {\n        @error #{'Invalid token name `'}#{$name}#{'`. '}#{'Valid tokens are: '}#{$all-names};\n      }\n    }\n  }\n}\n\n/// Filters keys with a null value out of the map.\n/// @param {Map} $map The map to filter.\n/// @return {Map} The given map with all of the null keys filtered out.\n@function _filter-nulls($map) {\n  $result: ();\n  @each $key, $val in $map {\n    @if $val != null {\n      $result: map.set($result, $key, $val);\n    }\n  }\n  @return $result;\n}\n","::ng-deep {\n  // Hidden globally until 2026-09-05. mat-error and mat-hint render inside this\n  // wrapper, so hiding it made every Angular Material validation message and\n  // hint in the admin panel invisible — the forms turned a field red and told\n  // the user nothing. Kept collapsed when there is nothing to show so the old\n  // spacing is preserved on screens that never had a hint.\n  .mat-mdc-form-field-subscript-wrapper {\n    display: block;\n    // Its only child is absolutely positioned, so without a reserved height\n    // the hint or error paints on top of the next row of the form.\n    min-height: pxToRem(20);\n  }\n  .mat-mdc-form-field-subscript-wrapper:not(:has(.mat-mdc-form-field-error)):not(:has(.mat-mdc-form-field-hint)) {\n    display: none;\n  }\n  .mat-mdc-form-field-infix {\n    min-height: pxToRem(48) !important;\n    height: pxToRem(48) !important;\n  }\n\n  .mat-mdc-form-field-flex {\n    display: flex;\n    align-items: center;\n  }\n\n  .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mat-mdc-form-field-infix {\n    padding: pxToRem(6) 0 !important;\n    display: flex;\n    align-items: center;\n  }\n\n  .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing {\n    border-radius: pxToRem(8) !important;\n    border-width: 1px !important;\n    border-color: $icons-color !important;\n  }\n\n  .mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__trailing {\n    border-radius: pxToRem(8) !important;\n    border-width: 1px !important;\n    border-color: $primary-color !important;\n  }\n\n  .mdc-text-field--no-label:not(.mdc-text-field--textarea) .mat-mdc-form-field-input-control.mdc-text-field__input,\n  .mdc-text-field--focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-input-control {\n    caret-color: $primary-color !important;\n  }\n\n  .mdc-text-field--outlined:not(.mdc-text-field--disabled)\n    .mdc-text-field--focused\n    .mdc-notched-outline\n    .mdc-notched-outline__leading {\n    border-color: $primary-color !important;\n  }\n\n  .mdc-text-field--no-label:not(.mdc-text-field--textarea) .mat-mdc-form-field-input-control.mdc-text-field__input,\n  .mat-mdc-text-field-wrapper .mat-mdc-form-field-input-control {\n    height: 100%;\n  }\n  .mdc-text-field--outlined.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-text-field__input {\n    caret-color: $alert-color !important;\n  }\n  .mdc-text-field--outlined .mdc-notched-outline,\n  .mdc-text-field--outlined.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing,\n  .mdc-text-field--outlined.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__leading {\n    border-color: $alert-color !important;\n    border-radius: pxToRem(8) !important;\n    border-width: 1px !important;\n  }\n\n  // The overrides below draw the whole outlined box with __trailing and hide\n  // __leading. That works only when the field has no floating label: with a\n  // label, __notch still takes flex space and pushes the label outside the\n  // visible box, which is what collapsed every labelled form in the admin\n  // panel (the super-admin wizard, the manual pipeline form, and ~20 more).\n  // Scope them to no-label fields and let Angular Material own the structure\n  // wherever a <mat-label> is present.\n  .mdc-text-field--no-label .mdc-notched-outline__leading {\n    display: none;\n  }\n  .mdc-text-field--no-label .mdc-notched-outline__trailing {\n    border-inline-start: 1px solid !important;\n    border-radius: pxToRem(8) !important;\n  }\n  .mat-mdc-text-field-wrapper.mdc-text-field--outlined:not(.mdc-text-field--no-label) {\n    .mdc-notched-outline__leading {\n      display: block;\n    }\n    .mdc-notched-outline__trailing {\n      border-inline-start: 0 !important;\n      border-start-start-radius: 0 !important;\n      border-end-start-radius: 0 !important;\n    }\n    // A fixed 48px infix leaves no room for the label to float into.\n    .mat-mdc-form-field-infix {\n      height: auto !important;\n      min-height: auto !important;\n      display: block !important;\n      padding: pxToRem(16) 0 !important;\n    }\n  }\n  .mat-mdc-form-field-error {\n    margin-top: pxToRem(8) !important;\n    color: $alert-color !important;\n  }\n\n  .mat-mdc-form-field-bottom-align::before {\n    height: auto !important;\n  }\n\n  .mat-mdc-button .mat-mdc-button-persistent-ripple::before {\n    background-color: transparent !important;\n  }\n\n  .mat-mdc-button .mat-mdc-button-ripple,\n  .mat-mdc-unelevated-button .mat-mdc-button-ripple,\n  .mat-mdc-raised-button .mat-mdc-button-ripple,\n  .mat-mdc-outlined-button .mat-mdc-button-ripple,\n  .mat-mdc-button .mat-mdc-button-touch-target {\n    display: none !important;\n    visibility: hidden !important;\n  }\n  .mat-mdc-dialog-container .mdc-dialog__surface {\n    border-radius: 1rem !important;\n    overflow: hidden;\n    @media only screen and (max-width: 768px) {\n      height: auto !important;\n    }\n  }\n  @media only screen and (max-width: 768px) {\n    .dialog-container {\n      padding: 1rem !important;\n    }\n    .mdc-dialog .mdc-dialog__content {\n      padding: 0 !important;\n      height: 60vh;\n    }\n  }\n\n  .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,\n  .mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,\n  .mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=\"true\"]:enabled ~ .mdc-checkbox__background {\n    background-color: $primary-color !important;\n    border-color: $primary-color !important;\n  }\n\n  .mat-mdc-button[disabled][disabled] {\n    pointer-events: none;\n    opacity: 0.5;\n  }\n\n  // ---------------------------------------------------------------------\n  // Shared control language, added 2026-09-05.\n  // Buttons and outlined fields were styled ad hoc per screen, so the console\n  // read as several products stitched together. One radius, one weight, one\n  // focus colour, applied to the Material primitives every page already uses.\n  // Sizes are min-height, never height, so nothing that relies on its own\n  // taller control is clipped.\n  // ---------------------------------------------------------------------\n  .mat-mdc-raised-button,\n  .mat-mdc-unelevated-button,\n  .mat-mdc-outlined-button,\n  .mat-mdc-button {\n    min-height: pxToRem(42);\n    border-radius: pxToRem(10) !important;\n    font-weight: 600;\n    letter-spacing: 0;\n    text-transform: none;\n    padding-inline: pxToRem(20);\n  }\n\n  .mat-mdc-raised-button:not([disabled]),\n  .mat-mdc-unelevated-button:not([disabled]) {\n    box-shadow:\n      0 1px 2px rgba(15, 23, 42, 0.08),\n      0 2px 6px rgba(15, 23, 42, 0.06);\n    &:hover {\n      box-shadow:\n        0 2px 4px rgba(15, 23, 42, 0.1),\n        0 6px 16px rgba(15, 23, 42, 0.1);\n    }\n  }\n\n  .mat-mdc-outlined-button:not([disabled]) {\n    border-color: rgba(15, 23, 42, 0.18);\n    &:hover {\n      border-color: $primary-color;\n      color: $primary-color;\n    }\n  }\n\n  // Outlined fields: same corner and the brand focus colour on every edge, so\n  // a focused input matches a focused button.\n  .mat-mdc-text-field-wrapper.mdc-text-field--outlined {\n    .mdc-notched-outline__leading,\n    .mdc-notched-outline__notch,\n    .mdc-notched-outline__trailing {\n      border-color: $border-color;\n    }\n    &.mdc-text-field--focused {\n      .mdc-notched-outline__leading,\n      .mdc-notched-outline__notch,\n      .mdc-notched-outline__trailing {\n        border-color: $primary-color !important;\n        border-width: 1px !important;\n      }\n    }\n  }\n  .mdc-text-field--outlined .mdc-notched-outline__leading {\n    border-start-start-radius: pxToRem(8);\n    border-end-start-radius: pxToRem(8);\n  }\n  .mdc-text-field--outlined .mdc-notched-outline__trailing {\n    border-start-end-radius: pxToRem(8);\n    border-end-end-radius: pxToRem(8);\n  }\n  .mat-mdc-form-field.mat-focused .mat-mdc-floating-label {\n    color: $primary-color;\n  }\n\n  // Cards: one elevation instead of per-page shadows.\n  .mat-mdc-card {\n    border-radius: pxToRem(16);\n    border: 1px solid rgba(15, 23, 42, 0.07);\n    box-shadow:\n      0 1px 2px rgba(15, 23, 42, 0.04),\n      0 4px 16px rgba(15, 23, 42, 0.06) !important;\n  }\n\n  .mat-mdc-tab .mdc-tab__text-label {\n    font-weight: 600;\n    letter-spacing: 0;\n  }\n}\n","app-data-table {\n  display: block;\n  // margin: pxToRem(160) pxToRem(48) pxToRem(56) pxToRem(80);\n  padding: 0 !important;\n\n  // table\n  table {\n    position: relative;\n    z-index: 0;\n    border-collapse: separate !important;\n    border-spacing: 0 1rem !important;\n    background: transparent !important;\n    box-shadow: none !important;\n    height: fit-content;\n    padding-inline-end: pxToRem(64) !important;\n    padding-inline-start: pxToRem(48) !important;\n\n    @media only screen and (max-width: 768px) {\n      padding-inline-end: pxToRem(20) !important;\n      padding-inline-start: pxToRem(20) !important;\n    }\n\n    .mat-mdc-header-cell {\n      text-align: center !important;\n      color: $white-color;\n      @extend .label-medium;\n    }\n\n    .mdc-data-table__cell {\n      text-align: center !important;\n      color: $accent-color;\n      @extend .label-medium;\n    }\n\n    tr.mat-mdc-header-row {\n      background-color: $primary-color;\n      position: sticky;\n      position: -webkit-sticky; /* Safari */\n      z-index: 100;\n      top: 0;\n    }\n\n    th.mat-mdc-header-cell {\n      border-top: none !important;\n      border-bottom: none !important;\n      background-color: $primary-color;\n      color: $white-color !important;\n      text-align: center;\n      padding: pxToRem(16) 0;\n      font-weight: 600 !important;\n      @media only screen and (max-width: 768px) {\n        padding: 0;\n      }\n      .mat-sort-header-arrow {\n        display: none !important;\n      }\n    }\n\n    th.mat-mdc-header-cell:first-child {\n      border-start-start-radius: pxToRem(8);\n      border-end-start-radius: pxToRem(8);\n    }\n\n    th.mat-mdc-header-cell:last-child {\n      border-start-end-radius: pxToRem(8);\n      border-end-end-radius: pxToRem(8);\n    }\n\n    td.mat-mdc-cell:first-child,\n    th.mat-mdc-header-cell:first-child {\n      border-inline-start: none;\n    }\n\n    td.mat-mdc-cell:last-child,\n    th.mat-mdc-header-cell:last-child {\n      border-inline-end: 1px solid $border;\n    }\n\n    tr.mat-mdc-row {\n      background-color: $background-light;\n      position: relative;\n      transition: background-color 0.15s ease-out;\n\n      &:nth-child(even) {\n        background-color: #ffffff;\n      }\n\n      &:hover {\n        background-color: rgba(13, 155, 132, 0.06) !important;\n      }\n      &.customRowActionFlag {\n        cursor: pointer;\n      }\n    }\n\n    td.mat-mdc-cell {\n      text-align: center;\n      border-top: 1px solid $border !important;\n      border-bottom: 1px solid $border !important;\n      min-width: 10rem;\n      // width: 18.75rem;\n      // min-width: 18.75rem;\n      // max-width: 18.75rem;\n      padding: 0.05rem pxToRem(30);\n\n      img {\n        object-fit: contain !important;\n      }\n\n      .platformWidth {\n        width: 15rem !important;\n        min-width: auto;\n        margin: auto;\n      }\n\n      .data-text {\n        padding: pxToRem(20) 0;\n        @media only screen and (max-width: 768px) {\n          padding: 0;\n        }\n        direction: ltr;\n        white-space: nowrap;\n\n        // width: 20rem;\n        &.tooltip {\n          // width: 12rem;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          margin: auto;\n          // direction: rtl !important;\n        }\n\n        &.bank-status[data-value=\"مفعل\"]::after {\n          content: \"مفعل\";\n          display: block;\n          border: 0.5px solid $secondary-color;\n          background: rgba(7, 178, 126, 0.1);\n          color: $secondary-color;\n          @extend .isDisabled-rounded;\n        }\n\n        &.bank-status[data-value=\"غير مفعل\"]::after {\n          content: \"غير مفعل\";\n          display: block;\n          border: 0.5px solid $alert-color;\n          background: rgba(186, 57, 57, 0.2);\n          color: $alert-color;\n          @extend .isDisabled-rounded;\n        }\n\n        &.bank-status {\n          span {\n            display: none;\n          }\n        }\n      }\n\n      .isDisabled-rounded {\n        border-radius: pxToRem(8) !important;\n        padding: pxToRem(3) pxToRem(7);\n        @extend .body-medium-2;\n        white-space: nowrap;\n        width: 5rem;\n        margin: auto;\n      }\n      .isDisabled {\n        span {\n          display: none;\n        }\n\n        &[data-value=\"1\"] {\n          &::after {\n            content: \"غير مفعل\";\n            display: block;\n            border: 0.5px solid $alert-color;\n            background: rgba(186, 57, 57, 0.2);\n            color: $alert-color;\n            @extend .isDisabled-rounded;\n          }\n        }\n\n        &[data-value=\"0\"] {\n          .span {\n            display: none;\n          }\n          &::after {\n            content: \"مفعل\";\n            display: block;\n            border: 0.5px solid $secondary-color;\n            background: rgba(7, 178, 126, 0.1);\n            color: $secondary-color;\n            @extend .isDisabled-rounded;\n          }\n        }\n      }\n\n      .mat-mdc-select {\n        // width: 20rem;\n\n        display: flex;\n        justify-content: center;\n        &.mat-mdc-select-disabled {\n          .mat-mdc-select-value-text,\n          .mat-mdc-select-arrow {\n            color: $icons-color !important;\n            border-color: $icons-color !important;\n            pointer-events: none;\n          }\n        }\n\n        &[aria-expanded=\"true\"] {\n          .mat-mdc-select-arrow {\n            transform: rotate(-135deg) !important;\n            -webkit-transform: rotate(-135deg);\n            border-color: $primary-color !important;\n          }\n        }\n\n        .mat-mdc-select-value-text {\n          color: $primary-color !important;\n        }\n\n        .mat-mdc-select-trigger {\n          width: auto !important;\n          gap: 0.5rem;\n          position: unset;\n        }\n\n        .mat-mdc-select-arrow {\n          position: unset;\n          transform: rotate(45deg) !important;\n          -webkit-transform: rotate(45deg);\n          border: solid $primary-color;\n          border-width: 0 2px 2px 0;\n          padding: 2.5px;\n          width: unset !important;\n          height: unset !important;\n\n          svg {\n            display: none !important;\n          }\n        }\n      }\n\n      .inquiry_number,\n      .question_number {\n        @extend .title-medium-3;\n        @extend .d-flex-center;\n        color: $secondary-color;\n        background-color: rgba(7, 178, 126, 0.1);\n        padding: 0 pxToRem(8);\n        width: 30%;\n        padding: 0 2rem;\n        margin: auto;\n        border-radius: pxToRem(4);\n      }\n\n      .inquiry_name {\n        min-width: 30rem !important;\n      }\n\n      .inquiry_status {\n        @extend .inquiry_status;\n      }\n\n      .question_name {\n        min-width: 25rem !important;\n        width: 12rem !important;\n      }\n      // .iconAction {\n      //   cursor: pointer;\n      //   font-size: 32px;\n      //   width: 32px;\n      //   height: 32px;\n      //   font-weight: 300;\n      // }\n    }\n\n    .btn-show {\n      // min-width: 12rem;\n      margin: 0 !important;\n\n      &.customHover {\n        &:hover {\n          color: $primary-color !important;\n        }\n      }\n\n      &.mat-mdc-button .mdc-button__label,\n      &.mat-mdc-unelevated-button .mdc-button__label,\n      &.mat-mdc-raised-button .mdc-button__label,\n      &.mat-mdc-outlined-button .mdc-button__label {\n        max-width: 12rem;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n\n      &.show-data {\n        @extend .title-large-3;\n        gap: pxToRem(5);\n        &::after {\n          font-family: \"Material Symbols Outlined\";\n          content: \"\\e941\";\n          position: relative;\n          display: block;\n          font-size: 24px;\n          transform: rotateZ(180deg);\n          font-weight: 300;\n        }\n      }\n\n      &.show-profile {\n        font-weight: 600;\n        color: $primary-color !important;\n        &:hover {\n          color: $secondary-color !important;\n        }\n        &.mat-mdc-button .mdc-button__label,\n        &.mat-mdc-unelevated-button .mdc-button__label,\n        &.mat-mdc-raised-button .mdc-button__label,\n        &.mat-mdc-outlined-button .mdc-button__label {\n          max-width: unset;\n        }\n      }\n\n      &.delete-admin {\n        cursor: pointer;\n        &.condition {\n          display: none !important;\n        }\n        &::after {\n          font-family: \"Material Symbols Outlined\";\n          content: \"delete\";\n          position: relative;\n          display: block;\n          font-size: 32px;\n          width: 32px;\n          height: 32px;\n          font-weight: 300;\n          color: $alert-color;\n        }\n      }\n\n      &.block-user {\n        cursor: pointer;\n        &.condition {\n          &::after {\n            font-family: \"Material Symbols Outlined\";\n            content: \"lock_open_right\";\n            position: relative;\n            display: block;\n            font-size: 32px;\n            width: 32px;\n            height: 32px;\n            font-weight: 300;\n            color: $secondary-color;\n          }\n        }\n        &::after {\n          font-family: \"Material Symbols Outlined\";\n          content: \"lock\";\n          position: relative;\n          display: block;\n          font-size: 32px;\n          width: 32px;\n          height: 32px;\n          font-weight: 300;\n          color: $alert-color;\n        }\n      }\n    }\n  }\n\n  // divider\n  .mat-divider {\n    display: none;\n  }\n\n  // content header\n  .content-page-header {\n    width: 100% !important;\n    margin-right: unset !important;\n    margin-bottom: pxToRem(70) !important;\n    margin-left: unset !important;\n    padding-inline-start: pxToRem(48) !important;\n    padding-inline-end: pxToRem(80) !important;\n\n    @media only screen and (max-width: 768px) {\n      padding: pxToRem(20) 0;\n      margin-bottom: pxToRem(20) !important;\n      padding-inline-end: pxToRem(20) !important;\n      padding-inline-start: pxToRem(20) !important;\n      // position: sticky;\n      // top: 0;\n      // background: $white-color;\n      // z-index: 5;\n    }\n    .contents {\n      padding: unset !important;\n      gap: 8rem;\n      align-items: flex-start !important;\n      // justify-content: flex-start !important;\n      @media only screen and (max-width: 768px) {\n        flex-direction: column !important;\n        position: relative;\n        gap: 1rem !important;\n        align-items: flex-start !important;\n        .header-title h2 {\n          white-space: normal !important;\n        }\n      }\n      .header-title h2 {\n        color: $secondary-color !important;\n        font-size: 2rem !important;\n        font-weight: 700 !important;\n        line-height: 1.4 !important;\n        white-space: nowrap;\n        letter-spacing: -0.01em;\n        position: relative;\n        padding-bottom: 0.4rem;\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          bottom: 0;\n          inset-inline-start: 0;\n          width: 2.5rem;\n          height: 3px;\n          background: $primary-color;\n          border-radius: 2px;\n        }\n      }\n      .k-ng-search {\n        width: 28%;\n        .search-btn {\n          position: absolute;\n          left: -8rem;\n          bottom: -0.2rem;\n          background-color: $primary-color !important;\n          @media only screen and (max-width: 768px) {\n            bottom: 4px !important;\n            left: -7rem !important;\n          }\n        }\n        mat-form-field {\n          width: 100%;\n          .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mat-mdc-form-field-infix {\n            gap: 0.4rem;\n          }\n\n          &.ng-touch.ng-invalid.ng-dirty.mat-form-field-invalid.ng-touched\n            .mdc-notched-outline.mdc-notched-outline--no-label.mdc-notched-outline--notched {\n            border-color: $alert-color !important;\n            border-radius: pxToRem(8) !important;\n            border-width: 1px !important;\n          }\n\n          input::placeholder {\n            color: $icons-color;\n            @extend .body-medium;\n            font-size: 1.1rem !important;\n            // line-height: unset !important;\n          }\n        }\n\n        mat-icon {\n          font-family: \"Material Symbols Outlined\";\n          color: $icons-color;\n          font-size: 20px;\n          height: 20px;\n          width: 20px;\n          &.search-icon {\n            cursor: pointer;\n          }\n          &.close-icon {\n            color: $secondary-color !important;\n            cursor: pointer;\n          }\n        }\n\n        @media only screen and (max-width: 768px) {\n          width: 75%;\n        }\n      }\n      .k-ng-filter {\n        mat-form-field {\n          .mat-mdc-text-field-wrapper {\n            height: 3rem;\n          }\n        }\n      }\n      .header-actions {\n        // width: 60%;\n        gap: pxToRem(12) !important;\n        justify-content: space-between;\n        align-items: flex-start;\n        @media only screen and (max-width: 768px) {\n          .k-ng-filter {\n            margin-inline-end: auto;\n          }\n        }\n        .add {\n          margin-left: 0.5rem;\n          width: 50%;\n          box-shadow: $box-shadow;\n        }\n        .btn {\n          height: 3rem !important;\n          width: max-content;\n          padding: 0 1rem !important;\n          &.delete-maqare {\n            border: 1px solid $alert-color !important;\n            color: $alert-color !important;\n            background-color: $white-color !important;\n          }\n\n          &.date-filter {\n            border: 1px solid $primary-color !important;\n            color: $primary-color !important;\n            background-color: $white-color !important;\n          }\n        }\n\n        .btnActions-resp {\n          .mat-mdc-button mat-icon {\n            margin: 0 !important;\n            color: $primary-color;\n            font-size: 1.5rem;\n            height: 1.5rem;\n            width: 1.5rem;\n          }\n          .mdc-button {\n            min-width: unset !important;\n            padding: 0 !important;\n            position: absolute;\n            top: 0;\n            left: 0 !important;\n            right: unset !important;\n          }\n        }\n\n        // .btn-action {\n        //   // width: 30%;\n        //   @extend .d-flex;\n        //   gap: pxToRem(16);\n        // }\n      }\n    }\n  }\n\n  // content body\n  // 2026-05-06 G+5 — shrink to readable max width (1400px) on\n  // wide screens so the data-table doesn't sprawl. Below 1024px\n  // the page reverts to full width so mobile/tablet stay edge-to-edge.\n  .content-page-body {\n    width: 100% !important;\n    max-width: 1400px;\n    margin-inline: auto;\n    @media only screen and (max-width: 1024px) {\n      max-width: 100%;\n    }\n    @media only screen and (max-width: 768px) {\n      margin-block-end: 5rem !important;\n    }\n    .empty-state {\n      @extend .d-flex-center;\n      flex-direction: column;\n      padding-top: pxToRem(100);\n      flex-direction: column;\n      gap: pxToRem(48);\n      color: $text-color;\n\n      figure {\n        img {\n          display: block;\n          width: 100%;\n        }\n      }\n\n      .message {\n        @extend .label-medium-2;\n        color: $icons-color;\n      }\n    }\n\n    .table-loading-spinner {\n      padding-top: pxToRem(120) !important;\n      @extend .d-flex-center;\n    }\n\n    .table-border {\n      min-height: 60vh;\n      max-height: 70vh !important;\n      margin-inline-end: pxToRem(80);\n\n      &.scroll_width {\n        margin-inline-end: 0 !important;\n        max-width: 100%;\n        // padding-inline-end: pxToRem(80) !important;\n        // padding-inline-start: pxToRem(48) !important;\n        padding: 0 !important;\n        // overflow: hidden;\n        overflow: auto;\n        padding-bottom: 2rem !important;\n        &:hover {\n          overflow: auto;\n          // cursor: grabbing;\n          // cursor: -webkit-grabbing;\n          -webkit-overflow-scrolling: touch;\n        }\n        &::-webkit-scrollbar {\n          width: 0.8rem !important;\n          height: 0.8rem !important;\n        }\n        @media only screen and (max-width: 1280px) {\n          overflow: auto;\n        }\n      }\n\n      @media only screen and (min-width: 769px) and (max-height: 750px) {\n        max-height: 63vh !important;\n        padding-inline-end: 1rem;\n      }\n\n      @media only screen and (min-width: 769px) and (max-height: 650px) {\n        max-height: 55vh !important;\n      }\n\n      @media only screen and (max-width: 768px) {\n        min-height: unset !important;\n        max-height: unset !important;\n        height: auto !important;\n        // margin-block-end: 35% !important;\n      }\n    }\n  }\n\n  // .tooltip {\n  //   // position: relative;\n  //   display: inline-block;\n  //   max-width: 5rem;\n  //   overflow: hidden;\n  //   text-overflow: ellipsis;\n  //   direction: rtl !important;\n  // }\n\n  // .tooltip .tooltip:hover .tooltiptext {\n  //   visibility: visible;\n  // }\n\n  // pagination\n  app-pagination {\n    // bottom: 2.5rem !important;\n    // padding: pxToRem(34) 0 0 pxToRem(84);\n    // width: 100%;\n    padding: 0.5rem 0 2rem;\n    width: 85%;\n    position: fixed !important;\n    @media only screen and (max-width: 768px) {\n      position: relative !important;\n      width: 100%;\n      padding: 0 !important;\n    }\n    .pagination {\n      // width: 100%;\n      position: relative;\n      bottom: 0rem;\n      background: $white-color;\n      padding: pxToRem(11) 0 0 0;\n      padding-inline-end: pxToRem(84);\n      // margin-inline-start: 3rem !important;\n      @media only screen and (max-width: 1400px) {\n        // bottom: 1rem !important;\n      }\n      @media only screen and (max-width: 768px) {\n        flex-direction: column;\n        padding: pxToRem(20) 0;\n        width: 100%;\n        gap: 0.5rem !important;\n        bottom: 0rem !important;\n      }\n      &-action {\n        margin-inline-start: 3rem !important;\n        @media only screen and (max-width: 768px) {\n          width: 100%;\n          justify-content: center !important;\n          padding: 0 1rem;\n          margin-inline-start: 0rem !important;\n        }\n      }\n      &__btn {\n        @extend .body-medium;\n        color: $accent-color;\n        background: $white-color !important;\n        padding: 0.5rem;\n\n        &:hover {\n          background: $scrollbar-color !important;\n          border-radius: pxToRem(8);\n          color: $primary-color !important;\n        }\n      }\n\n      &__toggle-btns {\n        background-color: transparent !important;\n        border: none !important;\n        color: $white-color;\n\n        &__dots {\n          color: $accent-color;\n          pointer-events: none;\n          @extend .body-small;\n        }\n\n        &__btn {\n          border-radius: pxToRem(8);\n          height: pxToRem(32);\n          width: pxToRem(32);\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          margin: 0 0.5rem;\n          @extend .body-small;\n          color: $accent-color;\n\n          &:hover {\n            background-color: white !important;\n            --mat-standard-button-toggle-hover-state-layer-opacity: 0 !important;\n            --mat-standard-button-toggle-focus-state-layer-opacity: 0 !important;\n          }\n\n          &__active {\n            background-color: $secondary-color !important;\n            color: $white-color !important;\n            padding: 0 !important;\n\n            &:hover {\n              background-color: $secondary-color !important;\n            }\n          }\n        }\n\n        .mat-button-toggle-appearance-standard .mat-button-toggle-label-content {\n          padding: 0 !important;\n        }\n      }\n\n      &-count {\n        color: $icons-color;\n        word-spacing: 0.1rem;\n        font-size: pxToRem(16);\n        line-height: pxToRem(32);\n        font-weight: 400;\n        @media only screen and (max-width: 768px) {\n          display: none !important;\n        }\n      }\n    }\n\n    .disabled {\n      pointer-events: none;\n      color: $icons-color !important;\n    }\n  }\n}\n// custom pane\n::ng-deep {\n  .tooltiptext {\n    background-color: $snackbar-bg !important;\n    color: $white-color !important;\n    text-align: center;\n    border-radius: pxToRem(8);\n    padding: pxToRem(8);\n    width: 100%;\n    // max-width: max-content !important;\n    @extend .body-medium;\n    &.tooltipSearch {\n      top: -1rem;\n    }\n  }\n\n  .tooltiptext::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: $snackbar-bg transparent transparent transparent;\n  }\n\n  .mat-mdc-tooltip .mdc-tooltip__surface {\n    @extend .body-medium;\n    background-color: $snackbar-bg !important;\n    color: $white-color !important;\n    padding: 0 !important;\n    text-align: center !important;\n    max-width: pxToRem(500);\n    max-height: pxToRem(300);\n    overflow-y: auto;\n    scrollbar-color: $white-color transparent !important;\n    padding: 0 1rem !important;\n    &::-webkit-scrollbar {\n      width: 0.2rem;\n    }\n    &::-webkit-scrollbar-track {\n      background: $icons-color !important;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: $white-color !important;\n    }\n  }\n\n  .cdk-overlay-pane {\n    &.selectCustomClass {\n      width: auto !important;\n      &.selectLevelClass,\n      &.selectFilterClass {\n        width: 100% !important;\n      }\n    }\n\n    .selectCustomClass {\n      border-radius: pxToRem(8) !important;\n      background: $background-light !important;\n      box-shadow: $box-shadow !important;\n      padding: 0 !important;\n      direction: rtl !important;\n\n      .mat-mdc-option,\n      mat-mdc-option {\n        border-bottom: 0.25px solid $lines-color;\n        direction: rtl !important;\n\n        .mdc-list-item__primary-text {\n          white-space: nowrap;\n        }\n\n        .mat-pseudo-checkbox-minimal,\n        mat-pseudo-checkbox {\n          margin-left: unset !important;\n          margin-inline-end: 1rem;\n          display: none !important;\n        }\n\n        &:hover {\n          background-color: transparent !important;\n        }\n\n        &:last-child,\n        &:first-child {\n          border: none !important;\n        }\n\n        &:first-child {\n          display: none !important;\n        }\n\n        &.canCloseFlag,\n        &.canActionFlag {\n          pointer-events: none;\n          opacity: 0.5;\n        }\n      }\n\n      .mat-mdc-option,\n      mat-mdc-option {\n        @extend .body-small;\n      }\n\n      .mat-mdc-option.mat-mdc-active,\n      .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled),\n      .mat-mdc-option.mat-mdc-selected:not(.mat-mdc-option-disabled),\n      .mdc-list-item--selected.mdc-list-item--disabled {\n        background-color: transparent !important;\n      }\n\n      .mat-mdc-option .mat-mdc-option-ripple {\n        display: none;\n      }\n\n      .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text {\n        color: unset;\n      }\n\n      &.selectLevelClass {\n        .mat-mdc-option,\n        mat-mdc-option {\n          border-bottom: 0.25px solid $lines-color !important;\n          &-multiple {\n            flex-direction: row-reverse;\n          }\n          .mdc-list-item__primary-text {\n            color: $text-color !important;\n            @extend .body-small;\n            line-height: unset !important;\n            background-color: transparent !important;\n          }\n\n          // margin: 0 2.5rem;\n\n          &:first-child {\n            display: flex !important;\n            border-bottom: 0.25px solid $lines-color !important;\n          }\n\n          &:last-child {\n            border: none !important;\n          }\n        }\n        .mat-mdc-option.mat-mdc-active,\n        .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled),\n        .mat-mdc-option.mat-mdc-selected:not(.mat-mdc-option-disabled) {\n          margin: 0 !important;\n          padding: 0 1.5rem !important;\n          background-color: $shapes-color !important;\n        }\n      }\n\n      &.selectClass {\n        .mat-mdc-option,\n        mat-mdc-option {\n          .mat-pseudo-checkbox-minimal,\n          mat-pseudo-checkbox {\n            &::after {\n              color: $primary-color !important;\n            }\n            display: block !important;\n            background: $white-color !important;\n            border: 1.5px solid $primary-color !important;\n          }\n        }\n      }\n    }\n\n    .phoneClass {\n      width: 40% !important;\n    }\n\n    .matMenuClass {\n      .mat-mdc-menu-content {\n        padding: 0 !important;\n      }\n      .mat-mdc-menu-item {\n        padding: 0 pxToRem(16) !important;\n        border: none !important;\n        border-bottom: 0.25px solid $lines-color !important;\n        display: flex;\n        justify-content: center !important;\n        width: 100% !important;\n        background-color: transparent !important;\n        border-radius: 0 !important;\n        direction: rtl;\n        mat-icon {\n          order: 2;\n          color: $secondary-color !important;\n        }\n        &:last-child {\n          border: none;\n        }\n      }\n      .mat-mdc-menu-item:not([disabled]):hover {\n        background-color: transparent !important;\n      }\n      .mat-mdc-menu-ripple {\n        display: none;\n      }\n      .mat-mdc-menu-item-text {\n        @extend .body-small;\n        color: $accent-color !important;\n      }\n    }\n  }\n\n  .mat-mdc-form-field-icon-suffix .mat-icon {\n    padding: 0 !important;\n  }\n}\n\n.filter-page {\n  position: relative;\n  &_main {\n    grid-template-columns: 4fr 1fr;\n    margin: 0 auto;\n    width: 100%;\n    padding: 0.5rem 3rem;\n    @media only screen and (max-width: 768px) {\n      padding: 0.5rem 1rem;\n    }\n    // position: absolute;\n    &_header {\n      display: flex;\n      align-items: center;\n      // margin-bottom: 1rem;\n      @media only screen and (max-width: 768px) {\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: flex-start;\n        gap: 0.5rem;\n      }\n\n      h4 {\n        font-size: 1.5rem;\n        font-weight: bold;\n        color: $accent-color;\n        margin-left: 1rem;\n      }\n\n      &_badges {\n        display: flex;\n        justify-content: flex-start;\n        flex-wrap: wrap;\n        gap: 1.5rem;\n        @media only screen and (max-width: 768px) {\n          gap: 0;\n        }\n        .badge {\n          height: 3rem;\n          width: fit-content;\n          border-radius: 1.5rem;\n          box-shadow: 0px 2px 6px #0000001a;\n          min-width: 14rem;\n          display: grid;\n          place-items: center;\n          font-size: 1.25rem;\n          position: relative;\n          color: $accent-color;\n          padding: 0 2rem;\n          margin: 0 1rem;\n          background: white;\n          @media only screen and (max-width: 768px) {\n            padding: 0 0.5rem;\n            font-size: 1rem;\n            min-width: 10rem;\n          }\n\n          .close-btn {\n            position: absolute !important;\n            top: -0.5rem;\n            left: -0.5rem;\n            font-size: 1rem;\n            height: 1.25rem;\n            width: 1.25rem;\n            background-color: $accent-color;\n\n            border-radius: 50%;\n            color: white;\n            cursor: pointer;\n            @extend .d-flex-center;\n\n            &:hover {\n              background-color: $secondary-color;\n            }\n          }\n        }\n      }\n    }\n    &_content {\n      width: 73%;\n    }\n  }\n\n  &.filterBody {\n    app-data-table .content-page-header {\n      margin-bottom: 0.5rem !important;\n      .k-ng-filter {\n        top: 0rem;\n      }\n    }\n  }\n}\n\n.meetings {\n  app-data-table {\n    .content-page-header .contents {\n      .k-ng-filter {\n        position: absolute;\n        top: 4rem;\n        left: 5rem;\n        right: unset;\n        .mat-mdc-form-field {\n          width: 22.2rem;\n        }\n        @media only screen and (max-width: 1400px) {\n          left: 3.5rem;\n        }\n        @media only screen and (max-width: 768px) {\n          position: relative !important;\n          top: unset;\n          left: unset;\n          right: unset;\n        }\n      }\n    }\n  }\n}\n\nhtml {\n  &[dir=\"ltr\"] {\n    app-data-table {\n      table {\n        .btn-show.show-data {\n          &::after {\n            transform: unset !important;\n          }\n        }\n      }\n\n      .content-page-header .contents {\n        .k-ng-search .search-btn {\n          right: -8rem;\n          bottom: 1px !important;\n          left: unset !important;\n        }\n        .header-actions .btnActions-resp {\n          .mdc-button {\n            left: unset !important;\n            right: 0 !important;\n          }\n        }\n        .k-ng-filter {\n          left: unset;\n          right: 5rem;\n          .mat-mdc-form-field {\n            width: 20.5rem;\n          }\n          @media only screen and (max-width: 1400px) {\n            right: 5rem;\n            left: unset;\n          }\n        }\n      }\n\n      app-pagination .pagination__btn {\n        .arrow {\n          transform: rotate(180deg) !important;\n          &.arrow_left {\n            transform: rotate(0deg) !important;\n          }\n        }\n      }\n    }\n    .cdk-overlay-pane {\n      direction: rtl;\n      .selectCustomClass {\n        direction: ltr !important;\n        .mat-mdc-option,\n        mat-mdc-option {\n          direction: ltr !important;\n          padding: 0 1.5rem !important;\n        }\n      }\n      .phoneClass {\n        direction: ltr;\n      }\n    }\n    .meetings {\n      app-data-table {\n        .content-page-header .contents {\n          .k-ng-filter {\n            left: unset;\n            right: 5rem;\n            .mat-mdc-form-field {\n              width: 20.5rem;\n            }\n            @media only screen and (max-width: 1400px) {\n              right: 5rem;\n              left: unset;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","@import \"variables\";\n@import \"function\";\n@import \"theme\";\n@import \"mat-theme\";\n@import \"datatable\";\n// admin-modern.scss intentionally NOT imported — user prefers the\n// existing k-ng-datatable grid/theme pattern. File kept in the repo\n// in case we want to opt in per-page later (class-scoped).\n\n// @import \"primeng/resources/themes/lara-light-blue/theme.css\";\n// @import \"primeng/resources/primeng.css\";\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  outline: none;\n  // text-decoration: none !important;\n  scrollbar-width: thin !important;\n  scrollbar-color: $secondary-color-opacity-5 $scroll-color !important;\n\n  @media only screen and (max-width: 768px) {\n    scrollbar-color: $secondary-color-opacity-5 $scroll-color !important;\n  }\n}\n\n::-webkit-scrollbar {\n  width: 0.5rem;\n  height: 0.5rem;\n}\n\n::-webkit-scrollbar-track {\n  background: $scroll-color;\n  border-radius: 2rem;\n}\n\n::-webkit-scrollbar-thumb {\n  background: $secondary-color-opacity-5;\n  border-radius: 2rem;\n  transition: width 0.3s ease;\n  -webkit-transition: width 0.3s ease;\n  -moz-transition: width 0.3s ease;\n  -ms-transition: width 0.3s ease;\n  -o-transition: width 0.3s ease;\n  -webkit-border-radius: 2rem;\n  -moz-border-radius: 2rem;\n  -ms-border-radius: 2rem;\n  -o-border-radius: 2rem;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: $secondary-color-opacity-5;\n}\n\n@media only screen and (max-width: 768px) {\n  ::-webkit-scrollbar {\n    width: 0.3rem;\n    height: 0.3rem;\n  }\n\n  ::-webkit-scrollbar-track {\n    background: secondary-color-opacity-5;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: secondary-color-opacity-5;\n  }\n}\n\nhtml,\nbody {\n  height: 100%;\n  overflow: hidden;\n}\n\nhtml {\n  &[dir=\"rtl\"] {\n    direction: rtl !important;\n\n    .mat-dialog-container,\n    .mat-calendar-header,\n    .mdc-dialog__container {\n      direction: rtl !important;\n    }\n  }\n\n  &[dir=\"ltr\"] {\n    direction: ltr !important;\n\n    .mat-dialog-container,\n    .mat-calendar-header,\n    .mdc-dialog__container {\n      direction: ltr !important;\n    }\n  }\n}\n\nimg {\n  width: 100%;\n  display: block;\n}\n\na {\n  text-decoration: none;\n  cursor: pointer;\n}\n\na,\nh1,\nh2,\nh3,\nspan,\ntable,\ntd,\ntr,\nbutton,\ninput,\nli,\nul,\nlabel,\ndiv,\npre {\n  font-family: $font-family-ar;\n}\n\nul {\n  list-style: none;\n}\n\n// shared\n\n.display-large {\n  @include textCustom(64, 94, 700);\n}\n\n.display-large-2 {\n  @include textCustom(40, 68, 700);\n}\n\n.display-semiBold {\n  @include textCustom(48, 72, 600);\n}\n\n.display-semiBold-2 {\n  @include textCustom(40, 68, 600);\n}\n\n.display-medium {\n  @include textCustom(48, 72, 700);\n}\n\n.display-medium-2 {\n  @include textCustom(40, 68, 500);\n}\n\n.display-small {\n  @include textCustom(48, 72, 500);\n}\n\n.display-small {\n  @include textCustom(40, 64, 400);\n}\n\n.headline-large {\n  @include textCustom(36, 60, 700);\n}\n\n.headline-large-2 {\n  @include textCustom(32, 56, 700);\n}\n\n.headline-semiBold {\n  @include textCustom(36, 60, 600);\n}\n\n.headline-semiBold-2 {\n  @include textCustom(32, 56, 600);\n}\n\n.headline-medium {\n  @include textCustom(36, 60, 500);\n}\n\n.headline-medium-2 {\n  @include textCustom(32, 56, 500);\n}\n\n.headline-small {\n  @include textCustom(36, 60, 400);\n}\n\n.headline-small-2 {\n  @include textCustom(30, 56, 400);\n}\n\n.title-large {\n  @include textCustom(28, 56, 700);\n}\n\n.title-large-2 {\n  @include textCustom(24, 48, 700);\n}\n\n.title-large-3 {\n  @include textCustom(22, 40, 700);\n}\n\n.title-semiBold {\n  @include textCustom(28, 56, 600);\n}\n\n.title-semiBold-2 {\n  @include textCustom(24, 48, 600);\n}\n\n.title-semiBold-3 {\n  @include textCustom(22, 40, 600);\n}\n\n.title-medium {\n  @include textCustom(28, 56, 500);\n}\n\n.title-medium-2 {\n  @include textCustom(24, 48, 500);\n}\n\n.title-medium-3 {\n  @include textCustom(22, 40, 500);\n}\n\n.title-small {\n  @include textCustom(28, 56, 400);\n}\n\n.title-small-2 {\n  @include textCustom(24, 48, 400);\n}\n\n.title-small-3 {\n  @include textCustom(22, 40, 400);\n}\n\n.label-large {\n  @include textCustom(20, 38, 700);\n}\n\n.label-large-2 {\n  @include textCustom(18, 36, 700);\n}\n\n.label-semiBold {\n  @include textCustom(20, 38, 600);\n}\n\n.label-semiBold-2 {\n  @include textCustom(18, 36, 600);\n}\n\n.label-medium {\n  @include textCustom(20, 38, 500);\n}\n\n.label-medium-2 {\n  @include textCustom(18, 36, 500);\n}\n\n.label-small {\n  @include textCustom(20, 38, 400);\n}\n\n.label-small-2 {\n  @include textCustom(18, 36, 400);\n}\n\n.body-large {\n  @include textCustom(16, 32, 700);\n}\n\n.body-large-2 {\n  @include textCustom(14, 26, 700);\n}\n\n.body-large-3 {\n  @include textCustom(12, 24, 700);\n}\n\n.body-semiBold {\n  @include textCustom(16, 32, 600);\n}\n\n.body-semiBold-2 {\n  @include textCustom(14, 26, 600);\n}\n\n.body-semiBold-3 {\n  @include textCustom(12, 24, 600);\n}\n\n.body-medium-lg {\n  @include textCustom(20, 32, 500);\n}\n\n.body-medium {\n  @include textCustom(16, 32, 500);\n}\n\n.body-medium-2 {\n  @include textCustom(14, 26, 500);\n}\n\n.body-medium-3 {\n  @include textCustom(12, 24, 500);\n}\n\n.body-small-lg {\n  @include textCustom(20, 36, 400);\n}\n\n.body-small {\n  @include textCustom(16, 32, 400);\n}\n\n.body-small-2 {\n  @include textCustom(14, 26, 400);\n}\n\n.body-small-3 {\n  @include textCustom(12, 24, 400);\n}\n\n.body-small-4 {\n  @include textCustom(10, 24, 400);\n}\n\n.d-flex {\n  display: flex !important;\n  align-items: center;\n}\n\n.d-flex-center {\n  @extend .d-flex;\n  justify-content: center;\n}\n\n.d-flex-between {\n  @extend .d-flex;\n  justify-content: space-between;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  font-weight: normal;\n  margin-top: pxToRem(32);\n  text-align: start;\n\n  input {\n    @extend .label-medium-2;\n    color: $text-color;\n  }\n\n  &__label {\n    @extend .body-small-lg;\n    color: $text-color;\n\n    &__required {\n      @extend .body-small;\n      color: $alert-color;\n      font-size: 2rem;\n    }\n  }\n\n  .error {\n    color: $alert-color;\n  }\n}\n\n.btn {\n  height: pxToRem(52) !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: pxToRem(10);\n  width: 100%;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease-out;\n\n  &:hover {\n    transform: translateY(-1px);\n  }\n  &:active {\n    transform: translateY(0);\n  }\n}\n\n.btn-secondary {\n  background: $secondary-color;\n  box-shadow: 0 2px 8px rgba(13, 49, 77, 0.2);\n  color: $white-color !important;\n  @extend .label-large;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(13, 49, 77, 0.3);\n  }\n}\n\n.btn-primary {\n  background-color: $primary-color !important;\n  border-radius: pxToRem(10) !important;\n  padding: pxToRem(8) !important;\n  @extend .d-flex-between;\n  color: $white-color !important;\n  @extend .label-medium;\n  width: auto;\n  gap: pxToRem(8);\n  direction: ltr;\n  box-shadow: 0 2px 8px rgba(13, 155, 132, 0.2);\n\n  mat-icon {\n    font-size: pxToRem(20) !important;\n    height: pxToRem(20) !important;\n    width: pxToRem(20) !important;\n    margin: 0 !important;\n    @extend .d-flex-center;\n  }\n}\n\n.btn-primary-outline {\n  @extend .label-medium;\n  color: $primary-color !important;\n  border: 1px solid $primary-color !important;\n  background-color: transparent !important;\n  gap: pxToRem(8);\n  white-space: nowrap;\n  justify-content: center !important;\n\n  &::after {\n    font-family: \"Material Symbols Outlined\";\n    content: \"download\";\n    position: relative;\n    display: block;\n    font-size: pxToRem(22);\n    font-weight: 400;\n    color: $primary-color;\n  }\n}\n\n.btn-cancel {\n  @extend .label-medium;\n  color: $text-color !important;\n  background-color: transparent !important;\n}\n\n.gap-1 {\n  gap: pxToRem(24);\n}\n\n.disabled {\n  pointer-events: none;\n  color: $icons-color !important;\n  opacity: 0.5;\n}\n\n.disabled-header {\n  pointer-events: none;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.inquiry_status {\n  @extend .body-medium-2;\n  @extend .d-flex-center;\n  border-radius: pxToRem(8) !important;\n  padding: pxToRem(3) pxToRem(7);\n  white-space: nowrap;\n  width: 6rem;\n  margin: auto;\n  border: 0.5px solid;\n\n  // width: 60%;\n  // padding: pxToRem(1.8) pxToRem(12);\n  &[data-value=\"active\"] {\n    border-color: $secondary-color;\n    color: $secondary-color;\n    background: rgba(7, 178, 126, 0.1);\n  }\n\n  &[data-value=\"initiated\"] {\n    border-color: #4053ff;\n    color: #4053ff;\n    background: #eaf0ff;\n  }\n\n  &[data-value=\"closed\"] {\n    border-color: $chat-color;\n    color: $chat-color;\n    background: #dfefef;\n  }\n\n  &[data-value=\"escalated_to_admin\"] {\n    border-color: #df9312;\n    color: #df9312;\n    background: rgba(245, 158, 11, 0.2);\n    padding: pxToRem(3) pxToRem(10) !important;\n  }\n\n  &[data-value=\"reported\"] {\n    border-color: $alert-color;\n    color: $alert-color;\n    background: rgba(186, 57, 57, 0.2);\n  }\n\n  &[data-value=\"rejected\"] {\n    border-color: #e54141;\n    color: #e54141;\n    background: rgba(186, 57, 57, 0.2);\n  }\n\n  &[data-value=\"delayed\"] {\n    border-color: $snackbar-bg;\n    color: $snackbar-bg;\n    background: #ccc;\n  }\n}\n\n.p-dropdown.p-component {\n  min-width: pxToRem(210) !important;\n}\n\n.calendarSelect input {\n  text-align: center;\n}\n\n.p-dropdown:not(.p-disabled):hover,\n.p-dropdown:not(.p-disabled).p-focus,\n.p-inputtext:enabled:hover,\n.p-inputtext:enabled:focus {\n  border-color: #07b27e !important;\n}\n\n.p-dropdown:not(.p-disabled).p-focus,\n.p-inputtext:enabled:focus {\n  box-shadow: none !important;\n}\n\n.chart {\n  div {\n    display: flex;\n    justify-content: center;\n\n    canvas {\n      min-width: 300px;\n      max-width: 320px;\n      min-height: 300px;\n      max-height: 320px;\n      width: 320px !important;\n      height: 320px !important;\n    }\n\n    @media only screen and (max-width: 1250px) {\n      canvas {\n        width: 55% !important;\n      }\n    }\n\n    @media only screen and (max-width: 480px) {\n      canvas {\n        width: 100% !important;\n      }\n    }\n  }\n}\n\n.payment-status {\n  margin-right: pxToRem(32);\n  @extend .body-medium-2;\n  @extend .d-flex-center;\n  border-radius: pxToRem(8) !important;\n  padding: pxToRem(3) pxToRem(15) !important;\n  min-width: 6rem;\n  white-space: nowrap;\n  width: min-content;\n  margin: auto;\n  border: 0.5px solid;\n  pointer-events: none;\n\n  &[data-value=\"paid\"],\n  &[data-value=\"started\"],\n  &[data-value=\"courses-status.in_review\"],\n  &[data-value=\"underreview\"] {\n    border-color: $primary-color;\n    color: $primary-color;\n    background: rgba(7, 178, 126, 0.1);\n  }\n\n  &[data-value=\"unpaid\"],\n  &[data-value=\"courses-status.rejected\"],\n  &[data-value=\"ended\"],\n  &[data-value=\"rejected\"],\n  &[data-value=\"closed_by_admin\"],\n  &[data-value=\"failed\"] {\n    border-color: #e54141;\n    color: #e54141;\n    background: rgba(186, 57, 57, 0.2);\n  }\n\n  &[data-value=\"open\"],\n  &[data-value=\"initiated\"],\n  &[data-value=\"courses-status.enabled\"],\n  &[data-value=\"approved\"],\n  &[data-value=\"completed\"] {\n    border-color: green;\n    color: $white-color;\n    background: green;\n  }\n\n  &[data-value=\"canceled\"],\n  &[data-value=\"canceled_by_teacher\"],\n  &[data-value=\"canceled_by_student\"],\n  &[data-value=\"courses-status.disabled\"],\n  &[data-value=\"courses-status.closed_by_admin\"],\n  &[data-value=\"courses-status.closed_by_user\"],\n  &[data-value=\"cancelled\"] {\n    border-color: #ff9800;\n    color: $accent-color;\n    background: #ff980073;\n  }\n\n  &[data-value=\"processing\"],\n  &[data-value=\"courses-status.paused\"] {\n    border-color: yellow;\n    color: $accent-color;\n    background: rgba(255, 255, 0, 0.4);\n  }\n}\n\n.account-status {\n  font-size: 1px;\n  color: transparent;\n  &[data-value=\"enabled\"] {\n    &::after {\n      content: \"\\2713\";\n      display: inline-block;\n      font-size: 2rem;\n      font-weight: 700;\n      color: green;\n      margin-top: 0.5rem;\n    }\n  }\n  &[data-value=\"disabled\"] {\n    &::after {\n      display: inline-block;\n      content: \"\\2715\";\n      font-size: 2rem;\n      font-weight: 700;\n      color: #e54141;\n      margin-top: 0.5rem;\n    }\n  }\n}\n\n.res-status {\n  @extend .payment-status;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
